/**
 * Auto-generated school holidays from OpenHolidays API Data (Git Submodule)
 * DO NOT EDIT MANUALLY - Run: node scripts/fetch-school-holidays.mjs
 * Submodule: a42b397 (2026-04-13)
 */

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ad = {
  SH: [
    {
      name: "Vacances de Nadal",
      2019: [12,23,1,6],
      2020: [12,23,1,6],
      2021: [12,23,1,7],
      2022: [12,23,1,6],
      2023: [12,25,1,5],
      2024: [12,23,1,6],
      2025: [12,22,1,6],
      2026: [12,23,1,6],
    },
    {
      name: "Vacances de Carnaval",
      2020: [2,24,2,28],
      2021: [2,15,2,18],
      2022: [2,28,3,4],
      2023: [2,20,2,24],
      2024: [2,12,2,16],
      2025: [2,24,3,3],
      2026: [2,16,2,20],
      2027: [2,8,2,12],
    },
    {
      name: "Vacances de Pasqua",
      2020: [4,6,4,17],
      2021: [3,29,4,6],
      2022: [4,11,4,22],
      2023: [4,3,4,14],
      2024: [3,28,4,5],
      2025: [4,17,5,2],
      2026: [3,30,4,10],
      2027: [3,22,4,2],
    },
    {
      name: "Vacances de Pentecosta",
      2020: [5,25,6,1],
      2021: [5,24,5,28],
      2022: [6,2,6,6],
      2023: [5,29,5,30],
      2024: [5,20,5,24],
      2025: [6,9,6,9],
      2026: [5,25,5,29],
      2027: [5,17,5,21],
    },
    {
      name: "Vacances d'estiu",
      2020: [7,2,9,8],
      2021: [7,3,9,8],
      2022: [7,2,9,8],
      2023: [7,1,9,10],
      2024: [6,29,9,8],
      2025: [7,1,9,8],
      2026: [7,4,9,8],
    },
    {
      name: "Vacances de Tots Sants",
      2020: [10,26,10,30],
      2021: [11,1,11,1],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
      2026: [10,26,10,30],
    },
    {
      name: "Final de classe",
      2027: [7,2,7,2],
    },
  ]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const al = {
  SH: [
    {
      name: "Pushimet dimërore",
      2019: [12,21,1,5],
      2020: [12,24,1,4],
      2021: [12,24,1,4],
      2022: [12,26,1,4],
      2023: [12,26,1,5],
      2024: [12,23,1,3],
      2025: [12,22,1,2],
    },
    {
      name: "Pushimet verore",
      2020: [6,13,9,13],
      2021: [6,9,9,26],
      2022: [6,18,9,11],
      2023: [6,15,9,10],
      2024: [6,14,9,8],
      2025: [6,13,9,8],
    },
    {
      name: "Pushimet e pranveres",
      2023: [4,3,4,9],
      2024: [4,1,4,5],
      2025: [3,31,4,4],
      2026: [3,30,4,3],
    },
    {
      name: "Fundi i klasës",
      2026: [6,13,6,13],
    },
  ]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ar = {
  PH: [{"name":"Año Nuevo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-48},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Día Nacional de la Memoria por la Verdad y la Justicia","fixed_date":[3,24]},{"name":"Viernes Santo","variable_date":"easter","offset":-2},{"name":"Día del Veterano y de los Caídos en la Guerra de Malvinas","fixed_date":[4,2]},{"name":"Día del Trabajador","fixed_date":[5,1]},{"name":"Día de la Revolución de Mayo","fixed_date":[5,25]},{"name":"Paso a la Inmortalidad del General Don Martín Miguel de Güemes","fixed_date":[6,17],"shift_rule":"if tuesday,wednesday then previous monday if thursday,friday then next monday"},{"name":"Paso a la Inmortalidad del General D. Manuel Belgrano","fixed_date":[6,20]},{"name":"Día de la Independencia","fixed_date":[7,9]},{"name":"Día no laborable con fines turísticos","fixed_date":[7,10],"year":2026},{"name":"Paso a la Inmortalidad del General José de San Martín","fixed_date":[8,17],"shift_rule":"if tuesday,wednesday then previous monday if thursday,friday then next monday"},{"name":"Día del Respeto a la Diversidad Cultural","fixed_date":[10,12],"shift_rule":"if tuesday,wednesday then previous monday if thursday,friday then next monday"},{"name":"Día de la Soberanía Nacional","fixed_date":[11,20],"shift_rule":"if tuesday,wednesday then previous monday if thursday,friday then next monday"},{"name":"Día no laborable con fines turísticos","fixed_date":[12,7],"year":2026},{"name":"Inmaculada Concepción de María","fixed_date":[12,8]},{"name":"Navidad","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-34.60377&lon=-58.38159&zoom=16&addressdetails=1&accept-language=es"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const at = {
  PH: [{"name":"Neujahr","fixed_date":[1,1]},{"name":"Heilige Drei Könige","fixed_date":[1,6]},{"name":"Ostermontag","variable_date":"easter","offset":1},{"name":"Staatsfeiertag","fixed_date":[5,1]},{"name":"Christi Himmelfahrt","variable_date":"easter","offset":39},{"name":"Pfingstmontag","variable_date":"easter","offset":50},{"name":"Fronleichnam","variable_date":"easter","offset":60},{"name":"Mariä Himmelfahrt","fixed_date":[8,15]},{"name":"Nationalfeiertag","fixed_date":[10,26]},{"name":"Allerheiligen","fixed_date":[11,1]},{"name":"Mariä Empfängnis","fixed_date":[12,8]},{"name":"Christtag","fixed_date":[12,25]},{"name":"Stefanitag","fixed_date":[12,26]}],
  SH: [
    {
      name: "Osterferien",
      2017: [4,8,4,18],
      2018: [3,24,4,3],
      2019: [4,13,4,23],
      2020: [4,4,4,14],
      2021: [3,27,4,5],
      2022: [4,9,4,18],
      2023: [4,1,4,10],
      2024: [3,23,4,1],
      2025: [4,12,4,21],
      2026: [3,28,4,6],
      2027: [3,20,3,29],
      2028: [4,8,4,17],
    },
    {
      name: "Pfingstferien",
      2017: [6,3,6,6],
      2018: [5,19,5,22],
      2019: [6,8,6,11],
      2020: [5,30,6,2],
      2021: [5,22,5,24],
      2022: [6,4,6,6],
      2023: [5,27,5,29],
      2024: [5,18,5,20],
      2025: [6,7,6,9],
      2026: [5,23,5,25],
      2027: [5,15,5,17],
      2028: [6,3,6,5],
    },
    {
      name: "Herbstferien",
      2020: [10,27,10,31],
      2021: [10,27,10,31],
      2022: [10,27,10,31],
      2023: [10,27,10,31],
      2024: [10,27,10,31],
      2025: [10,27,10,31],
      2026: [10,27,10,31],
      2027: [10,27,10,31],
      2028: [10,27,10,31],
    },
    {
      name: "Weihnachtsferien",
      2016: [12,24,1,7],
      2017: [12,24,1,6],
      2018: [12,24,1,6],
      2019: [12,23,1,6],
      2020: [12,24,1,6],
      2021: [12,24,1,6],
      2022: [12,24,1,6],
      2023: [12,23,1,6],
      2024: [12,24,1,6],
      2025: [12,24,1,6],
      2026: [12,24,1,6],
      2027: [12,24,1,6],
      2028: [12,24,1,6],
    },
    {
      name: "Allerseelen",
      2020: [11,2,11,2],
      2021: [11,2,11,2],
      2022: [11,2,11,2],
      2023: [11,2,11,2],
      2024: [11,2,11,2],
      2025: [11,2,11,2],
      2026: [11,2,11,2],
      2027: [11,2,11,2],
      2028: [11,2,11,2],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lon=16.3725042&lat=48.2083537&zoom=18&addressdetails=1&accept-language=de,en",
  "Burgenland": {
    "_state_code": "bl",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Martin",
        2020: [11,11,11,11],
        2021: [11,11,11,11],
        2022: [11,11,11,11],
        2023: [11,11,11,11],
        2024: [11,11,11,11],
        2025: [11,11,11,11],
        2027: [11,11,11,11],
        2028: [11,11,11,11],
      },
    ]
  },
  "Kärnten": {
    "_state_code": "kä",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Niederösterreich": {
    "_state_code": "nö",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [2,7,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [1,30,2,6],
        2028: [2,5,2,12],
      },
      {
        name: "St. Leopold",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
        2027: [11,15,11,15],
        2028: [11,15,11,15],
      },
    ]
  },
  "Oberösterreich": {
    "_state_code": "oö",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,17,2,22],
        2021: [2,8,2,13],
        2022: [2,21,2,26],
        2023: [2,20,2,25],
        2024: [2,19,2,24],
        2025: [2,17,2,22],
        2026: [2,16,2,21],
        2027: [2,15,2,20],
        2028: [2,21,2,26],
      },
      {
        name: "St. Florian",
        2020: [5,4,5,4],
        2021: [5,4,5,4],
        2022: [5,4,5,4],
        2023: [5,4,5,4],
        2024: [5,4,5,4],
        2025: [5,4,5,4],
        2026: [5,4,5,4],
        2027: [5,4,5,4],
        2028: [5,4,5,4],
      },
    ]
  },
  "Salzburg": {
    "_state_code": "sb",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Rupert",
        2020: [9,24,9,24],
        2021: [9,24,9,24],
        2022: [9,24,9,24],
        2023: [9,24,9,24],
        2024: [9,24,9,24],
        2025: [9,24,9,24],
        2027: [9,24,9,24],
        2028: [9,24,9,24],
      },
    ]
  },
  "Steiermark": {
    "_state_code": "sm",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,17,2,22],
        2021: [2,8,2,13],
        2022: [2,21,2,26],
        2023: [2,20,2,25],
        2024: [2,19,2,24],
        2025: [2,17,2,22],
        2026: [2,16,2,21],
        2027: [2,15,2,20],
        2028: [2,21,2,26],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Tirol": {
    "_state_code": "ti",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
      {
        name: "schulfrei",
        2025: [6,20,6,20],
      },
    ]
  },
  "Vorarlberg": {
    "_state_code": "va",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,5,2,10],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Wien": {
    "_state_code": "wi",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [2,7,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [1,30,2,6],
        2028: [2,5,2,12],
      },
      {
        name: "St. Leopold",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
        2027: [11,15,11,15],
        2028: [11,15,11,15],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const au = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-35.2809&lon=149.1300&zoom=16&addressdetails=1&accept-language=en",
  "Australian Capital Territory": {
    "_state_code": "act",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-35.2809&lon=149.1300&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Canberra Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Reconciliation Day","variable_date":"lastMayMonday"},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "New South Wales": {
    "_state_code": "nsw",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-33.8688&lon=151.2093&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"substitute_rule":"if saturday,sunday then next monday"},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "Northern Territory": {
    "_state_code": "nt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-12.4634&lon=130.8456&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"shift_rule":"if sunday then next monday"},{"name":"May Day","variable_date":"firstMayMonday"},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Picnic Day","variable_date":"firstAugustMonday"},{"name":"Christmas Day","fixed_date":[12,25],"shift_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "Queensland": {
    "_state_code": "qld",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-27.4698&lon=153.0251&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"shift_rule":"if sunday then next monday"},{"name":"Labour Day","variable_date":"firstMayMonday"},{"name":"King's Birthday","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "South Australia": {
    "_state_code": "sa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-34.9285&lon=138.6007&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Adelaide Cup Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25],"shift_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Proclamation Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "Tasmania": {
    "_state_code": "tas",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-42.8821&lon=147.3272&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"shift_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Eight Hours Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"shift_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "Victoria": {
    "_state_code": "vic",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-37.8136&lon=144.9631&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Labour Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"King's Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"AFL Grand Final Friday","variable_date":"lastSeptemberFriday"},{"name":"Melbourne Cup","variable_date":"firstNovemberTuesday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  },
  "Western Australia": {
    "_state_code": "wa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-31.9505&lon=115.8605&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Labour Day","variable_date":"firstMarchMonday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Western Australia Day","variable_date":"firstJuneMonday"},{"name":"King's Birthday","variable_date":"lastSeptemberMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const be = {
  PH: [{"name":"Nieuwjaar - Nouvel An","fixed_date":[1,1]},{"name":"Paasmaandag - Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Dag van de Arbeid - Fête du travail","fixed_date":[5,1]},{"name":"Hemelvaartsdag - Ascension","variable_date":"easter","offset":39},{"name":"Pinkstermaandag - Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Nationale feestdag - Fête nationale","fixed_date":[7,21]},{"name":"Tenhemelopneming - Assomption","fixed_date":[8,15]},{"name":"Allerheiligen - Toussaint","fixed_date":[11,1]},{"name":"Wapenstilstand - Armistice","fixed_date":[11,11]},{"name":"Kerstmis - Noël","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Belgium&zoom=18&addressdetails=1&limit=1&accept-language=nl,fr,de,en",
  "DE": {
    "_state_code": "de",
    SH: [
      {
        name: "Osterferien",
        2020: [4,6,4,17],
        2021: [4,6,4,16],
        2022: [4,4,4,15],
        2023: [4,3,4,16],
        2024: [4,1,4,13],
        2025: [4,21,5,3],
        2026: [4,6,4,18],
      },
      {
        name: "Sommerferien",
        2020: [7,1,8,30],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [6,29,8,31],
        2025: [7,1,8,31],
        2026: [7,1,8,31],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,7],
        2022: [12,26,1,8],
        2023: [12,25,1,6],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
      },
      {
        name: "Karnevalsferien",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [2,20,2,26],
        2024: [2,12,2,17],
        2025: [3,3,3,8],
        2026: [2,16,2,21],
      },
      {
        name: "Allerheiligenferien",
        2020: [11,2,11,6],
        2021: [11,1,11,5],
        2022: [10,31,11,6],
        2023: [10,30,11,4],
        2024: [10,28,11,2],
        2025: [10,27,11,1],
      },
      {
        name: "Tag der Deutschsprachigen Gemeinschaft",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
      },
    ]
  },
  "FR": {
    "_state_code": "fr",
    SH: [
      {
        name: "Vacances d'hiver (Noël)",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,9],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,5],
        2025: [12,22,1,4],
        2026: [12,21,1,3],
      },
      {
        name: "Congé de détente (Carnaval)",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [2,20,3,3],
        2024: [2,26,3,8],
        2025: [2,24,3,9],
        2026: [2,16,3,1],
        2027: [2,22,3,7],
      },
      {
        name: "Vacances de printemps (Pâques)",
        2020: [4,6,4,17],
        2021: [4,5,4,16],
        2022: [4,4,4,15],
        2023: [5,1,5,12],
        2024: [4,29,5,10],
        2025: [4,28,5,11],
        2026: [4,27,5,10],
        2027: [4,26,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,28],
        2023: [7,8,8,27],
        2024: [7,6,8,25],
        2025: [7,5,8,24],
        2026: [7,4,8,23],
      },
      {
        name: "Fête de la Communauté française",
        2020: [9,27,9,27],
        2021: [9,27,9,27],
        2022: [9,27,9,27],
        2023: [9,27,9,27],
        2024: [9,27,9,27],
        2025: [9,27,9,27],
      },
      {
        name: "Congé d'automne (Toussaint)",
        2020: [11,2,11,6],
        2021: [11,1,11,5],
        2022: [10,24,11,4],
        2023: [10,23,11,3],
        2024: [10,21,11,3],
        2025: [10,20,11,2],
        2026: [10,19,11,1],
      },
      {
        name: "Début des vacances d'été",
        2027: [7,3,7,3],
      },
    ]
  },
  "NL": {
    "_state_code": "nl",
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,23,1,5],
        2020: [12,21,1,3],
        2021: [12,24,1,9],
        2022: [12,26,1,8],
        2023: [12,25,1,7],
        2024: [12,23,1,5],
        2025: [12,22,1,4],
        2026: [12,21,1,3],
        2027: [12,27,1,9],
        2028: [12,25,1,7],
      },
      {
        name: "Krokusvakantie",
        2020: [2,24,3,1],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [2,20,2,26],
        2024: [2,12,2,18],
        2025: [3,3,3,9],
        2026: [2,16,2,22],
        2027: [2,8,2,14],
        2028: [2,28,3,5],
        2029: [2,12,2,18],
      },
      {
        name: "Paasvakantie",
        2020: [4,6,4,19],
        2021: [4,5,4,18],
        2022: [4,4,4,18],
        2023: [4,3,4,16],
        2024: [4,1,4,14],
        2025: [4,7,4,21],
        2026: [4,6,4,19],
        2027: [3,29,4,11],
        2028: [4,3,4,17],
        2029: [4,2,4,15],
      },
      {
        name: "Zomervakantie",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,8,31],
        2025: [7,1,8,31],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,1,8,31],
        2029: [7,1,8,31],
      },
      {
        name: "Herfstvakantie",
        2020: [11,2,11,15],
        2021: [11,1,11,7],
        2022: [10,31,11,6],
        2023: [10,30,11,5],
        2024: [10,28,11,3],
        2025: [10,27,11,2],
        2026: [11,2,11,8],
        2027: [11,1,11,7],
        2028: [10,30,11,5],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const bg = {
  PH: [{"name":"Нова Година","fixed_date":[1,1]},{"name":"Ден на Освобождението на България от Османската Империя","fixed_date":[3,3]},{"name":"Разпети петък","variable_date":"orthodox easter","offset":-2},{"name":"Великден","variable_date":"orthodox easter"},{"name":"Велики понеделник","variable_date":"orthodox easter","offset":1},{"name":"Ден на труда","fixed_date":[5,1]},{"name":"Гергьовден","fixed_date":[5,6]},{"name":"Ден на азбуката, културата и просветата","fixed_date":[5,24]},{"name":"Ден на съединението","fixed_date":[9,6]},{"name":"Ден на независимостта","fixed_date":[9,22]},{"name":"Бъдни вечер","fixed_date":[12,24]},{"name":"Коледа","fixed_date":[12,25]}],
  SH: [
    {
      name: "Коледна ваканция",
      2019: [12,21,1,5],
      2020: [12,22,1,3],
      2021: [12,24,1,3],
      2022: [12,24,1,2],
      2023: [12,23,1,2],
      2024: [12,21,1,2],
      2025: [12,24,1,4],
    },
    {
      name: "Междусрочна ваканция",
      2020: [2,5,2,5],
      2021: [1,30,2,3],
      2022: [2,1,2,1],
      2023: [2,1,2,5],
      2024: [2,3,2,5],
      2025: [2,5,2,5],
      2026: [1,31,2,2],
    },
    {
      name: "Пролетна ваканция",
      2020: [4,16,4,20],
      2021: [4,8,4,11],
      2022: [4,7,4,10],
      2023: [4,12,4,17],
      2024: [4,5,4,7],
      2025: [4,4,4,6],
      2026: [4,8,4,13],
    },
    {
      name: "Лятна ваканция",
      2020: [7,1,9,14],
      2021: [7,1,9,14],
      2022: [7,1,9,14],
      2023: [7,1,9,14],
      2024: [6,29,9,14],
      2025: [7,1,9,14],
      2026: [7,1,9,14],
    },
    {
      name: "Есенна ваканция",
      2020: [10,30,11,1],
      2021: [10,30,11,1],
      2022: [10,29,11,1],
      2023: [11,1,11,5],
      2024: [10,31,11,3],
      2025: [10,31,11,3],
    },
    {
      name: "Свободен от училище",
      2022: [2,2,2,4],
      2026: [3,2,3,2],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.6977&lon=23.3219&zoom=18&addressdetails=1&accept-language=bg,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const br = {
  PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-10&lon=-52&zoom=18&addressdetails=1&accept-language=pt,en",
  "Acre": {
    "_state_code": "ac",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Acre&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Dia do evangélico","fixed_date":[1,12]},{"name":"Alusivo ao Dia Internacional da Mulher","fixed_date":[3,8]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Aniversário do estado","fixed_date":[6,15]},{"name":"Dia da Amazônia","fixed_date":[9,5]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Alagoas": {
    "_state_code": "al",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Alagoas&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"São João","fixed_date":[6,24]},{"name":"São Pedro","fixed_date":[6,29]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Emancipação política","fixed_date":[9,16]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Morte de Zumbi dos Palmares","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Amapá": {
    "_state_code": "ap",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Amap%C3%A1&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Dia de São José","fixed_date":[3,19]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Criação do Território Federal","fixed_date":[9,13]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Amazonas": {
    "_state_code": "am",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Amazonas&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Elevação do Amazonas à categoria de província","fixed_date":[9,5]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Bahia": {
    "_state_code": "ba",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Bahia&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Independência da Bahia","fixed_date":[7,2]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Ceará": {
    "_state_code": "ce",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Cear%C3%A1&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Data magna do estado","fixed_date":[3,25]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Distrito Federal": {
    "_state_code": "df",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Distrito+Federal&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Fundação de Brasília","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Dia do Evangélico","fixed_date":[11,30]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Espírito Santo": {
    "_state_code": "es",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Esp%C3%ADrito+Santo&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Nossa Senhora da Penha","variable_date":"easter","offset":8},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Goiás": {
    "_state_code": "go",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Goi%C3%A1s&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Nossa Senhora Auxiliadora","fixed_date":[5,24]},{"name":"Fundação da Cidade de Goiás","fixed_date":[7,26]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Lançamento da pedra fundamental de Goiânia","fixed_date":[10,24]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Maranhão": {
    "_state_code": "ma",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Maranh%C3%A3o&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Adesão do Maranhão à independência do Brasil","fixed_date":[7,28]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Mato Grosso": {
    "_state_code": "mt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Mato+Grosso&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Mato Grosso do Sul": {
    "_state_code": "ms",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Mato+Grosso+do+Sul&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Criação do estado","fixed_date":[10,11]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Minas Gerais": {
    "_state_code": "mg",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Minas+Gerais&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Data magna do estado","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Assunção de Nossa Senhora","fixed_date":[8,15]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Imaculada Conceição","fixed_date":[12,8]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Pará": {
    "_state_code": "pa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Par%C3%A1&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Adesão do Grão-Pará à independência do Brasil","fixed_date":[8,15]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Paraíba": {
    "_state_code": "pb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Para%C3%ADba&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Homenagem à memória do ex-presidente João Pessoa","fixed_date":[7,26]},{"name":"Nossa Senhora das Neves","fixed_date":[8,5]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Paraná": {
    "_state_code": "pr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Paran%C3%A1&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Nossa Senhora da Luz dos Pinhais","fixed_date":[9,8]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Emancipação política do estado do Paraná","fixed_date":[12,19]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Pernambuco": {
    "_state_code": "pe",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Pernambuco&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"São João","fixed_date":[6,24]},{"name":"Nossa Senhora do Carmo","fixed_date":[7,16]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Nossa Senhora da Conceição","fixed_date":[12,8]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Piauí": {
    "_state_code": "pi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Piau%C3%AD&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia do Piauí","fixed_date":[10,19]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio de Janeiro": {
    "_state_code": "rj",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Rio+de+Janeiro&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Dia de São Sebastião","fixed_date":[1,20]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia de São Jorge","fixed_date":[4,23]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio Grande do Norte": {
    "_state_code": "rn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Rio+Grande+do+Norte&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Mártires de Cunhaú e Uruaçu","fixed_date":[10,3]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio Grande do Sul": {
    "_state_code": "rs",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Rio+Grande+do+Sul&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Proclamação da República Rio-Grandense","fixed_date":[9,20]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rondônia": {
    "_state_code": "ro",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Rond%C3%B4nia&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Criação do estado","fixed_date":[1,4]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia do evangélico","fixed_date":[6,18]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Roraima": {
    "_state_code": "rr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Roraima&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Criação do estado","fixed_date":[10,5]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Santa Catarina": {
    "_state_code": "sc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Santa+Catarina&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia de Santa Catarina","fixed_date":[8,11],"shift_rule":"if monday,tuesday,wednesday,thursday,friday,saturday then next sunday"},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Dia de Santa Catarina de Alexandria","fixed_date":[11,25],"shift_rule":"if monday,tuesday,wednesday,thursday,friday,saturday then next sunday"},{"name":"Natal","fixed_date":[12,25]}]
  },
  "São Paulo": {
    "_state_code": "sp",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=S%C3%A3o+Paulo&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Aniversário da Cidade","fixed_date":[1,25]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Corpo de Deus","variable_date":"easter","offset":60},{"name":"Revolução Constitucionalista","fixed_date":[7,9]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Sergipe": {
    "_state_code": "se",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Sergipe&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Emancipação política de Sergipe","fixed_date":[7,8]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Tocantins": {
    "_state_code": "to",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Brasil&state=Tocantins&zoom=18&addressdetails=1&limit=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Autonomia do Estado","fixed_date":[3,18]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Dia de Tiradentes","fixed_date":[4,21]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Dia da Independência","fixed_date":[9,7]},{"name":"Nossa Senhora da Natividade","fixed_date":[9,8]},{"name":"Dia de Eleição","variable_date":"firstOctoberSunday","years":"even"},{"name":"Criação do estado","fixed_date":[10,5]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Dia de Eleição","variable_date":"lastOctoberSunday","years":"even"},{"name":"Dia de Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const by = {
  PH: [{"name":"Новы год","fixed_date":[1,1]},{"name":"Мiжнародны жаночы дзень","fixed_date":[3,8]},{"name":"Радунiца","variable_date":"orthodox easter","offset":9},{"name":"Дзень працы","fixed_date":[5,1]},{"name":"Дзень Перамогi","fixed_date":[5,9]},{"name":"Дзень Незалежнасцi","fixed_date":[7,3]},{"name":"Дзень Кастрычніцкай рэвалюцыі","fixed_date":[11,7]},{"name":"Каляды каталiцкiя","fixed_date":[12,25]}],
  SH: [
    {
      name: "Зімовыя вакацыі",
      2019: [12,26,1,11],
      2020: [12,25,1,10],
      2021: [12,25,1,9],
      2022: [12,25,1,8],
      2023: [12,24,1,7],
      2024: [12,25,1,7],
      2025: [12,25,1,7],
    },
    {
      name: "Вясновыя вакацыі",
      2020: [3,30,4,18],
      2021: [3,28,4,4],
      2022: [3,27,4,3],
      2023: [3,26,4,2],
      2024: [3,24,3,31],
      2025: [3,23,3,30],
      2026: [3,22,3,29],
    },
    {
      name: "Летнія вакацыі",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [6,1,8,31],
      2026: [6,1,8,31],
    },
    {
      name: "Восеньскія вакацыі",
      2020: [11,1,11,8],
      2021: [10,31,11,7],
      2022: [10,30,11,7],
      2023: [10,29,11,7],
      2024: [10,27,11,5],
      2025: [11,2,11,9],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=53.9045&lon=27.5615&zoom=18&addressdetails=1&accept-language=be,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ca = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Christmas Day","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=45.4215&lon=-75.6972&zoom=18&addressdetails=1&accept-language=en,fr",
  "Alberta": {
    "_state_code": "ab",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Alberta&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "British Columbia": {
    "_state_code": "bc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=British+Columbia&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"British Columbia Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Manitoba": {
    "_state_code": "mb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Manitoba&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Louis Riel Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "New Brunswick": {
    "_state_code": "nb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=New+Brunswick&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"New Brunswick Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Newfoundland and Labrador": {
    "_state_code": "nl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Newfoundland+and+Labrador&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Memorial Day","fixed_date":[7,1]},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Armistice Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Northwest Territories": {
    "_state_code": "nt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Northwest+Territories&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"National Indigenous Peoples Day","fixed_date":[6,21]},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Nova Scotia": {
    "_state_code": "ns",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Nova+Scotia&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Heritage Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Nunavut": {
    "_state_code": "nu",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Nunavut&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Nunavut Day","fixed_date":[7,9]},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Ontario": {
    "_state_code": "on",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Ontario&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Prince Edward Island": {
    "_state_code": "pe",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Prince+Edward+Island&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Islander Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Gold Cup Parade Day","variable_date":"firstAugustFriday","offset":14},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Quebec": {
    "_state_code": "qc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Quebec&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"Nouvel An","fixed_date":[1,1]},{"name":"Vendredi saint","variable_date":"easter","offset":-2},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Journée nationale des patriotes","variable_date":"victoriaDay"},{"name":"Fête nationale du Québec","fixed_date":[6,24]},{"name":"Fête du Canada","variable_date":"canadaDay"},{"name":"Fête du travail","variable_date":"firstSeptemberMonday"},{"name":"Action de grâce","variable_date":"firstOctoberMonday","offset":7},{"name":"Noël","fixed_date":[12,25]}]
  },
  "Saskatchewan": {
    "_state_code": "sk",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Saskatchewan&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Saskatchewan Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Yukon": {
    "_state_code": "yt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Canada&state=Yukon&zoom=18&addressdetails=1&limit=1&accept-language=en,fr",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"National Indigenous Peoples Day","fixed_date":[6,21]},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Discovery Day","variable_date":"firstAugustMonday","offset":14},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ch = {
  PH: [{"name":"Neujahr/Nouvel An/Capodanno","fixed_date":[1,1]},{"name":"Karfreitag/Vendredi saint/Venerdì santo","variable_date":"easter","offset":-2},{"name":"Ostersonntag/Pâques/Domenica di Pasqua","variable_date":"easter"},{"name":"Ostermontag/Lundi de Pâques/Lunedì dell’Angelo","variable_date":"easter","offset":1},{"name":"Auffahrt/Ascension/Ascensione","variable_date":"easter","offset":39},{"name":"Pfingstsonntag/Pentecôte/Pentecoste","variable_date":"easter","offset":49},{"name":"Pfingstmontag/Lundi de Pentecôte/Lunedì di Pentecoste","variable_date":"easter","offset":50},{"name":"Bundesfeiertag/Fête nationale/Giorno festivo federale","fixed_date":[8,1]},{"name":"Eidg. Dank-, Buss- und Bettag/Jeûne fédéral/Digiuno federale","variable_date":"firstSeptemberSunday","offset":14},{"name":"Weihnachtstag/Noël/Natale di Gesù","fixed_date":[12,25]},{"name":"Stephanstag/Saint-Etienne/Santo Stefano","fixed_date":[12,26]},{"name":"Berchtoldstag/2 janvier","fixed_date":[1,2],"only_states":["Aargau","Bern","Jura","Thurgau","Waadt"]},{"name":"Heilige Drei Könige/l’Épiphanie/Epifania","fixed_date":[1,6],"only_states":["Schwyz","Tessin","Uri"]},{"name":"Jahrestag Ausrufung der Republik/Instauration de la République","fixed_date":[3,1],"only_states":["Neuenburg"]},{"name":"Josefstag/San Giuseppe","fixed_date":[3,19],"only_states":["Nidwalden","Schwyz","Solothurn","Tessin","Uri","Wallis"]},{"name":"Tag der Arbeit/Fête du travail/Festa del lavoro","fixed_date":[5,1],"only_states":["Aargau","Basel-Landschaft","Basel-Stadt","Jura","Neuenburg","Schaffhausen","Tessin","Thurgau","Zürich"]},{"name":"Fronleichnam/la Fête-Dieu/Corpus Domini","variable_date":"easter","offset":60,"only_states":["Aargau","Appenzell Innerrhoden","Freiburg","Jura","Luzern","Neuenburg","Nidwalden","Obwalden","Schwyz","Solothurn","Tessin","Uri","Wallis","Zug"]},{"name":"Fest der Unabhängigkeit/Plébiscite jurassien","fixed_date":[6,23],"only_states":["Jura"]},{"name":"Peter und Paul/Saint Pierre et Paul/Santi Pietro e Paolo","fixed_date":[6,29],"only_states":["Tessin"]},{"name":"Mariä Himmelfahrt/Assomption/Assunzione","fixed_date":[8,15],"only_states":["Tessin"]},{"name":"Mariä Himmelfahrt/Assomption/Assunzione di Maria","fixed_date":[8,15],"only_states":["Aargau","Appenzell Innerrhoden","Freiburg","Jura","Luzern","Nidwalden","Obwalden","Schwyz","Solothurn","Uri","Wallis","Zug"]},{"name":"Mauritiustag","fixed_date":[9,22],"only_states":["Appenzell Innerrhoden"]},{"name":"Bruderklausenfest/Saint-Nicholas-de-Flüe","fixed_date":[9,25],"only_states":["Obwalden"]},{"name":"Allerheiligen/Toussaint/Ognissanti","fixed_date":[11,1],"only_states":["Aargau","Appenzell Innerrhoden","Freiburg","Glarus","Jura","Luzern","Nidwalden","Obwalden","Schwyz","Solothurn","St. Gallen","Tessin","Uri","Wallis","Zug"]},{"name":"Mariä Empfängnis/Immaculée Conception/Immacolata Concezione","fixed_date":[12,8],"only_states":["Aargau","Freiburg","Luzern","Nidwalden","Obwalden","Schwyz","Tessin","Uri","Wallis","Zug"]},{"name":"Heiliger Abend/Veille de Noël","fixed_date":[12,24],"only_states":["Glarus"]},{"name":"Silvester/Saint-Sylvestre/Ultimo dell’anno","fixed_date":[12,31],"only_states":["Glarus"]},{"name":"Wiederherstellung der Republik/Restauration de la République","fixed_date":[12,31],"only_states":["Genf"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
  "Aargau": {
    "_state_code": "ag",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Aargau&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Winterferien",
        2019: [12,23,1,3],
        2020: [12,21,12,31],
        2021: [12,24,1,7],
        2022: [12,27,1,6],
        2023: [12,27,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,12,31],
        2027: [12,24,1,7],
        2028: [12,27,1,5],
        2029: [12,24,1,4],
        2030: [12,23,1,3],
        2031: [12,22,12,31],
        2032: [12,24,1,7],
        2033: [12,27,1,6],
        2034: [12,27,1,5],
      },
      {
        name: "Sommerferien",
        2020: [7,20,8,7],
        2021: [7,19,8,6],
        2022: [7,18,8,5],
        2023: [7,24,8,11],
        2024: [7,22,8,9],
        2025: [7,21,8,8],
        2026: [7,20,8,7],
        2027: [7,19,8,6],
        2028: [7,24,8,11],
        2029: [7,23,8,10],
        2030: [7,22,8,9],
        2031: [7,21,8,8],
        2032: [7,19,8,6],
        2033: [7,18,8,5],
        2034: [7,24,8,11],
        2035: [7,23,8,10],
      },
      {
        name: "Herbstferien",
        2020: [9,28,10,9],
        2021: [10,4,10,15],
        2022: [10,3,10,14],
        2023: [10,2,10,13],
        2024: [9,30,10,11],
        2025: [9,29,10,10],
        2026: [9,28,10,9],
        2027: [10,4,10,15],
        2028: [10,2,10,13],
        2029: [10,1,10,12],
        2030: [9,30,10,11],
        2031: [9,29,10,10],
        2032: [9,27,10,8],
        2033: [10,3,10,14],
        2034: [10,2,10,13],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,21],
        2023: [4,11,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,18],
        2026: [4,7,4,17],
        2027: [4,12,4,23],
        2028: [4,10,4,21],
        2029: [4,9,4,20],
        2030: [4,6,4,18],
        2031: [4,7,4,18],
        2032: [4,5,4,16],
        2033: [4,11,4,22],
        2034: [4,11,4,21],
        2035: [4,9,4,20],
      },
    ]
  },
  "Albula": {
    "_state_code": "gr-ab",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Appenzell": {
    "_state_code": "ai-ap",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Appenzell Ausserrhoden": {
    "_state_code": "ar",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Appenzell+Ausserrhoden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,6,8,7],
        2021: [7,12,8,15],
        2022: [7,11,8,12],
        2023: [7,10,8,11],
        2024: [7,8,8,9],
        2025: [7,7,8,8],
        2026: [7,6,8,7],
        2027: [7,12,8,13],
        2028: [7,10,8,11],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,16],
        2021: [10,11,10,24],
        2022: [10,20,10,21],
        2023: [10,9,10,20],
        2024: [10,7,10,18],
        2025: [10,6,10,17],
        2026: [10,5,10,16],
        2027: [10,11,10,22],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,21,1,1],
        2021: [12,26,12,31],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,1,1],
        2027: [12,20,12,31],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,22],
        2023: [4,10,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,18],
        2026: [4,3,4,17],
        2027: [4,12,4,23],
        2028: [4,10,4,21],
      },
    ]
  },
  "Appenzell Innerrhoden": {
    "_state_code": "ai",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Appenzell+Innerrhoden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Weihnachtsferien",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [4,10,4,25],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [4,6,4,21],
        2025: [4,5,4,20],
        2026: [4,3,4,19],
        2027: [4,10,4,25],
        2028: [4,8,4,23],
      },
    ]
  },
  "Basel-Landschaft": {
    "_state_code": "bl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Basel-Landschaft&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,2,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
        2029: [6,30,8,12],
        2030: [6,29,8,11],
        2031: [6,28,8,10],
        2032: [6,26,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,9],
        2021: [10,2,10,17],
        2022: [10,2,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [10,2,10,17],
        2028: [9,30,10,15],
        2029: [9,29,10,14],
        2030: [9,28,10,13],
        2031: [9,27,10,12],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
        2030: [12,21,1,5],
        2031: [12,20,1,4],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,22,3,8],
        2021: [2,13,2,28],
        2022: [2,26,3,13],
        2023: [2,18,3,5],
        2024: [2,10,2,25],
        2025: [3,1,3,16],
        2026: [2,14,3,1],
        2027: [2,6,2,21],
        2028: [2,26,3,12],
        2029: [2,10,2,25],
        2030: [3,2,3,17],
        2031: [2,22,3,9],
        2032: [2,7,2,22],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [3,27,4,11],
        2022: [4,9,4,24],
        2023: [4,1,4,16],
        2024: [3,23,4,7],
        2025: [4,12,4,27],
        2026: [3,28,4,12],
        2027: [3,20,4,4],
        2028: [4,8,4,23],
        2029: [3,24,4,8],
        2030: [4,13,4,28],
        2031: [4,5,4,20],
        2032: [3,20,4,4],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,25,5,25],
        2027: [5,7,5,7],
        2028: [6,26,6,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
        2032: [5,7,5,7],
      },
    ]
  },
  "Basel-Stadt": {
    "_state_code": "bs",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Basel-Stadt&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
        2029: [6,30,8,12],
        2030: [6,29,8,11],
        2031: [6,28,8,10],
        2032: [6,26,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [10,2,10,17],
        2028: [9,30,10,15],
        2029: [9,29,10,14],
        2030: [9,28,10,13],
        2031: [9,27,10,12],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
        2030: [12,21,1,5],
        2031: [12,20,1,4],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,22,3,8],
        2021: [2,13,2,28],
        2022: [2,26,3,13],
        2023: [2,18,3,5],
        2024: [2,10,2,25],
        2025: [3,1,3,16],
        2026: [2,14,3,1],
        2027: [2,6,2,21],
        2028: [2,16,3,12],
        2029: [2,10,2,25],
        2030: [3,2,3,17],
        2031: [2,22,3,9],
        2032: [2,7,2,22],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [3,27,4,11],
        2022: [4,9,4,24],
        2023: [4,1,4,16],
        2024: [3,23,4,7],
        2025: [4,12,4,27],
        2026: [3,28,4,12],
        2027: [3,20,4,4],
        2028: [4,8,4,23],
        2029: [3,24,4,8],
        2030: [4,13,4,28],
        2031: [4,5,4,20],
        2032: [3,20,4,4],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,25,5,25],
        2027: [5,7,5,7],
        2028: [6,26,6,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
        2032: [5,7,5,7],
      },
    ]
  },
  "Bern": {
    "_state_code": "be",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Bern&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Winterferien",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,25,1,10],
        2027: [12,25,1,9],
      },
      {
        name: "Sommerferien",
        2020: [7,4,8,9],
        2021: [7,3,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
        2027: [7,3,8,15],
      },
      {
        name: "Herbstferien",
        2020: [9,19,10,11],
        2021: [9,25,10,17],
        2022: [9,24,10,16],
        2023: [9,23,10,15],
        2024: [9,21,10,13],
        2025: [9,20,10,12],
        2026: [9,19,10,11],
        2027: [9,25,10,17],
      },
      {
        name: "Februarwoche",
        2020: [2,1,2,9],
        2021: [2,6,2,14],
        2022: [2,5,2,13],
        2023: [2,4,2,12],
        2024: [2,3,2,11],
        2025: [2,1,2,9],
        2026: [1,31,2,8],
        2027: [2,6,2,14],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [4,10,4,25],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [4,6,4,21],
        2025: [4,5,4,21],
        2026: [4,3,4,19],
        2027: [4,10,4,25],
      },
      {
        name: "Vacances de printemps",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,11,4,22],
        2023: [4,7,4,21],
        2024: [3,29,4,12],
        2025: [4,14,4,25],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,11,8,19],
        2023: [7,10,8,18],
        2024: [7,8,8,16],
        2025: [7,7,8,15],
        2026: [7,6,8,14],
        2027: [7,5,8,13],
      },
      {
        name: "Vacances d'automne",
        2020: [10,3,10,18],
        2021: [10,11,10,22],
        2022: [10,10,10,21],
        2023: [10,9,10,20],
        2024: [10,7,10,18],
        2025: [10,6,10,27],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
      },
      {
        name: "Vacances d'hiver",
        2020: [12,25,1,10],
        2021: [12,27,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,25,1,8],
        2027: [12,27,1,7],
      },
    ]
  },
  "Bernina": {
    "_state_code": "gr-bn",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Engiadina Bassa/Val Müstair": {
    "_state_code": "gr-eb",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Freiburg": {
    "_state_code": "fr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Freiburg&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Fribourg": {
    "_state_code": "fr",
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,4,4,19],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,26],
        2021: [7,10,8,25],
        2022: [7,9,8,24],
        2023: [7,8,8,23],
        2024: [7,6,8,21],
        2025: [7,4,8,27],
        2026: [7,11,8,26],
      },
      {
        name: "Herbst",
        2020: [10,17,11,1],
        2021: [10,16,11,1],
        2022: [10,15,10,30],
        2023: [10,14,10,29],
        2024: [10,12,10,27],
        2025: [10,11,10,26],
        2026: [10,10,10,25],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,2],
        2026: [12,19,1,3],
      },
    ]
  },
  "Genève": {
    "_state_code": "ge",
    SH: [
      {
        name: "Vacances de février",
        2020: [2,8,2,16],
        2021: [2,13,2,21],
        2022: [2,12,2,20],
        2023: [2,18,2,26],
        2024: [2,17,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [2,21,2,25],
        2029: [2,19,2,23],
        2030: [2,25,3,1],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,2],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
        2028: [4,13,4,21],
        2029: [3,29,4,6],
        2030: [4,18,4,26],
      },
      {
        name: "Vacances d'été",
        2020: [6,27,8,23],
        2021: [7,3,8,29],
        2022: [7,2,8,21],
        2023: [7,1,8,20],
        2024: [6,29,8,18],
        2025: [6,30,8,15],
        2026: [6,29,8,16],
        2027: [7,5,8,25],
        2028: [7,3,8,23],
        2029: [7,2,8,22],
        2030: [7,1,8,21],
      },
      {
        name: "Vacances d'automne",
        2020: [10,17,10,25],
        2021: [10,23,10,31],
        2022: [10,22,10,30],
        2023: [10,21,10,29],
        2024: [10,19,10,27],
        2025: [10,20,10,24],
        2026: [10,19,10,23],
        2027: [10,25,10,29],
        2028: [10,23,10,27],
        2029: [10,22,10,26],
      },
      {
        name: "Vacances de Noël et Nouvel An",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
        2028: [12,25,1,5],
        2029: [12,24,1,4],
      },
      {
        name: "Pont de l'Ascension",
        2023: [5,18,5,19],
        2024: [5,9,5,10],
        2025: [5,29,5,30],
        2026: [5,14,5,15],
        2027: [5,6,5,7],
        2028: [5,25,5,26],
        2029: [5,10,5,11],
        2030: [5,30,5,31],
      },
    ]
  },
  "Genf": {
    "_state_code": "ge",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Genf&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Glarus": {
    "_state_code": "gl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Glarus&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2025: [1,25,2,2],
        2026: [1,24,2,1],
      },
      {
        name: "Frühling",
        2020: [4,2,4,19],
        2021: [4,2,4,18],
        2022: [4,7,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,3,4,20],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Gonten": {
    "_state_code": "ai-go",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Graubünden": {
    "_state_code": "gr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Graub%C3%BCnden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Imboden": {
    "_state_code": "gr-ib",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Jura": {
    "_state_code": "ju",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Jura&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,23,1,3],
        2020: [12,24,1,8],
        2021: [12,24,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
      },
      {
        name: "Semaine de relâche hivernale",
        2020: [2,17,2,21],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [2,20,2,24],
        2024: [2,19,2,23],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [2,15,2,19],
        2028: [2,21,2,25],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,10,4,24],
        2021: [4,2,4,16],
        2022: [4,11,4,22],
        2023: [4,7,4,21],
        2024: [3,29,4,12],
        2025: [3,18,5,2],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
        2028: [4,14,4,28],
      },
      {
        name: "Ascension",
        2020: [4,21,4,22],
        2021: [5,13,5,14],
        2022: [5,26,5,27],
        2023: [5,18,5,19],
        2024: [5,9,5,10],
        2025: [5,29,5,30],
        2026: [5,14,5,15],
        2027: [5,6,5,7],
        2028: [5,25,5,26],
      },
      {
        name: "Vacances d'été",
        2020: [7,6,8,14],
        2021: [7,5,8,13],
        2022: [7,4,8,12],
        2023: [7,3,8,18],
        2024: [7,8,8,16],
        2025: [7,7,8,15],
        2026: [7,6,8,14],
        2027: [7,5,8,13],
        2028: [7,3,8,18],
      },
      {
        name: "Vacances d'automne",
        2020: [10,12,10,23],
        2021: [10,11,10,22],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,14,10,25],
        2025: [10,6,10,17],
        2026: [10,5,10,16],
        2027: [10,11,10,22],
      },
    ]
  },
  "Landquart": {
    "_state_code": "gr-lq",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Luzern": {
    "_state_code": "lu",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Luzern&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,8,8,20],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [9,25,10,10],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,22,3,9],
        2026: [2,7,2,22],
        2027: [1,30,2,14],
        2028: [2,19,3,5],
      },
      {
        name: "Frühlingsferien",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
        2027: [3,26,4,11],
        2028: [4,14,4,30],
      },
    ]
  },
  "Maloja": {
    "_state_code": "gr-ml",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Moesa": {
    "_state_code": "gr-ms",
    SH: [
      {
        name: "Herbstferien",
        2023: [10,28,11,5],
        2024: [10,26,11,3],
        2025: [11,1,11,9],
        2026: [10,31,11,8],
      },
      {
        name: "Weihnachtsferien",
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
      {
        name: "Schulbeginn",
        2023: [8,21,8,21],
        2024: [8,26,8,26],
        2025: [8,25,8,25],
        2026: [8,24,8,24],
      },
    ]
  },
  "Neuchâtel": {
    "_state_code": "ne",
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,27,3,7],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,24,3,3],
        2025: [2,22,3,2],
        2026: [2,21,3,1],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,21,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
    ]
  },
  "Neuenburg": {
    "_state_code": "ne",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Neuenburg&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Nidwalden": {
    "_state_code": "nw",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Nidwalden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,22,3,9],
        2026: [2,7,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,23],
        2021: [7,3,8,22],
        2022: [7,9,8,28],
        2023: [7,8,8,27],
        2024: [7,6,8,25],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [9,25,10,10],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
    ]
  },
  "Oberegg": {
    "_state_code": "ai-ob",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,15],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2026: [7,4,8,9],
        2027: [7,10,8,15],
        2028: [7,8,8,13],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,18],
        2021: [10,2,10,24],
        2022: [10,1,10,23],
        2023: [9,30,10,22],
        2024: [9,28,10,20],
        2025: [10,4,10,19],
        2026: [9,26,10,18],
        2027: [10,2,10,24],
      },
      {
        name: "Sportferien",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2026: [1,24,2,1],
        2027: [1,30,2,7],
      },
    ]
  },
  "Obwalden": {
    "_state_code": "ow",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Obwalden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,27,3,9],
        2026: [2,12,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,2,8,15],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [10,2,10,24],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [10,4,10,26],
        2026: [10,3,10,25],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
    ]
  },
  "Plessur": {
    "_state_code": "gr-ps",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Prättigau / Davos": {
    "_state_code": "gr-pd",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Schaffhausen": {
    "_state_code": "sh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Schaffhausen&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,9],
        2021: [1,30,2,14],
        2022: [1,29,2,13],
        2023: [1,28,2,12],
        2024: [1,27,2,11],
        2025: [1,25,2,9],
        2026: [1,24,2,8],
      },
      {
        name: "Frühling",
        2020: [4,11,4,26],
        2021: [4,17,5,2],
        2022: [4,15,5,1],
        2023: [4,15,5,1],
        2024: [4,13,4,28],
        2025: [4,12,4,27],
        2026: [4,11,4,26],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [9,26,10,18],
        2021: [10,2,10,24],
        2022: [10,1,10,23],
        2023: [9,30,10,22],
        2024: [9,28,10,20],
        2025: [9,27,10,19],
        2026: [9,26,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,3],
        2021: [12,24,1,2],
        2022: [12,24,1,2],
        2023: [12,23,1,2],
        2024: [12,24,1,5],
        2025: [12,24,1,4],
        2026: [12,24,1,3],
      },
    ]
  },
  "Schlatt-Haslen": {
    "_state_code": "ai-sh",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Schwende-Rüte": {
    "_state_code": "ai-sr",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Schwyz": {
    "_state_code": "sz",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Schwyz&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,27,3,7],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,24,3,3],
        2025: [2,22,3,2],
        2026: [2,21,3,1],
      },
      {
        name: "Frühling",
        2020: [4,25,5,10],
        2021: [5,1,5,16],
        2022: [4,30,5,15],
        2023: [4,29,5,14],
        2024: [4,27,5,12],
        2025: [4,26,5,11],
        2026: [4,25,5,10],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,25,1,6],
        2025: [12,20,1,4],
        2026: [12,25,1,6],
      },
    ]
  },
  "Solothurn": {
    "_state_code": "so",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Solothurn&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Winterferien",
        2020: [2,3,2,14],
        2021: [2,8,2,19],
        2022: [2,7,2,18],
        2023: [2,6,2,17],
        2024: [2,5,2,16],
        2025: [2,3,2,14],
        2026: [2,2,2,13],
        2027: [2,8,2,19],
        2028: [2,7,2,18],
        2029: [2,5,2,16],
        2030: [2,4,2,15],
        2031: [2,3,2,14],
      },
      {
        name: "Sommerferien",
        2020: [7,6,8,7],
        2021: [7,10,8,15],
        2022: [7,11,8,12],
        2023: [7,10,8,15],
        2024: [7,8,8,9],
        2025: [7,7,8,8],
        2026: [7,6,8,7],
        2027: [7,12,8,13],
        2028: [7,10,8,11],
        2029: [7,9,8,10],
        2030: [7,8,8,9],
        2031: [7,7,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,28,10,16],
        2021: [10,4,10,22],
        2022: [10,3,10,21],
        2023: [10,2,10,20],
        2024: [9,30,10,18],
        2025: [9,29,10,17],
        2026: [9,28,10,16],
        2027: [10,4,10,22],
        2028: [10,2,10,20],
        2029: [10,1,10,19],
        2030: [9,30,10,18],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,1,1],
        2027: [12,27,1,7],
        2028: [12,25,1,5],
        2029: [12,24,1,4],
        2030: [12,23,1,3],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,22],
        2023: [4,10,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,21],
        2026: [4,6,4,17],
        2027: [4,2,4,23],
        2028: [4,10,4,21],
        2029: [4,9,4,20],
        2030: [4,8,4,22],
        2031: [4,7,4,18],
      },
    ]
  },
  "St. Gallen": {
    "_state_code": "sg",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=St.+Gallen&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,5,8,9],
        2021: [7,11,8,15],
        2022: [7,10,8,14],
        2023: [7,9,8,13],
        2024: [7,7,8,11],
        2025: [7,6,8,10],
        2026: [7,5,8,9],
        2027: [7,11,8,15],
        2028: [7,9,8,13],
        2029: [7,8,8,12],
      },
      {
        name: "Herbstferien",
        2020: [9,27,10,18],
        2021: [10,3,10,24],
        2022: [10,2,10,23],
        2023: [10,1,10,22],
        2024: [9,29,10,20],
        2025: [9,28,10,19],
        2026: [9,27,10,18],
        2027: [10,3,10,24],
        2028: [10,1,10,22],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,25,1,8],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
        2027: [12,19,1,2],
        2028: [12,24,1,7],
      },
      {
        name: "Frühlingsferien",
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,9,4,23],
        2024: [4,7,4,21],
        2025: [4,6,4,20],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
        2028: [4,9,4,23],
        2029: [4,8,4,22],
      },
    ]
  },
  "Surselva": {
    "_state_code": "gr-ss",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Tessin": {
    "_state_code": "ti",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Tessin&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Thurgau": {
    "_state_code": "tg",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Thurgau&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2025: [1,25,2,2],
        2026: [1,24,2,1],
      },
      {
        name: "Frühling",
        2020: [3,28,4,13],
        2021: [4,2,4,18],
        2022: [4,2,4,18],
        2023: [3,25,4,10],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
      {
        name: "Pfingsten",
        2026: [5,14,5,25],
      },
    ]
  },
  "Ticino": {
    "_state_code": "ti",
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,19],
        2021: [4,2,4,11],
        2022: [4,15,4,24],
        2023: [4,7,4,16],
        2024: [3,29,4,7],
        2025: [4,18,4,27],
        2026: [4,3,4,12],
      },
      {
        name: "Sommer",
        2020: [6,20,8,30],
        2021: [6,19,8,29],
        2022: [6,16,8,28],
        2023: [6,17,8,27],
        2024: [6,15,9,1],
        2025: [6,19,8,31],
        2026: [6,18,8,30],
      },
      {
        name: "Herbst",
        2020: [10,31,11,8],
        2021: [10,30,11,7],
        2022: [10,29,11,6],
        2023: [10,28,11,5],
        2024: [10,26,11,3],
        2025: [11,1,11,9],
        2026: [10,31,11,8],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
    ]
  },
  "Uri": {
    "_state_code": "ur",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Uri&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,27,3,7],
        2022: [2,19,3,6],
        2023: [3,4,3,12],
        2024: [3,2,3,10],
        2025: [2,22,3,9],
        2026: [2,28,3,8],
      },
      {
        name: "Frühling",
        2020: [4,25,5,10],
        2021: [5,1,5,16],
        2022: [4,30,5,15],
        2023: [4,22,5,7],
        2024: [4,27,5,12],
        2025: [4,26,5,11],
        2026: [5,2,5,17],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,20,1,6],
        2026: [12,24,1,10],
      },
    ]
  },
  "Valais": {
    "_state_code": "vs",
    SH: [
      {
        name: "Sport",
        2020: [2,29,3,8],
        2021: [2,27,3,7],
        2022: [3,5,3,13],
        2023: [3,4,3,12],
        2024: [3,2,3,10],
        2025: [3,1,3,9],
        2026: [2,28,3,8],
      },
      {
        name: "Frühling",
        2020: [5,16,5,24],
        2021: [5,8,5,16],
        2022: [5,7,5,15],
        2023: [5,13,5,29],
        2024: [5,4,5,12],
        2025: [4,18,4,27],
        2026: [5,9,5,17],
      },
      {
        name: "Sommer",
        2020: [6,27,8,16],
        2021: [6,26,8,15],
        2022: [6,30,8,15],
        2023: [7,1,8,15],
        2024: [6,29,8,18],
        2025: [6,28,8,17],
        2026: [7,1,8,16],
      },
      {
        name: "Herbst",
        2020: [10,22,11,1],
        2021: [10,13,10,24],
        2022: [10,13,10,23],
        2023: [10,19,10,29],
        2024: [10,17,10,27],
        2025: [10,16,10,26],
        2026: [10,15,10,25],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Vaud": {
    "_state_code": "vd",
    SH: [
      {
        name: "Sport",
        2020: [2,15,2,23],
        2021: [2,20,2,28],
        2022: [2,19,2,27],
        2023: [2,11,2,19],
        2024: [2,10,2,18],
        2025: [2,15,2,23],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,23],
        2021: [7,3,8,22],
        2022: [7,2,8,21],
        2023: [7,1,8,20],
        2024: [6,29,8,18],
        2025: [6,28,8,17],
        2026: [6,27,8,16],
      },
      {
        name: "Herbst",
        2020: [10,10,10,25],
        2021: [10,16,10,31],
        2022: [10,15,10,30],
        2023: [10,14,10,29],
        2024: [10,12,10,27],
        2025: [10,11,10,26],
        2026: [10,10,10,25],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Viamala": {
    "_state_code": "gr-vm",
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Waadt": {
    "_state_code": "vd",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Waadt&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Wallis": {
    "_state_code": "vs",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Wallis&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm"
  },
  "Zug": {
    "_state_code": "zg",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Zug&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Winterferien",
        2020: [12,19,1,3],
        2021: [12,23,1,5],
        2022: [12,22,1,4],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,19,1,3],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [6,21,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,8,8,20],
        2029: [7,7,8,19],
        2030: [7,6,8,18],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,3,10,18],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Sportferien",
        2020: [2,1,2,16],
        2021: [2,6,2,21],
        2022: [2,5,2,20],
        2023: [2,4,2,19],
        2024: [2,3,2,18],
        2025: [2,1,2,16],
        2026: [1,31,2,15],
        2027: [2,6,2,21],
        2028: [2,5,2,20],
        2029: [2,3,2,18],
        2030: [2,2,2,17],
      },
      {
        name: "Frühlingsferien",
        2020: [4,11,4,26],
        2021: [4,17,5,2],
        2022: [4,15,5,1],
        2023: [4,15,4,30],
        2024: [4,13,4,28],
        2025: [4,12,4,27],
        2026: [4,11,4,26],
        2027: [4,17,5,2],
        2028: [4,15,4,30],
        2029: [4,4,4,29],
        2030: [4,13,4,28],
      },
      {
        name: "Auffahrtsferien",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2024: [5,9,5,12],
        2025: [5,29,6,1],
        2026: [5,14,5,17],
        2027: [5,6,5,9],
        2028: [5,25,5,28],
        2029: [5,10,5,13],
        2030: [5,30,6,2],
      },
    ]
  },
  "Zürich": {
    "_state_code": "zh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Schweiz&state=Z%C3%BCrich&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,13,8,15],
        2021: [7,19,8,21],
        2022: [7,18,8,20],
        2023: [7,17,8,19],
        2024: [7,15,8,17],
        2025: [7,14,8,16],
        2026: [7,13,8,15],
        2027: [7,19,8,21],
        2028: [7,17,8,19],
        2029: [7,16,8,18],
        2030: [7,15,8,17],
        2031: [7,14,8,16],
        2032: [7,12,8,14],
        2033: [7,18,8,20],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,17],
        2021: [10,11,10,23],
        2022: [10,10,10,22],
        2023: [10,9,10,21],
        2024: [10,7,10,19],
        2025: [10,6,10,18],
        2026: [10,5,10,17],
        2027: [10,11,10,23],
        2028: [10,9,10,21],
        2029: [10,8,10,20],
        2030: [10,7,10,19],
        2031: [10,6,10,18],
        2032: [10,4,10,16],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,21,1,2],
        2021: [12,20,1,1],
        2022: [12,26,1,7],
        2023: [12,25,1,6],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
        2026: [12,21,1,2],
        2027: [12,20,1,1],
        2028: [12,25,1,6],
        2029: [12,24,1,5],
        2030: [12,23,1,5],
        2031: [12,22,1,3],
        2032: [12,20,1,1],
      },
      {
        name: "Ostern",
        2020: [4,10,4,13],
        2021: [4,2,4,5],
        2022: [4,15,4,18],
        2023: [4,7,4,10],
        2024: [3,29,4,1],
        2025: [4,18,4,21],
        2026: [4,3,4,6],
        2027: [3,26,3,29],
        2028: [4,14,4,17],
        2029: [3,30,4,2],
        2030: [4,19,4,22],
        2031: [4,11,4,14],
        2032: [3,26,3,29],
        2033: [4,15,4,18],
      },
      {
        name: "Frühlingsferien",
        2020: [4,13,4,25],
        2021: [4,26,5,8],
        2022: [4,18,4,30],
        2023: [4,24,5,6],
        2024: [4,22,5,4],
        2025: [4,21,5,3],
        2026: [4,20,5,2],
        2027: [4,26,5,8],
        2028: [4,17,4,29],
        2029: [4,23,5,5],
        2030: [4,22,5,4],
        2031: [4,14,4,26],
        2032: [4,19,5,1],
        2033: [4,18,4,30],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,21,5,23],
        2021: [5,13,5,15],
        2022: [5,26,5,28],
        2024: [5,9,5,11],
        2025: [5,29,5,31],
        2026: [5,14,5,16],
        2027: [5,6,5,8],
        2028: [5,25,5,27],
        2029: [5,10,5,12],
        2030: [5,30,6,1],
        2031: [5,22,5,24],
        2032: [5,6,5,8],
        2033: [5,26,5,28],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ci = {
  PH: [{"name":"Fête du 1ᵉʳ janvier","fixed_date":[1,1]},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Fête du travail","fixed_date":[5,1]},{"name":"Lendemain de la Fête du travail","variable_date":"nextMo-Sa01May"},{"name":"Jour de l’Ascension","variable_date":"easter","offset":39},{"name":"Lundi de la Pentecôte","variable_date":"easter","offset":50},{"name":"Fête nationale","fixed_date":[8,7]},{"name":"Lendemain de la Fête nationale","variable_date":"nextMo-Sa07August"},{"name":"Fête de l’Assomption","fixed_date":[8,15]},{"name":"Fête de la Toussaint","fixed_date":[11,1]},{"name":"Journée Nationale de la Paix","fixed_date":[11,15]},{"name":"Fête de Noël","fixed_date":[12,25]},{"name":"Lendemain de la Fête de Noël","variable_date":"nextMo-Sa25December"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=5.3203570&lon=-4.0161070&zoom=18&addressdetails=1&accept-language=fr"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const cn = {
  PH: [{"name":"元旦","fixed_date":[1,1]},{"name":"妇女节","fixed_date":[3,8]},{"name":"劳动节","fixed_date":[5,1]},{"name":"青年节","fixed_date":[5,4]},{"name":"儿童节","fixed_date":[6,1]},{"name":"国庆节","fixed_date":[10,1]},{"name":"国庆节休息日","fixed_date":[10,2]},{"name":"国庆节休息日","fixed_date":[10,3]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=%E4%B8%AD%E5%9B%BD&&zoom=18&addressdetails=1&limit=1&accept-language=zh,en",
  "西藏自治区": {
    "_state_code": "xz",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&state=%E8%A5%BF%E8%97%8F%E8%87%AA%E6%B2%BB%E5%8C%BA&zoom=1&addressdetails=1&limit=1&accept-language=zh,en",
    PH: [{"name":"元旦","fixed_date":[1,1]},{"name":"西藏百万农奴解放纪念日","fixed_date":[3,28]},{"name":"妇女节","fixed_date":[3,8]},{"name":"劳动节","fixed_date":[5,1]},{"name":"青年节","fixed_date":[5,4]},{"name":"儿童节","fixed_date":[6,1]},{"name":"国庆节","fixed_date":[10,1]},{"name":"国庆节休息日","fixed_date":[10,2]},{"name":"国庆节休息日","fixed_date":[10,3]}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const cz = {
  PH: [{"name":"Nový rok a Den obnovy samostatného českého státu","fixed_date":[1,1]},{"name":"Velký pátek","variable_date":"easter","offset":-2},{"name":"Velikonoční pondělí","variable_date":"easter","offset":1},{"name":"Svátek práce","fixed_date":[5,1]},{"name":"Den vítězství","fixed_date":[5,8]},{"name":"Den slovanských věrozvěstů Cyrila a Metoděje","fixed_date":[7,5]},{"name":"Den upálení mistra Jana Husa","fixed_date":[7,6]},{"name":"Den české státnosti","fixed_date":[9,28]},{"name":"Den vzniku samostatného československého státu","fixed_date":[10,28]},{"name":"Den boje za svobodu a demokracii","fixed_date":[11,17]},{"name":"Štědrý den","fixed_date":[12,24]},{"name":"1. svátek vánoční","fixed_date":[12,25]},{"name":"2. svátek vánoční","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vánoční prázdniny",
      2019: [12,23,1,3],
      2020: [12,23,1,3],
      2021: [12,23,1,2],
      2022: [12,23,1,2],
      2023: [12,23,1,2],
      2024: [12,23,1,3],
      2025: [12,22,1,2],
      2026: [12,23,1,3],
      2027: [12,23,1,2],
    },
    {
      name: "Pololetní prázdniny",
      2020: [1,31,1,31],
      2021: [1,29,1,29],
      2022: [2,4,2,4],
      2023: [2,3,2,3],
      2024: [2,2,2,2],
      2025: [1,31,1,31],
      2026: [1,30,1,30],
      2027: [1,29,1,29],
      2028: [2,4,2,4],
    },
    {
      name: "Velikonoční prázdniny",
      2020: [4,9,4,9],
      2021: [4,1,4,1],
      2022: [4,14,4,14],
      2023: [4,6,4,6],
      2024: [3,28,3,28],
      2025: [4,17,4,17],
      2026: [4,2,4,2],
      2027: [3,25,3,25],
      2028: [4,13,4,13],
    },
    {
      name: "Hlavní prázdniny",
      2020: [7,1,8,31],
      2021: [7,1,8,31],
      2022: [7,1,8,31],
      2023: [7,1,9,3],
      2024: [6,29,9,1],
      2025: [7,1,8,31],
      2026: [7,1,8,31],
      2027: [7,1,8,31],
      2028: [7,1,9,3],
    },
    {
      name: "Podzimní prázdniny",
      2020: [10,29,10,30],
      2021: [10,27,10,29],
      2022: [10,26,10,27],
      2023: [10,26,10,27],
      2024: [10,29,10,30],
      2025: [10,27,10,29],
      2026: [10,29,10,30],
      2027: [10,27,10,29],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=50.0874401&lon=14.4212556&zoom=18&addressdetails=1&accept-language=cs,en",
  "Benešov": {
    "_state_code": "st-bn",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Beroun": {
    "_state_code": "st-be",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Blansko": {
    "_state_code": "jm-bk",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Břeclav": {
    "_state_code": "jm-bv",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Brno-město": {
    "_state_code": "jm-bm",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Brno-venkov": {
    "_state_code": "jm-bo",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Bruntál": {
    "_state_code": "mo-br",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Česká Lípa": {
    "_state_code": "li-cl",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "České Budějovice": {
    "_state_code": "jc-cb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Český Krumlov": {
    "_state_code": "jc-ck",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Cheb": {
    "_state_code": "ka-ch",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Chomutov": {
    "_state_code": "us-cv",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Chrudim": {
    "_state_code": "pa-cr",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Děčín": {
    "_state_code": "us-dc",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Domažlice": {
    "_state_code": "pl-do",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Frýdek-Místek": {
    "_state_code": "mo-fm",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Havlíčkův Brod": {
    "_state_code": "vy-hb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Hodonín": {
    "_state_code": "jm-ho",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Hradec Králov": {
    "_state_code": "kr-hk",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Jablonec nad Nisou": {
    "_state_code": "li-jn",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Jeseník": {
    "_state_code": "ol-je",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Jičín": {
    "_state_code": "kr-jc",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Jihlava": {
    "_state_code": "vy-ji",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Jindřichův Hradec": {
    "_state_code": "jc-jh",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Karlovy Vary": {
    "_state_code": "ka-kv",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Karviná": {
    "_state_code": "mo-ki",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Kladno": {
    "_state_code": "st-kl",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Klatovy": {
    "_state_code": "pl-kt",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Kolín": {
    "_state_code": "st-ko",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Kroměříž": {
    "_state_code": "zl-km",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Kutná Hora": {
    "_state_code": "st-kh",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Liberec": {
    "_state_code": "li-lb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Litoměřice": {
    "_state_code": "us-lt",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Louny": {
    "_state_code": "us-ln",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Mělník": {
    "_state_code": "st-me",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Mladá Boleslav": {
    "_state_code": "st-mb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Most": {
    "_state_code": "us-mo",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Náchod": {
    "_state_code": "kr-na",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Nový Jičín": {
    "_state_code": "mo-nj",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Nymburk": {
    "_state_code": "st-nb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Olomouc": {
    "_state_code": "ol-oc",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Opava": {
    "_state_code": "mo-op",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Ostrava-město": {
    "_state_code": "mo-ov",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Pardubice": {
    "_state_code": "pa-pu",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Pelhřimov": {
    "_state_code": "vy-pe",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Písek": {
    "_state_code": "jc-pi",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Plzeň-jih": {
    "_state_code": "pl-pj",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Plzeň-město": {
    "_state_code": "pl-pm",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Plzeň-sever": {
    "_state_code": "pl-ps",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Prachatice": {
    "_state_code": "jc-pt",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Praha": {
    "_state_code": "pr",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [3,13,3,19],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Praha-východ": {
    "_state_code": "st-ph",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Praha-západ": {
    "_state_code": "st-pz",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Přerov": {
    "_state_code": "ol-pr",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Příbram": {
    "_state_code": "st-pb",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Prostějov": {
    "_state_code": "ol-pv",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Rakovník": {
    "_state_code": "st-ra",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Rokycany": {
    "_state_code": "pl-ro",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Rychnov nad Kněžnou": {
    "_state_code": "kr-rk",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Semily": {
    "_state_code": "li-sm",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Sokolov": {
    "_state_code": "ka-so",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Strakonice": {
    "_state_code": "jc-st",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Šumperk": {
    "_state_code": "ol-su",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Svitavy": {
    "_state_code": "pa-sy",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Tábor": {
    "_state_code": "jc-ta",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Tachov": {
    "_state_code": "pl-tc",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Teplice": {
    "_state_code": "us-tp",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Třebíč": {
    "_state_code": "vy-tr",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Trutnov": {
    "_state_code": "kr-tu",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Uherské Hradiště": {
    "_state_code": "zl-uh",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Ústí nad Labem": {
    "_state_code": "us-ul",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Ústí nad Orlicí": {
    "_state_code": "pa-uo",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Vsetín": {
    "_state_code": "zl-vs",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Vyškov": {
    "_state_code": "jm-vy",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Žďár nad Sázavou": {
    "_state_code": "vy-zr",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Zlín": {
    "_state_code": "zl-zl",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Znojmom": {
    "_state_code": "jm-zn",
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const de = {
  PH: [{"name":"Neujahr","fixed_date":[1,1]},{"name":"Karfreitag","variable_date":"easter","offset":-2},{"name":"Ostermontag","variable_date":"easter","offset":1},{"name":"Maifeiertag","fixed_date":[5,1]},{"name":"Christi Himmelfahrt","variable_date":"easter","offset":39},{"name":"Pfingstmontag","variable_date":"easter","offset":50},{"name":"Tag der Deutschen Einheit","fixed_date":[10,3]},{"name":"1. Weihnachtstag","fixed_date":[12,25]},{"name":"2. Weihnachtstag","fixed_date":[12,26]},{"name":"Heilige Drei Könige","fixed_date":[1,6],"only_states":["Baden-Württemberg","Bayern","Sachsen-Anhalt"]},{"name":"Internationaler Frauentag","fixed_date":[3,8],"only_states":["Berlin","Mecklenburg-Vorpommern"]},{"name":"Ostersonntag","variable_date":"easter","only_states":["Brandenburg"]},{"name":"Pfingstsonntag","variable_date":"easter","offset":49,"only_states":["Brandenburg"]},{"name":"Fronleichnam","variable_date":"easter","offset":60,"only_states":["Baden-Württemberg","Bayern","Hessen","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland"]},{"name":"75-jähriges Jubiläum des Volksaufstands in der DDR","fixed_date":[6,17],"year":2028,"only_states":["Berlin"]},{"name":"Augsburger Friedensfest","fixed_date":[8,8],"only_states":["Bayern"]},{"name":"Mariä Himmelfahrt","fixed_date":[8,15],"only_states":["Bayern","Saarland"]},{"name":"Weltkindertag","fixed_date":[9,20],"only_states":["Thüringen"]},{"name":"Reformationstag","fixed_date":[10,31],"only_states":["Brandenburg","Bremen","Hamburg","Mecklenburg-Vorpommern","Niedersachsen","Sachsen","Sachsen-Anhalt","Schleswig-Holstein","Thüringen"]},{"name":"Allerheiligen","fixed_date":[11,1],"only_states":["Baden-Württemberg","Bayern","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland"]},{"name":"Buß- und Bettag","variable_date":"nextWednesday16Nov","only_states":["Sachsen"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=49.5487&lon=9.8160&zoom=18&addressdetails=1&accept-language=de,en",
  "Baden-Württemberg": {
    "_state_code": "bw",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Baden-W%C3%BCrttemberg&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,13],
        2013: [3,25,4,5],
        2014: [4,14,4,25],
        2015: [3,30,4,10],
        2016: [3,29,4,2],
        2017: [4,10,4,21],
        2018: [3,26,4,6],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [4,6,4,10],
        2022: [4,19,4,23],
        2023: [4,11,4,15],
        2024: [3,23,4,5],
        2025: [4,14,4,26],
        2026: [3,30,4,11],
        2027: [3,30,4,3],
        2028: [4,18,4,22],
        2029: [3,26,4,7],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,6,9],
        2013: [5,21,6,1],
        2014: [6,10,6,21],
        2015: [5,26,6,6],
        2016: [5,17,5,28],
        2017: [6,6,6,16],
        2018: [5,22,6,2],
        2019: [6,11,6,21],
        2020: [6,2,6,13],
        2021: [5,25,6,5],
        2022: [6,7,6,18],
        2023: [5,30,6,9],
        2024: [5,21,5,31],
        2025: [6,10,6,20],
        2026: [5,26,6,5],
        2027: [5,18,5,29],
        2028: [6,6,6,17],
        2029: [5,22,6,1],
        2030: [6,11,6,21],
      },
      {
        name: "Sommerferien",
        2012: [7,26,9,8],
        2013: [7,25,9,7],
        2014: [7,31,9,13],
        2015: [7,30,9,12],
        2016: [7,28,9,10],
        2017: [7,27,9,9],
        2018: [7,26,9,8],
        2019: [7,29,9,10],
        2020: [7,30,9,12],
        2021: [7,29,9,11],
        2022: [7,28,9,10],
        2023: [7,27,9,9],
        2024: [7,25,9,7],
        2025: [7,31,9,13],
        2026: [7,30,9,12],
        2027: [7,29,9,11],
        2028: [7,27,9,9],
        2029: [7,26,9,8],
        2030: [7,25,9,7],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,2],
        2013: [10,28,10,30],
        2014: [10,27,10,30],
        2015: [11,2,11,6],
        2016: [11,2,11,4],
        2017: [10,30,11,3],
        2018: [10,29,11,2],
        2019: [10,28,10,30],
        2020: [10,26,10,30],
        2021: [11,2,11,6],
        2022: [11,2,11,4],
        2023: [10,30,11,3],
        2024: [10,28,10,30],
        2025: [10,27,10,30],
        2026: [10,26,10,30],
        2027: [11,2,11,6],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,5],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,22,1,5],
        2015: [12,23,1,9],
        2016: [12,23,1,7],
        2017: [12,22,1,5],
        2018: [12,24,1,5],
        2019: [12,23,1,4],
        2020: [12,23,1,9],
        2021: [12,23,1,8],
        2022: [12,21,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,23,1,5],
        2029: [12,22,1,5],
      },
      {
        name: "Reformationsfest",
        2022: [10,31,10,31],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
        2026: [10,31,10,31],
      },
      {
        name: "Gründonnerstag",
        2023: [4,6,4,6],
        2027: [3,25,3,25],
        2028: [4,13,4,13],
      },
    ]
  },
  "Bayern": {
    "_state_code": "by",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Bayern&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [2,20,2,24],
        2013: [2,11,2,15],
        2014: [3,3,3,7],
        2015: [2,16,2,20],
        2016: [2,8,2,12],
        2017: [2,27,3,3],
        2018: [2,12,2,16],
        2019: [3,4,3,8],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,21,4,1],
        2017: [4,10,4,22],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,6,9],
        2013: [5,21,5,31],
        2014: [6,10,6,21],
        2015: [5,26,6,5],
        2016: [5,17,5,28],
        2017: [6,6,6,16],
        2018: [5,22,6,2],
        2019: [6,11,6,21],
        2020: [6,2,6,13],
        2021: [5,25,6,4],
        2022: [6,7,6,18],
        2023: [5,30,6,9],
        2024: [5,21,6,1],
        2025: [6,10,6,20],
        2026: [5,26,6,5],
        2027: [5,18,5,28],
        2028: [6,6,6,16],
        2029: [5,22,6,1],
        2030: [6,11,6,21],
      },
      {
        name: "Sommerferien",
        2012: [8,1,9,12],
        2013: [7,31,9,11],
        2014: [7,30,9,15],
        2015: [8,1,9,14],
        2016: [7,30,9,12],
        2017: [7,29,9,11],
        2018: [7,30,9,10],
        2019: [7,29,9,9],
        2020: [7,27,9,7],
        2021: [7,30,9,13],
        2022: [8,1,9,12],
        2023: [7,31,9,11],
        2024: [7,29,9,9],
        2025: [8,1,9,15],
        2026: [8,3,9,14],
        2027: [8,2,9,13],
        2028: [7,31,9,11],
        2029: [7,30,9,10],
        2030: [7,29,9,9],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,3],
        2013: [10,28,10,31],
        2014: [11,19,11,19],
        2015: [11,18,11,18],
        2016: [11,16,11,16],
        2017: [11,22,11,22],
        2018: [11,21,11,21],
        2019: [11,20,11,20],
        2020: [10,31,11,6],
        2021: [11,2,11,5],
        2022: [10,31,11,4],
        2023: [10,30,11,4],
        2024: [10,28,10,31],
        2025: [11,3,11,7],
        2026: [11,2,11,6],
        2027: [11,2,11,5],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,27,1,5],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,24,1,5],
        2015: [12,24,1,5],
        2016: [12,24,1,5],
        2017: [12,23,1,5],
        2018: [12,22,1,5],
        2019: [12,23,1,4],
        2020: [12,23,1,9],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,5],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
        2028: [12,23,1,5],
        2029: [12,24,1,4],
      },
      {
        name: "Frühjahrsferien",
        2020: [2,24,2,28],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [2,12,2,16],
        2025: [3,3,3,7],
        2026: [2,16,2,20],
        2027: [2,8,2,12],
        2028: [2,28,3,3],
        2029: [2,12,2,16],
        2030: [3,4,3,8],
      },
      {
        name: "Buß- und Bettag",
        2020: [11,18,11,18],
        2021: [11,17,11,17],
        2022: [11,16,11,16],
        2023: [11,22,11,22],
        2024: [11,20,11,20],
        2025: [11,19,11,19],
        2026: [11,18,11,18],
        2027: [11,17,11,17],
        2028: [11,22,11,22],
        2029: [11,21,11,21],
        2030: [11,20,11,20],
      },
    ]
  },
  "Berlin": {
    "_state_code": "be",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Berlin&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,2,4],
        2013: [2,4,2,9],
        2014: [2,3,2,8],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [1,30,2,3],
        2018: [2,5,2,10],
        2019: [2,4,2,9],
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [1,30,2,4],
        2023: [1,30,2,4],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [2,1,2,6],
        2028: [1,31,2,5],
        2029: [1,29,2,3],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,25,4,6],
        2014: [5,2,5,2],
        2015: [3,30,4,11],
        2016: [3,21,4,2],
        2017: [4,10,4,18],
        2018: [3,26,4,6],
        2019: [4,15,4,26],
        2020: [4,6,4,17],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,14],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,22],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,21,5,21],
        2014: [5,30,5,30],
        2015: [5,26,5,26],
        2016: [5,17,5,18],
        2017: [6,6,6,9],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,19],
        2028: [6,1,6,2],
        2029: [5,22,5,25],
        2030: [6,7,6,7],
      },
      {
        name: "Sommerferien",
        2012: [6,20,8,3],
        2013: [6,19,8,2],
        2014: [7,9,8,22],
        2015: [7,16,8,28],
        2016: [7,21,9,2],
        2017: [7,20,9,1],
        2018: [7,5,8,17],
        2019: [6,20,8,2],
        2020: [6,25,8,7],
        2021: [6,24,8,6],
        2022: [7,7,8,18],
        2023: [7,13,8,25],
        2024: [7,18,8,30],
        2025: [7,24,9,6],
        2026: [7,9,8,22],
        2027: [7,1,8,14],
        2028: [7,1,8,12],
        2029: [7,1,8,11],
        2030: [7,4,8,17],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,13],
        2013: [9,30,10,12],
        2014: [10,20,11,1],
        2015: [10,19,10,31],
        2016: [10,17,10,28],
        2017: [10,23,11,4],
        2018: [10,22,11,2],
        2019: [10,7,10,19],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,24,11,5],
        2023: [10,23,11,4],
        2024: [10,21,11,2],
        2025: [10,20,11,1],
        2026: [10,19,10,31],
        2027: [10,11,10,23],
        2028: [10,2,10,14],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,24,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,23,1,2],
        2016: [12,23,1,3],
        2017: [12,21,1,2],
        2018: [12,22,1,5],
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,2],
        2023: [12,23,1,5],
        2024: [12,23,12,31],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,22,12,31],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Unterrichtsfreier Tag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Brandenburg": {
    "_state_code": "bb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Brandenburg&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,2,4],
        2013: [2,4,2,9],
        2014: [2,3,2,8],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [1,30,2,4],
        2018: [2,5,2,10],
        2019: [2,4,2,9],
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [1,31,2,5],
        2023: [1,30,2,3],
        2024: [2,5,2,9],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [2,1,2,6],
        2028: [1,31,2,5],
        2029: [1,29,2,3],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,27,4,6],
        2014: [5,2,5,2],
        2015: [4,1,4,11],
        2016: [3,23,4,2],
        2017: [4,10,4,22],
        2018: [3,26,4,6],
        2019: [4,15,4,26],
        2020: [4,6,4,17],
        2021: [3,29,4,9],
        2022: [4,11,4,24],
        2023: [4,3,4,14],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,17,5,17],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2029: [5,22,5,22],
      },
      {
        name: "Sommerferien",
        2012: [6,21,8,3],
        2013: [6,20,8,2],
        2014: [7,10,8,22],
        2015: [7,16,8,28],
        2016: [7,21,9,3],
        2017: [7,20,9,1],
        2018: [7,5,8,18],
        2019: [6,20,8,3],
        2020: [6,25,8,8],
        2021: [6,24,8,7],
        2022: [7,7,8,20],
        2023: [7,13,8,26],
        2024: [7,18,8,31],
        2025: [7,24,9,6],
        2026: [7,9,8,22],
        2027: [7,1,8,14],
        2028: [6,29,8,12],
        2029: [6,28,8,11],
        2030: [7,4,8,17],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,13],
        2013: [11,1,11,1],
        2014: [10,20,11,1],
        2015: [10,19,10,30],
        2016: [10,17,10,28],
        2017: [10,23,11,4],
        2018: [10,22,11,2],
        2019: [11,1,11,1],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,24,11,5],
        2023: [10,23,11,4],
        2024: [10,21,11,2],
        2025: [10,20,11,1],
        2026: [10,19,10,30],
        2027: [10,11,10,23],
        2028: [10,2,10,14],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,24,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,23,1,2],
        2016: [12,23,1,3],
        2017: [12,21,1,2],
        2018: [12,21,1,5],
        2019: [12,23,1,3],
        2020: [12,21,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,3],
        2023: [12,23,1,5],
        2024: [12,23,12,31],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,23,12,31],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Variabler Ferientag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [10,30,10,30],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Bremen": {
    "_state_code": "hb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Bremen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,31],
        2013: [1,31,2,1],
        2014: [1,30,1,31],
        2015: [2,2,2,3],
        2016: [1,28,1,29],
        2017: [1,30,1,31],
        2018: [2,1,2,2],
        2019: [1,31,2,1],
      },
      {
        name: "Halbjahresferien",
        2021: [2,1,2,2],
        2022: [1,31,2,1],
        2023: [1,30,1,31],
        2024: [2,1,2,2],
        2025: [2,3,2,4],
        2026: [2,2,2,3],
        2027: [2,1,2,2],
        2028: [1,31,2,1],
        2029: [2,1,2,2],
        2030: [1,31,2,1],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,16,4,2],
        2014: [5,2,5,2],
        2015: [3,25,4,10],
        2016: [3,18,4,2],
        2017: [4,10,4,22],
        2018: [3,19,4,3],
        2019: [4,6,4,23],
        2021: [3,27,4,10],
        2022: [4,4,4,19],
        2023: [3,27,4,11],
        2024: [3,18,3,28],
        2025: [4,7,4,19],
        2026: [3,23,4,7],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,19,4,3],
        2030: [4,8,4,23],
      },
      {
        name: "Kirchentag und Tag nach dem 1. Mai",
        2025: [4,30,5,2],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2021: [5,25,5,25],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2028: [6,6,6,6],
        2029: [5,22,5,22],
        2030: [6,11,6,11],
      },
      {
        name: "Tag nach Himmelfahrt",
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [6,27,8,7],
        2014: [7,31,9,10],
        2015: [7,23,9,2],
        2016: [6,23,8,3],
        2017: [6,22,8,2],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,2],
        2025: [7,3,8,13],
        2026: [7,2,8,12],
        2027: [7,8,8,18],
        2028: [7,20,8,30],
        2029: [7,19,8,29],
        2030: [7,11,8,21],
      },
      {
        name: "Tag vor dem 3. Oktober",
        2023: [10,2,10,2],
        2028: [10,2,10,2],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,4,10,18],
        2014: [10,27,11,8],
        2015: [10,19,10,31],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,13],
        2019: [10,4,10,18],
        2020: [10,12,10,24],
        2021: [10,18,10,30],
        2022: [10,17,10,29],
        2023: [10,16,10,30],
        2024: [10,4,10,19],
        2025: [10,13,10,25],
        2026: [10,12,10,24],
        2027: [10,18,10,30],
        2028: [10,23,11,4],
        2029: [10,22,11,2],
      },
      {
        name: "Tag nach dem Reformationstag",
        2024: [11,1,11,1],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,23,1,3],
        2014: [12,22,1,5],
        2015: [12,23,1,6],
        2016: [12,21,1,6],
        2017: [12,22,1,6],
        2018: [12,24,1,4],
        2019: [12,21,1,6],
        2020: [12,23,1,8],
        2021: [12,23,1,8],
        2022: [12,23,1,6],
        2023: [12,23,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,27,1,6],
        2029: [12,21,1,5],
      },
      {
        name: "Tag vor dem 1. Mai",
        2029: [4,30,4,30],
      },
      {
        name: "Tage nach dem 3. Oktober",
        2029: [10,4,10,5],
      },
    ]
  },
  "Hamburg": {
    "_state_code": "hh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Hamburg&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,30],
        2013: [2,1,2,1],
        2014: [1,31,1,31],
        2015: [1,30,1,30],
        2016: [1,29,1,29],
        2017: [1,30,1,30],
        2018: [2,2,2,2],
        2019: [2,1,2,1],
      },
      {
        name: "Osterferien",
        2012: [3,5,3,16],
        2013: [3,4,3,15],
        2014: [3,3,3,14],
        2015: [3,2,3,13],
        2016: [3,7,3,18],
        2017: [3,6,3,17],
        2018: [4,30,4,30],
        2019: [3,4,3,15],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,2,5,10],
        2014: [5,30,5,30],
        2015: [5,11,5,15],
        2016: [5,17,5,20],
        2017: [5,22,5,26],
        2018: [5,7,5,11],
        2019: [5,31,5,31],
        2020: [5,18,5,22],
        2021: [5,10,5,14],
        2022: [5,23,5,27],
        2023: [5,15,5,19],
        2024: [5,21,5,24],
        2025: [5,26,5,30],
        2026: [5,11,5,15],
        2027: [5,7,5,14],
        2028: [5,22,5,26],
        2029: [5,11,5,18],
        2030: [5,20,5,24],
      },
      {
        name: "Sommerferien",
        2012: [6,21,8,1],
        2013: [6,20,7,31],
        2014: [7,10,8,20],
        2015: [7,16,8,26],
        2016: [7,21,8,31],
        2017: [7,20,8,30],
        2018: [7,5,8,15],
        2019: [6,27,8,7],
        2020: [6,25,8,5],
        2021: [6,24,8,4],
        2022: [7,7,8,17],
        2023: [7,13,8,23],
        2024: [7,18,8,28],
        2025: [7,24,9,3],
        2026: [7,9,8,19],
        2027: [7,1,8,11],
        2028: [7,3,8,11],
        2029: [7,2,8,10],
        2030: [7,4,8,14],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,12],
        2013: [9,30,10,11],
        2014: [10,13,10,24],
        2015: [10,19,10,30],
        2016: [10,17,10,28],
        2017: [10,16,10,27],
        2018: [10,1,10,12],
        2019: [10,4,10,18],
        2020: [10,5,10,16],
        2021: [10,4,10,15],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,21,11,1],
        2025: [10,20,10,31],
        2026: [10,19,10,30],
        2027: [10,11,10,22],
        2028: [10,2,10,13],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,27,1,6],
        2012: [12,21,1,4],
        2013: [12,19,1,3],
        2014: [12,22,1,6],
        2015: [12,21,1,1],
        2016: [12,27,1,6],
        2017: [12,22,1,5],
        2018: [12,20,1,4],
        2019: [12,20,1,3],
        2020: [12,21,1,4],
        2021: [12,23,1,4],
        2022: [12,23,1,6],
        2023: [12,22,1,5],
        2024: [12,20,1,3],
        2025: [12,17,1,2],
        2026: [12,21,1,1],
        2027: [12,20,12,31],
        2028: [12,18,12,29],
        2029: [12,21,1,4],
      },
      {
        name: "Halbjahrespause",
        2020: [1,31,1,31],
        2021: [1,29,1,29],
        2022: [1,28,1,28],
        2023: [1,27,1,27],
        2024: [2,2,2,2],
        2025: [1,31,1,31],
        2026: [1,30,1,30],
        2027: [1,29,1,29],
        2028: [1,28,1,28],
        2029: [2,2,2,2],
        2030: [2,1,2,1],
      },
      {
        name: "Frühjahrsferien",
        2020: [3,2,3,13],
        2021: [3,1,3,12],
        2022: [3,7,3,18],
        2023: [3,6,3,17],
        2024: [3,18,3,28],
        2025: [3,10,3,21],
        2026: [3,2,3,13],
        2027: [3,1,3,12],
        2028: [3,6,3,17],
        2029: [3,5,3,16],
        2030: [3,4,3,15],
      },
      {
        name: "Brückentag",
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,2,5,2],
        2028: [10,30,10,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Hessen": {
    "_state_code": "he",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Hessen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,29,4,9],
        2017: [4,3,4,15],
        2018: [3,26,4,7],
        2019: [4,14,4,27],
        2020: [4,6,4,18],
        2021: [4,6,4,16],
        2022: [4,11,4,23],
        2023: [4,3,4,22],
        2024: [3,25,4,13],
        2025: [4,7,4,21],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,3,4,14],
        2029: [3,29,4,13],
        2030: [4,8,4,22],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,10],
        2013: [7,8,8,16],
        2014: [7,28,9,5],
        2015: [7,27,9,4],
        2016: [7,18,8,26],
        2017: [7,3,8,11],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,15],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,15,10,27],
        2013: [10,14,10,26],
        2014: [10,20,11,1],
        2015: [10,19,10,31],
        2016: [10,17,10,29],
        2017: [10,9,10,21],
        2018: [10,1,10,13],
        2019: [9,30,10,12],
        2020: [10,5,10,17],
        2021: [10,11,10,23],
        2022: [10,24,10,29],
        2023: [10,23,10,28],
        2024: [10,14,10,25],
        2025: [10,6,10,18],
        2026: [10,5,10,17],
        2027: [10,4,10,16],
        2028: [10,9,10,20],
        2029: [10,15,10,26],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,21,1,6],
        2012: [12,24,1,12],
        2013: [12,23,1,11],
        2014: [12,22,1,10],
        2015: [12,23,1,9],
        2016: [12,22,1,7],
        2017: [12,24,1,13],
        2018: [12,24,1,12],
        2019: [12,23,1,11],
        2020: [12,21,1,9],
        2021: [12,23,1,8],
        2022: [12,22,1,7],
        2023: [12,27,1,13],
        2024: [12,23,1,10],
        2025: [12,22,1,10],
        2026: [12,23,1,12],
        2027: [12,23,1,11],
        2028: [12,27,1,12],
        2029: [12,24,1,11],
      },
    ]
  },
  "Mecklenburg-Vorpommern": {
    "_state_code": "mv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Mecklenburg-Vorpommern&zoom=18&addressdetails=1&limit=1&accept-language=de,en"
  },
  "MV-ABS": {
    "_state_code": "mv-abs",
    SH: [
      {
        name: "Winterferien",
        2012: [2,6,2,17],
        2013: [2,4,2,15],
        2014: [2,3,2,15],
        2015: [2,2,2,14],
        2016: [2,1,2,13],
        2017: [2,6,2,18],
        2018: [2,5,2,16],
        2019: [2,4,2,15],
        2020: [2,10,2,21],
        2021: [2,6,2,18],
        2022: [2,5,2,17],
        2023: [2,6,2,18],
        2024: [2,5,2,16],
        2025: [2,3,2,14],
        2026: [2,9,2,20],
        2027: [2,8,2,19],
        2028: [2,5,2,17],
        2029: [2,5,2,16],
        2030: [2,4,2,15],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,11],
        2013: [3,25,4,3],
        2014: [4,14,4,23],
        2015: [3,30,4,8],
        2016: [3,21,3,30],
        2017: [4,10,4,19],
        2018: [3,26,4,4],
        2019: [4,15,4,24],
        2020: [4,6,4,15],
        2021: [3,29,4,7],
        2022: [4,11,4,20],
        2023: [4,3,4,12],
        2024: [3,25,4,3],
        2025: [4,14,4,23],
        2026: [3,30,4,8],
        2027: [3,24,4,2],
        2028: [4,12,4,21],
        2029: [3,28,4,6],
        2030: [4,17,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,25,5,29],
        2013: [5,17,5,21],
        2014: [6,6,6,10],
        2015: [5,22,5,26],
        2016: [5,14,5,17],
        2017: [6,2,6,6],
        2018: [5,18,5,22],
        2019: [6,7,6,11],
        2020: [5,29,6,2],
        2021: [5,21,5,25],
        2022: [6,3,6,7],
        2023: [5,26,5,30],
        2024: [5,17,5,21],
        2025: [6,6,6,10],
        2026: [5,22,5,26],
        2027: [5,14,5,18],
        2028: [6,2,6,6],
        2029: [5,18,5,22],
        2030: [6,7,6,11],
      },
      {
        name: "Sommerferien",
        2012: [6,23,8,4],
        2013: [6,22,8,3],
        2014: [7,14,8,23],
        2015: [7,20,8,29],
        2016: [7,25,9,3],
        2017: [7,24,9,2],
        2018: [7,9,8,18],
        2019: [7,1,8,10],
        2020: [6,22,8,1],
        2021: [6,21,7,31],
        2022: [7,4,8,13],
        2023: [7,17,8,26],
        2024: [7,22,8,31],
        2025: [7,28,9,6],
        2026: [7,13,8,22],
        2027: [7,5,8,14],
        2028: [6,26,8,5],
        2029: [6,18,7,28],
        2030: [7,1,8,10],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,5],
        2013: [10,14,10,19],
        2014: [10,20,10,25],
        2015: [10,24,10,30],
        2016: [10,24,10,28],
        2017: [10,23,10,30],
        2018: [11,1,11,2],
        2019: [11,1,11,1],
        2020: [10,5,10,10],
        2021: [10,2,10,9],
        2022: [10,10,10,14],
        2023: [10,9,10,14],
        2024: [10,21,10,26],
        2025: [10,20,10,24],
        2026: [10,15,10,24],
        2027: [10,14,10,23],
        2028: [10,23,10,28],
        2029: [10,22,10,27],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,21,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,21,1,2],
        2016: [12,22,1,2],
        2017: [12,21,1,3],
        2018: [12,24,1,5],
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,22,12,31],
        2022: [12,22,1,2],
        2023: [12,21,1,3],
        2024: [12,23,1,6],
        2025: [12,20,1,3],
        2026: [12,21,1,2],
        2027: [12,22,1,4],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Zusätzlicher Ferientag",
        2020: [11,3,11,3],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,1,11,1],
        2024: [11,1,11,1],
        2025: [11,3,11,3],
        2026: [11,27,11,27],
        2027: [11,26,11,26],
        2028: [10,30,10,30],
        2029: [10,30,10,30],
        2030: [5,31,5,31],
      },
      {
        name: "Schulfrei",
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2028: [2,18,2,18],
      },
    ]
  },
  "MV-BBS": {
    "_state_code": "mv-bbs",
    SH: [
      {
        name: "Winterferien",
        2020: [2,10,2,15],
        2021: [2,5,2,13],
        2022: [2,5,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,5,2,12],
        2029: [2,5,2,10],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2020: [4,6,4,17],
        2021: [3,29,4,9],
        2022: [4,11,4,22],
        2023: [4,3,4,15],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,12,4,21],
        2029: [3,28,4,6],
        2030: [4,17,4,26],
      },
      {
        name: "Sommerferien",
        2020: [7,13,8,29],
        2021: [7,12,8,28],
        2022: [7,11,8,27],
        2023: [7,17,9,1],
        2024: [7,15,8,31],
        2025: [7,14,8,30],
        2026: [7,13,8,29],
        2027: [7,12,8,28],
        2028: [7,17,9,2],
        2029: [7,16,9,1],
        2030: [7,15,8,31],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,10],
        2021: [10,2,10,9],
        2022: [10,10,10,15],
        2023: [10,9,10,14],
        2024: [10,21,10,26],
        2025: [10,20,10,25],
        2026: [10,19,10,24],
        2027: [10,16,10,23],
        2028: [10,23,10,28],
        2029: [10,22,10,27],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,22,1,3],
        2022: [12,22,1,2],
        2023: [12,21,1,3],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
        2026: [12,19,1,2],
        2027: [12,22,12,31],
        2028: [12,21,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Zusätzlicher Ferientag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [10,28,10,28],
        2023: [10,30,10,30],
        2024: [11,1,11,1],
        2025: [11,3,11,3],
        2026: [11,27,11,27],
        2027: [11,26,11,26],
        2028: [10,30,10,30],
        2029: [10,30,10,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Niedersachsen": {
    "_state_code": "ni",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Niedersachsen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,31],
        2013: [1,31,2,1],
        2014: [1,30,1,31],
        2015: [2,2,2,3],
        2016: [1,28,1,29],
        2017: [1,30,1,31],
        2018: [2,1,2,2],
        2019: [1,31,2,1],
      },
      {
        name: "Halbjahresferien",
        2020: [2,3,2,4],
        2021: [2,1,2,2],
        2022: [1,31,2,1],
        2023: [1,30,1,31],
        2024: [2,1,2,2],
        2025: [2,3,2,4],
        2026: [2,2,2,3],
        2027: [2,1,2,2],
        2028: [1,31,2,1],
        2029: [2,1,2,2],
        2030: [1,31,2,1],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,16,4,2],
        2014: [5,2,5,2],
        2015: [3,25,4,10],
        2016: [3,18,4,2],
        2017: [4,10,4,22],
        2018: [3,19,4,3],
        2019: [4,8,4,23],
        2020: [3,30,4,14],
        2021: [3,29,4,9],
        2022: [4,4,4,19],
        2023: [3,27,4,11],
        2024: [3,18,3,28],
        2025: [4,7,4,19],
        2026: [3,23,4,7],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,19,4,3],
        2030: [4,8,4,23],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2020: [6,2,6,2],
        2021: [5,25,5,25],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2028: [6,6,6,6],
        2029: [5,22,5,22],
        2030: [6,11,6,11],
      },
      {
        name: "Tag nach Himmelfahrt",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [6,27,8,7],
        2014: [7,31,9,10],
        2015: [7,23,9,2],
        2016: [6,23,8,3],
        2017: [6,22,8,2],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,3],
        2025: [7,3,8,13],
        2026: [7,2,8,12],
        2027: [7,8,8,18],
        2028: [7,20,8,30],
        2029: [7,19,8,29],
        2030: [7,11,8,21],
      },
      {
        name: "Tag vor dem 3. Oktober",
        2023: [10,2,10,2],
        2028: [10,2,10,2],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,4,10,18],
        2014: [10,27,11,8],
        2015: [10,19,10,31],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,12],
        2019: [10,4,10,18],
        2020: [10,12,10,23],
        2021: [10,18,10,29],
        2022: [10,17,10,28],
        2023: [10,16,10,30],
        2024: [10,4,10,19],
        2025: [10,13,10,25],
        2026: [10,12,10,24],
        2027: [10,16,10,30],
        2028: [10,23,11,4],
        2029: [10,22,11,2],
      },
      {
        name: "Tag nach dem Reformationstag",
        2024: [11,1,11,1],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,23,1,3],
        2014: [12,22,1,5],
        2015: [12,23,1,6],
        2016: [12,21,1,6],
        2017: [12,22,1,5],
        2018: [12,24,1,4],
        2019: [12,23,1,6],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,27,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,27,1,6],
        2029: [12,21,1,5],
      },
      {
        name: "Kirchentag",
        2025: [4,30,4,30],
      },
      {
        name: "Tag nach dem 1. Mai",
        2025: [5,2,5,2],
      },
      {
        name: "Tag vor dem 1. Mai",
        2029: [4,30,4,30],
      },
      {
        name: "Tage nach dem 3. Oktober",
        2029: [10,4,10,5],
      },
    ]
  },
  "Nordrhein-Westfalen": {
    "_state_code": "nw",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Nordrhein-Westfalen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,21,4,2],
        2017: [4,10,4,22],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,14,4,26],
        2026: [3,30,4,11],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,26,4,7],
        2030: [4,15,4,27],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,25],
        2019: [6,11,6,11],
        2020: [6,2,6,2],
        2021: [5,25,5,25],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2029: [5,22,5,22],
      },
      {
        name: "Sommerferien",
        2012: [7,9,8,21],
        2013: [7,22,9,3],
        2014: [7,7,8,19],
        2015: [6,29,8,11],
        2016: [7,11,8,23],
        2017: [7,17,8,29],
        2018: [7,16,8,28],
        2019: [7,15,8,27],
        2020: [6,29,8,11],
        2021: [7,5,8,17],
        2022: [6,27,8,9],
        2023: [6,22,8,4],
        2024: [7,8,8,20],
        2025: [7,14,8,26],
        2026: [7,20,9,1],
        2027: [7,19,8,31],
        2028: [7,10,8,22],
        2029: [7,2,8,14],
        2030: [6,24,8,6],
      },
      {
        name: "Herbstferien",
        2012: [10,8,10,20],
        2013: [10,21,11,2],
        2014: [10,6,10,18],
        2015: [10,5,10,17],
        2016: [10,10,10,21],
        2017: [10,23,11,4],
        2018: [10,15,10,27],
        2019: [10,14,10,26],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,4,10,15],
        2023: [10,2,10,14],
        2024: [10,14,10,26],
        2025: [10,13,10,25],
        2026: [10,17,10,31],
        2027: [10,23,11,6],
        2028: [10,23,11,4],
        2029: [10,15,10,27],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,6],
        2012: [12,21,1,4],
        2013: [12,23,1,7],
        2014: [12,22,1,6],
        2015: [12,23,1,6],
        2016: [12,23,1,6],
        2017: [12,27,1,6],
        2018: [12,21,1,4],
        2019: [12,23,1,6],
        2020: [12,21,1,6],
        2021: [12,24,1,8],
        2022: [12,23,1,6],
        2023: [12,21,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
        2026: [12,23,1,6],
        2027: [12,24,1,8],
        2028: [12,21,1,5],
        2029: [12,20,1,4],
      },
    ]
  },
  "Rheinland-Pfalz": {
    "_state_code": "rp",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Rheinland-Pfalz&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2019: [2,25,3,1],
        2020: [2,17,2,21],
        2022: [2,21,2,25],
      },
      {
        name: "Osterferien",
        2012: [3,29,4,13],
        2013: [3,20,4,5],
        2014: [4,11,4,25],
        2015: [3,26,4,10],
        2016: [3,18,4,1],
        2017: [4,10,4,21],
        2018: [3,26,4,6],
        2019: [4,23,4,30],
        2020: [4,9,4,17],
        2021: [3,29,4,6],
        2022: [4,13,4,22],
        2023: [4,3,4,6],
        2024: [3,25,4,2],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,30],
      },
      {
        name: "Pfingstferien",
        2021: [5,25,6,2],
        2023: [5,30,6,7],
        2024: [5,21,5,29],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,10],
        2013: [7,8,8,16],
        2014: [7,28,9,5],
        2015: [7,27,9,4],
        2016: [7,18,8,26],
        2017: [7,3,8,11],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,15],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,12],
        2013: [10,4,10,18],
        2014: [10,20,10,31],
        2015: [10,19,10,30],
        2016: [10,10,10,21],
        2017: [10,2,10,13],
        2018: [10,1,10,12],
        2019: [9,30,10,11],
        2020: [10,12,10,23],
        2021: [10,11,10,22],
        2022: [10,17,10,31],
        2023: [10,16,10,27],
        2024: [10,14,10,25],
        2025: [10,13,10,24],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
        2028: [10,9,10,20],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,22,1,6],
        2012: [12,20,1,4],
        2013: [12,23,1,7],
        2014: [12,22,1,7],
        2015: [12,23,1,8],
        2016: [12,22,1,6],
        2017: [12,22,1,9],
        2018: [12,20,1,4],
        2019: [12,23,1,6],
        2020: [12,21,12,31],
        2021: [12,23,12,31],
        2022: [12,23,1,2],
        2023: [12,27,1,5],
        2024: [12,23,1,8],
        2025: [12,22,1,7],
        2026: [12,23,1,8],
        2027: [12,23,1,7],
        2028: [12,21,1,8],
        2029: [12,24,1,9],
      },
    ]
  },
  "Saarland": {
    "_state_code": "sl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Saarland&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [2,20,2,25],
        2013: [2,11,2,16],
        2014: [3,3,3,8],
        2015: [2,16,2,21],
        2016: [2,8,2,13],
        2017: [2,27,3,4],
        2018: [2,12,2,17],
        2019: [2,25,3,5],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,29,4,9],
        2017: [4,10,4,22],
        2018: [3,26,4,6],
        2019: [4,17,4,26],
        2020: [4,14,4,24],
        2021: [3,29,4,7],
        2022: [4,14,4,22],
        2023: [4,3,4,12],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [4,7,4,17],
        2027: [3,30,4,9],
        2028: [4,12,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2021: [5,25,5,28],
        2022: [6,7,6,10],
        2023: [5,30,6,2],
        2024: [5,21,5,24],
        2029: [5,22,5,25],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,14],
        2013: [7,8,8,17],
        2014: [7,28,9,6],
        2015: [7,27,9,5],
        2016: [7,18,8,27],
        2017: [7,3,8,14],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,14],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,21,11,2],
        2014: [10,20,10,31],
        2015: [10,19,10,31],
        2016: [10,10,10,22],
        2017: [10,2,10,14],
        2018: [10,1,10,12],
        2019: [10,7,10,18],
        2020: [10,12,10,23],
        2021: [10,18,10,29],
        2022: [10,24,11,4],
        2023: [10,23,11,3],
        2024: [10,14,10,25],
        2025: [10,13,10,24],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
        2028: [10,9,10,20],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,20,1,4],
        2014: [12,22,1,7],
        2015: [12,21,1,2],
        2016: [12,19,12,31],
        2017: [12,21,1,5],
        2018: [12,20,1,4],
        2019: [12,23,1,3],
        2020: [12,21,12,31],
        2021: [12,23,1,3],
        2022: [12,22,1,4],
        2023: [12,21,1,2],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,12,31],
        2027: [12,20,12,31],
        2028: [12,20,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Fastnachtsferien",
        2020: [2,17,2,25],
        2021: [2,15,2,19],
        2022: [2,21,3,1],
        2023: [2,20,2,24],
        2024: [2,12,2,16],
        2025: [2,24,3,4],
        2026: [2,16,2,20],
        2027: [2,8,2,12],
        2028: [2,21,2,29],
        2029: [2,12,2,16],
        2030: [2,25,3,5],
      },
    ]
  },
  "Sachsen": {
    "_state_code": "sn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Sachsen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [2,13,2,25],
        2013: [2,4,2,15],
        2014: [2,17,3,1],
        2015: [2,9,2,21],
        2016: [2,8,2,20],
        2017: [2,13,2,24],
        2018: [2,12,2,23],
        2019: [2,18,3,2],
        2020: [2,10,2,22],
        2021: [1,31,2,6],
        2022: [2,12,2,26],
        2023: [2,13,2,24],
        2024: [2,12,2,23],
        2025: [2,17,3,1],
        2026: [2,9,2,21],
        2027: [2,8,2,19],
        2028: [2,14,2,26],
        2029: [2,5,2,16],
        2030: [2,18,3,1],
      },
      {
        name: "Osterferien",
        2012: [4,6,4,14],
        2013: [3,29,4,6],
        2014: [4,18,4,26],
        2015: [4,2,4,11],
        2016: [3,25,4,2],
        2017: [4,13,4,22],
        2018: [3,29,4,6],
        2019: [4,19,4,26],
        2020: [4,10,4,18],
        2021: [3,27,4,10],
        2022: [4,15,4,23],
        2023: [4,7,4,15],
        2024: [3,28,4,5],
        2025: [4,18,4,25],
        2026: [4,3,4,10],
        2027: [3,26,4,2],
        2028: [4,14,4,22],
        2029: [3,29,4,6],
        2030: [4,19,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,18,5,22],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,19,5,22],
        2019: [5,31,5,31],
        2024: [5,18,5,21],
        2027: [5,15,5,18],
        2029: [5,19,5,22],
        2030: [6,8,6,11],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [7,15,8,23],
        2014: [7,21,8,29],
        2015: [7,13,8,21],
        2016: [6,27,8,5],
        2017: [6,26,8,4],
        2018: [7,2,8,10],
        2019: [7,8,8,16],
        2020: [7,20,8,28],
        2021: [7,26,9,3],
        2022: [7,18,8,26],
        2023: [7,10,8,18],
        2024: [6,20,8,2],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,2],
        2013: [10,21,11,1],
        2014: [10,20,10,31],
        2015: [10,12,10,24],
        2016: [10,3,10,15],
        2017: [10,30,10,30],
        2018: [10,8,10,20],
        2019: [10,14,10,25],
        2020: [10,19,10,31],
        2021: [10,18,10,30],
        2022: [10,17,10,29],
        2023: [10,2,10,14],
        2024: [10,7,10,19],
        2025: [10,6,10,18],
        2026: [10,12,10,24],
        2027: [10,11,10,23],
        2028: [10,23,11,3],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,2],
        2012: [12,22,1,2],
        2013: [12,21,1,3],
        2014: [12,22,1,3],
        2015: [12,21,1,2],
        2016: [12,23,1,2],
        2017: [12,23,1,2],
        2018: [12,22,1,4],
        2019: [12,21,1,3],
        2020: [12,19,1,2],
        2021: [12,23,1,1],
        2022: [12,22,1,2],
        2023: [12,23,1,2],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,23,1,1],
        2028: [12,23,1,3],
        2029: [12,22,1,4],
      },
      {
        name: "Unterrichtsfreier Tag",
        2022: [5,27,5,27],
        2023: [10,30,10,30],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Sachsen-Anhalt": {
    "_state_code": "st",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Sachsen-Anhalt&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [2,4,2,11],
        2013: [2,1,2,8],
        2014: [2,1,2,12],
        2015: [2,2,2,14],
        2016: [2,1,2,10],
        2017: [2,4,2,11],
        2018: [2,5,2,9],
        2019: [2,11,2,15],
        2020: [2,10,2,14],
        2021: [2,8,2,13],
        2022: [2,12,2,19],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [1,27,1,31],
        2026: [1,31,2,6],
        2027: [2,1,2,6],
        2028: [2,7,2,12],
        2029: [2,5,2,10],
        2030: [2,4,2,8],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,7],
        2013: [3,25,3,30],
        2014: [4,14,4,17],
        2015: [4,2,4,2],
        2016: [3,24,3,24],
        2017: [4,10,4,13],
        2018: [4,30,4,30],
        2019: [4,18,4,30],
        2020: [4,6,4,11],
        2021: [3,29,4,3],
        2022: [4,11,4,16],
        2023: [4,3,4,8],
        2024: [3,25,3,30],
        2025: [4,7,4,19],
        2026: [3,30,4,4],
        2027: [3,22,3,27],
        2028: [4,10,4,22],
        2029: [3,26,3,31],
        2030: [4,8,4,20],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,25],
        2013: [5,10,5,18],
        2014: [5,30,6,7],
        2015: [5,15,5,23],
        2016: [5,6,5,14],
        2017: [5,26,5,26],
        2018: [5,11,5,19],
        2019: [5,31,6,1],
        2020: [5,18,5,30],
        2021: [5,10,5,22],
        2022: [5,23,5,28],
        2023: [5,15,5,19],
        2024: [5,21,5,24],
        2026: [5,26,5,29],
        2027: [5,15,5,22],
        2028: [6,3,6,10],
        2029: [5,11,5,25],
        2030: [6,3,6,8],
      },
      {
        name: "Sommerferien",
        2012: [7,23,9,5],
        2013: [7,15,8,28],
        2014: [7,21,9,3],
        2015: [7,13,8,26],
        2016: [6,27,8,10],
        2017: [6,26,8,9],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,3],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,2],
        2013: [10,21,10,25],
        2014: [10,27,10,30],
        2015: [10,17,10,24],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,12],
        2019: [11,1,11,1],
        2020: [10,19,10,24],
        2021: [10,25,10,30],
        2022: [10,24,11,4],
        2023: [10,16,10,30],
        2024: [9,30,10,12],
        2025: [10,13,10,25],
        2026: [10,19,10,30],
        2027: [10,18,10,23],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,22,1,7],
        2012: [12,19,1,4],
        2013: [12,21,1,3],
        2014: [12,22,1,5],
        2015: [12,21,1,5],
        2016: [12,19,1,2],
        2017: [12,21,1,3],
        2018: [12,19,1,4],
        2019: [12,23,1,4],
        2020: [12,21,1,10],
        2021: [12,22,1,8],
        2022: [12,21,1,5],
        2023: [12,21,1,3],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,21,1,2],
        2027: [12,20,12,31],
        2028: [12,21,1,2],
        2029: [12,21,1,5],
      },
      {
        name: "Ferientag",
        2023: [10,2,10,2],
        2024: [11,1,11,1],
        2025: [5,30,5,30],
        2028: [10,2,10,2],
        2029: [4,30,4,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Schleswig-Holstein": {
    "_state_code": "sh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Schleswig-Holstein&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Osterferien",
        2011: [4,15,4,30],
        2012: [3,30,4,13],
        2013: [3,25,4,9],
        2014: [4,16,5,2],
        2015: [4,1,4,17],
        2016: [3,24,4,9],
        2017: [4,7,4,21],
        2018: [3,29,4,13],
        2019: [4,4,4,18],
        2020: [3,30,4,17],
        2021: [4,1,4,16],
        2022: [4,4,4,16],
        2023: [4,6,4,22],
        2024: [4,2,4,19],
        2025: [4,11,4,25],
        2026: [3,26,4,10],
        2027: [3,30,4,10],
        2028: [4,3,4,15],
        2029: [3,23,4,6],
        2030: [4,8,4,20],
        2031: [3,28,4,10],
      },
      {
        name: "Sommerferien",
        2011: [7,4,8,13],
        2012: [6,25,8,4],
        2013: [6,24,8,3],
        2014: [7,14,8,23],
        2015: [7,20,8,29],
        2016: [7,25,9,3],
        2017: [7,24,9,2],
        2018: [7,9,8,18],
        2019: [7,1,8,10],
        2020: [6,29,8,8],
        2021: [6,21,7,31],
        2022: [7,4,8,13],
        2023: [7,17,8,26],
        2024: [7,22,8,31],
        2025: [7,28,9,6],
        2026: [7,4,8,15],
        2027: [7,3,8,14],
        2028: [6,24,8,4],
        2029: [6,23,8,3],
        2030: [7,8,8,17],
      },
      {
        name: "Herbstferien",
        2011: [10,10,10,22],
        2012: [10,4,10,19],
        2013: [10,4,10,18],
        2014: [10,13,10,25],
        2015: [10,19,10,31],
        2016: [10,17,10,29],
        2017: [10,16,10,27],
        2018: [10,1,10,19],
        2019: [10,4,10,18],
        2020: [10,5,10,17],
        2021: [10,4,10,16],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,21,11,1],
        2025: [10,20,10,30],
        2026: [10,12,10,24],
        2027: [10,11,10,23],
        2028: [10,16,10,30],
        2029: [10,8,10,19],
        2030: [10,14,10,25],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,6],
        2012: [12,24,1,5],
        2013: [12,23,1,6],
        2014: [12,22,1,6],
        2015: [12,21,1,6],
        2016: [12,23,1,6],
        2017: [12,21,1,6],
        2018: [12,21,1,4],
        2019: [12,23,1,6],
        2020: [12,21,1,6],
        2021: [12,23,1,8],
        2022: [12,23,1,7],
        2023: [12,27,1,6],
        2024: [12,19,1,7],
        2025: [12,19,1,6],
        2026: [12,21,1,6],
        2027: [12,23,1,8],
        2028: [12,21,1,5],
        2029: [12,21,1,8],
        2030: [12,20,1,6],
      },
      {
        name: "Himmelfahrt",
        2011: [6,3,6,4],
        2012: [5,18,5,18],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
        2020: [5,22,5,22],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,19,5,20],
        2024: [5,10,5,11],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
      },
    ]
  },
  "Thüringen": {
    "_state_code": "th",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Deutschland&state=Th%C3%BCringen&zoom=18&addressdetails=1&limit=1&accept-language=de,en",
    SH: [
      {
        name: "Winterferien",
        2012: [2,6,2,11],
        2013: [2,18,2,23],
        2014: [2,17,2,22],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [2,6,2,11],
        2018: [2,5,2,9],
        2019: [2,11,2,15],
        2020: [2,10,2,14],
        2021: [1,25,1,30],
        2022: [2,12,2,19],
        2023: [2,13,2,17],
        2024: [2,12,2,16],
        2025: [2,3,2,8],
        2026: [2,16,2,21],
        2027: [2,1,2,6],
        2028: [2,7,2,12],
        2029: [2,12,2,17],
        2030: [2,11,2,16],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,13],
        2013: [3,25,4,6],
        2014: [4,19,5,2],
        2015: [3,30,4,11],
        2016: [3,24,4,2],
        2017: [4,10,4,21],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,7,4,19],
        2026: [4,7,4,17],
        2027: [3,22,4,3],
        2028: [4,3,4,15],
        2029: [3,26,4,7],
        2030: [4,8,4,20],
      },
      {
        name: "Pfingstferien",
        2012: [5,25,5,29],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [7,15,8,23],
        2014: [7,21,8,29],
        2015: [7,13,8,21],
        2016: [6,27,8,10],
        2017: [6,26,8,9],
        2018: [7,2,8,11],
        2019: [7,8,8,17],
        2020: [7,20,8,29],
        2021: [7,26,9,4],
        2022: [7,18,8,27],
        2023: [7,10,8,19],
        2024: [6,20,7,31],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,21,11,2],
        2014: [10,6,10,18],
        2015: [10,5,10,17],
        2016: [10,10,10,22],
        2017: [10,2,10,14],
        2018: [10,1,10,13],
        2019: [10,7,10,19],
        2020: [10,17,10,30],
        2021: [10,25,11,6],
        2022: [10,17,10,29],
        2023: [10,2,10,14],
        2024: [9,30,10,12],
        2025: [10,6,10,18],
        2026: [10,12,10,24],
        2027: [10,9,10,23],
        2028: [10,23,11,3],
        2029: [10,22,11,3],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,1],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,22,1,3],
        2015: [12,23,1,2],
        2016: [12,23,12,31],
        2017: [12,22,1,5],
        2018: [12,21,1,4],
        2019: [12,21,1,3],
        2020: [12,23,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,3],
        2023: [12,22,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,3],
        2026: [12,23,1,2],
        2027: [12,23,12,31],
        2028: [12,23,1,5],
        2029: [12,22,1,4],
      },
      {
        name: "Schulfreier Tag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const dk = {
  PH: [{"name":"Nytårsdag","fixed_date":[1,1]},{"name":"Skærtorsdag","variable_date":"easter","offset":-3},{"name":"Langfredag","variable_date":"easter","offset":-2},{"name":"Påskedag","variable_date":"easter"},{"name":"Anden påskedag","variable_date":"easter","offset":1},{"name":"Kristi Himmelfartsdag","variable_date":"easter","offset":39},{"name":"Pinsedag","variable_date":"easter","offset":49},{"name":"Anden Pinsedag","variable_date":"easter","offset":50},{"name":"Grundlovsdag","fixed_date":[6,5]},{"name":"Juleaftensdag","fixed_date":[12,24]},{"name":"Juledag","fixed_date":[12,25]},{"name":"Anden Juledag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.670249&lon=10.3333283&zoom=18&addressdetails=1&accept-language=da,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ee = {
  PH: [{"name":"uusaasta","fixed_date":[1,1]},{"name":"iseseisvuspäev","fixed_date":[2,24]},{"name":"suur reede","variable_date":"easter","offset":-2},{"name":"lihavõtted","variable_date":"easter"},{"name":"kevadpüha","fixed_date":[5,1]},{"name":"nelipühade 1. püha","variable_date":"easter","offset":49},{"name":"võidupüha","fixed_date":[6,23]},{"name":"jaanipäev","fixed_date":[6,24]},{"name":"taasiseseisvumispäev","fixed_date":[8,20]},{"name":"jõululaupäev","fixed_date":[12,24]},{"name":"esimene jõulupüha","fixed_date":[12,25]},{"name":"teine jõulupüha","fixed_date":[12,26]}],
  SH: [
    {
      name: "jõulupühad",
      2019: [12,23,1,5],
      2020: [12,23,1,10],
      2021: [12,23,1,9],
      2022: [12,22,1,8],
      2023: [12,21,1,7],
      2024: [12,23,1,5],
      2025: [12,22,1,11],
      2026: [12,23,1,10],
    },
    {
      name: "talvepuhkus",
      2020: [2,24,3,1],
      2021: [2,22,2,28],
      2022: [2,28,3,6],
      2023: [2,27,3,5],
      2024: [2,26,3,3],
      2025: [2,24,3,2],
      2026: [2,23,3,1],
      2027: [2,22,2,28],
    },
    {
      name: "kevadpühad",
      2020: [4,20,4,26],
      2021: [4,19,4,25],
      2022: [4,25,5,1],
      2023: [4,24,4,30],
      2024: [4,22,4,28],
      2025: [4,14,4,20],
      2026: [4,13,4,19],
      2027: [4,12,4,18],
    },
    {
      name: "suvepuhkus",
      2020: [6,10,8,31],
      2021: [6,14,8,31],
      2022: [6,14,8,31],
      2023: [6,14,8,31],
      2024: [6,13,8,31],
      2025: [6,10,8,31],
      2026: [6,17,8,31],
      2027: [6,14,8,31],
    },
    {
      name: "sügispuhkus",
      2020: [10,19,10,25],
      2021: [10,25,10,31],
      2022: [10,24,10,30],
      2023: [10,23,10,29],
      2024: [10,21,10,27],
      2025: [10,20,10,26],
      2026: [10,26,11,1],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=59.4370&lon=24.7536&zoom=18&addressdetails=1&accept-language=et,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const es = {
  PH: [{"name":"Año Nuevo","fixed_date":[1,1]},{"name":"Día de los Reyes Magos","fixed_date":[1,6]},{"name":"Viernes Santo","variable_date":"easter","offset":-2},{"name":"Día del Trabajador","fixed_date":[5,1]},{"name":"Asunción","fixed_date":[8,15]},{"name":"Fiesta Nacional de España","fixed_date":[10,12]},{"name":"Todos los Santos","fixed_date":[11,1]},{"name":"Día de la Constitución Española","fixed_date":[12,6]},{"name":"La inmaculada concepción","fixed_date":[12,8]},{"name":"Navidad","fixed_date":[12,25],"substitute_rule":"if sunday then next monday"},{"name":"Día de Andalucía","fixed_date":[2,28],"substitute_rule":"if sunday then next monday","only_states":["Andalucía"]},{"name":"Día de les Illes Balears","fixed_date":[3,1],"substitute_rule":"if sunday then next monday","only_states":["Illes Balears"]},{"name":"San José","fixed_date":[3,19],"only_states":["Comunidad Foral de Navarra","Comunitat Valenciana","Galicia","País Vasco","Región de Murcia"]},{"name":"Jueves Santo","variable_date":"easter","offset":-3,"only_states":["Andalucía","Aragón","Asturias","Cantabria","Castilla y León","Castilla-La Mancha","Ceuta","Comunidad de Madrid","Comunidad Foral de Navarra","Extremadura","Galicia","Illes Balears","La Rioja","Melilla","País Vasco","Región de Murcia"]},{"name":"Lunes de Pascua","variable_date":"easter","offset":1,"only_states":["Cataluña","Comunidad Foral de Navarra","Comunitat Valenciana","Illes Balears","La Rioja","País Vasco"]},{"name":"Día de Aragón","fixed_date":[4,23],"substitute_rule":"if sunday then next monday","only_states":["Aragón"]},{"name":"Fiesta de Castilla y León","fixed_date":[4,23],"substitute_rule":"if sunday then next monday","only_states":["Castilla y León"]},{"name":"Día de la Comunidad de Madrid","fixed_date":[5,2],"shift_rule":"if sunday then next monday","only_states":["Comunidad de Madrid"]},{"name":"Día de las Letras Gallegas","fixed_date":[5,17],"only_states":["Galicia"]},{"name":"Día de Castilla-La Mancha","fixed_date":[5,31],"only_states":["Castilla-La Mancha"]},{"name":"Corpus Christi","variable_date":"easter","offset":60,"only_states":["Castilla-La Mancha"]},{"name":"Día de La Rioja","fixed_date":[6,9],"only_states":["La Rioja"]},{"name":"San Juan","fixed_date":[6,24],"only_states":["Cataluña","Comunitat Valenciana"]},{"name":"Día de las Instituciones de Cantabria","fixed_date":[6,28],"only_states":["Cantabria"]},{"name":"Día Nacional de Galicia","fixed_date":[7,25],"only_states":["Galicia"]},{"name":"Santiago Apóstol","fixed_date":[7,25],"only_states":["País Vasco"]},{"name":"Nuestra Señora de África","fixed_date":[8,5],"substitute_rule":"if sunday then next monday","only_states":["Ceuta"]},{"name":"Día de Ceuta","fixed_date":[9,2],"substitute_rule":"if sunday then next monday","only_states":["Ceuta"]},{"name":"Día de Asturias","fixed_date":[9,8],"substitute_rule":"if sunday then next monday","only_states":["Asturias"]},{"name":"Día de Extremadura","fixed_date":[9,8],"substitute_rule":"if sunday then next monday","only_states":["Extremadura"]},{"name":"Dia de Cataluña","fixed_date":[9,11],"only_states":["Cataluña"]},{"name":"La Bien Aparecida","fixed_date":[9,15],"substitute_rule":"if sunday then next monday","only_states":["Cantabria"]},{"name":"Nuestra Señora de la Merced","fixed_date":[9,24],"only_states":["Cataluña"]},{"name":"San Esteban","fixed_date":[12,26],"only_states":["Cataluña"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.60333&lon=2.18920&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
  "Almería": {
    "_state_code": "an-al",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Día no lectivo",
        2020: [12,23,12,23],
        2021: [12,23,12,23],
        2022: [12,7,12,7],
        2023: [12,22,12,22],
        2024: [12,23,12,23],
        2025: [12,23,12,23],
        2026: [5,4,5,4],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [2,27,2,27],
        2021: [3,2,3,2],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,5,4,12],
        2021: [3,28,4,4],
        2022: [4,10,4,17],
        2023: [4,2,4,9],
        2024: [3,23,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,23,9,11],
        2023: [6,23,9,10],
        2024: [6,22,9,9],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Andalucía": {
    "_state_code": "an",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Andaluc%C3%ADa&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast"
  },
  "Aragón": {
    "_state_code": "ar",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Arag%C3%B3n&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,20,1,6],
        2020: [12,22,1,6],
        2021: [12,23,1,7],
        2022: [12,22,1,6],
        2023: [12,22,1,5],
        2024: [12,20,1,6],
        2025: [12,20,1,6],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,13],
        2021: [3,29,4,2],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,28,4,5],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,6],
        2021: [6,23,9,10],
        2022: [6,23,9,10],
        2023: [6,24,9,6],
        2024: [6,25,9,8],
        2025: [6,25,9,11],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2025: [11,3,11,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Asturias": {
    "_state_code": "as",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Asturias&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,24,1,7],
        2022: [12,27,1,5],
        2023: [12,26,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [10,30,10,30],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [11,4,11,4],
        2026: [5,4,5,4],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,5],
        2022: [4,11,4,15],
        2023: [4,3,4,11],
        2024: [3,25,4,1],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,21],
        2021: [7,1,9,7],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,22,9,8],
        2025: [6,21,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Cádiz": {
    "_state_code": "an-ca",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [5,4,5,4],
        2023: [3,1,3,1],
        2024: [2,27,2,27],
        2025: [10,13,10,13],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [5,3,5,3],
        2022: [3,1,3,1],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,23,9,11],
        2023: [6,23,9,10],
        2024: [6,25,9,9],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Canarias": {
    "_state_code": "cn",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,14],
        2021: [6,24,9,8],
        2022: [6,24,9,8],
        2023: [6,24,9,10],
        2024: [6,22,9,9],
        2025: [6,21,9,8],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Cantabria": {
    "_state_code": "cb",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Cantabria&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "No lectivos",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,26,1,5],
        2024: [12,23,1,7],
        2025: [12,24,1,5],
        2026: [3,30,4,1],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Castilla y León": {
    "_state_code": "cl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Castilla+y+Le%C3%B3n&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,22,1,11],
        2021: [12,22,1,10],
        2022: [12,22,1,9],
        2023: [12,22,1,8],
        2024: [12,21,1,7],
        2025: [12,19,1,8],
      },
      {
        name: "Carnavales",
        2020: [2,24,2,25],
        2021: [2,15,2,16],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Día no lectivo",
        2020: [10,9,10,9],
        2021: [12,7,12,7],
        2022: [12,9,12,9],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
        2026: [4,24,4,24],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,3,4,14],
        2021: [3,25,4,6],
        2022: [4,6,4,18],
        2023: [3,29,4,10],
        2024: [3,22,4,3],
        2025: [4,12,4,22],
        2026: [3,26,4,7],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,8],
        2021: [6,24,9,9],
        2022: [6,24,9,8],
        2023: [6,24,9,6],
        2024: [6,22,9,5],
        2025: [6,24,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,24,6,24],
      },
    ]
  },
  "Castilla-La Mancha": {
    "_state_code": "cm",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Castilla-La+Mancha&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Descanso de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Días de libre disposición",
        2020: [2,24,2,25],
        2021: [2,15,2,15],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Día no lectivo",
        2020: [11,13,11,13],
        2021: [11,19,11,19],
        2022: [11,18,11,18],
        2023: [12,7,12,7],
        2024: [11,15,11,15],
        2025: [11,14,11,14],
        2026: [5,2,5,2],
      },
      {
        name: "Descanso de Semana Santa",
        2020: [4,6,4,13],
        2021: [3,29,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,26,9,8],
        2021: [6,29,9,8],
        2022: [6,25,9,7],
        2023: [6,24,9,10],
        2024: [6,22,9,8],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,17,6,17],
      },
    ]
  },
  "Cataluña": {
    "_state_code": "ct",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Catalu%C3%B1a&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast"
  },
  "Catalunya": {
    "_state_code": "ct",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,22,1,7],
        2021: [12,23,1,7],
        2022: [12,22,1,8],
        2023: [12,21,1,7],
        2024: [12,21,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,13],
        2021: [3,27,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,23,4,1],
        2025: [4,12,4,21],
        2026: [3,28,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,13],
        2021: [6,23,9,12],
        2022: [6,23,9,4],
        2023: [6,23,9,5],
        2024: [6,22,9,9],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Ceuta": {
    "_state_code": "ce",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Ceuta&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,25,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día de libre disposición",
        2020: [5,25,5,25],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [4,10,4,10],
        2025: [5,2,5,2],
      },
      {
        name: "Días de libre disposición",
        2020: [4,1,4,3],
        2022: [4,4,4,8],
        2023: [4,20,4,21],
        2024: [3,18,3,22],
        2025: [4,7,4,11],
        2026: [5,25,5,26],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,8],
        2021: [3,29,4,11],
        2022: [4,11,4,15],
        2023: [4,3,4,5],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,3],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,7],
        2023: [6,24,9,6],
        2024: [6,22,9,8],
        2025: [6,24,9,7],
      },
      {
        name: "Fin del Ramadán",
        2021: [5,13,5,14],
        2022: [5,3,5,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Comunidad de Madrid": {
    "_state_code": "md",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Comunidad+de+Madrid&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,6],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,20,1,6],
      },
      {
        name: "Día no lectivo",
        2020: [11,2,11,2],
        2021: [12,7,12,7],
        2022: [12,7,12,7],
        2023: [12,7,12,7],
        2024: [5,3,5,3],
        2025: [11,3,11,3],
        2026: [4,6,4,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,4,4,12],
        2021: [3,27,4,4],
        2022: [4,9,4,17],
        2023: [4,1,4,9],
        2024: [3,23,3,31],
        2025: [4,12,4,20],
        2026: [3,28,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,20],
        2021: [6,26,9,5],
        2022: [6,25,9,11],
        2023: [6,22,9,5],
        2024: [6,22,9,5],
        2025: [6,21,9,7],
      },
      {
        name: "Días de libre disposición",
        2020: [12,7,12,8],
        2021: [1,7,1,8],
        2024: [2,22,2,23],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Comunidad Foral de Navarra": {
    "_state_code": "nc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Comunidad+Foral+de+Navarra&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast"
  },
  "Comunitat Valenciana": {
    "_state_code": "vc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Comunitat+Valenciana&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,20],
        2021: [4,1,4,12],
        2022: [4,14,4,25],
        2023: [4,6,4,17],
        2024: [3,28,4,8],
        2025: [4,17,4,28],
        2026: [4,2,4,13],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,19,9,6],
        2021: [6,24,9,7],
        2022: [6,22,9,11],
        2023: [6,22,9,10],
        2024: [6,22,9,8],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Córdoba": {
    "_state_code": "an-co",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [2,27,2,27],
        2024: [2,27,2,27],
        2025: [2,27,2,27],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,5,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,23,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,23,9,1],
        2025: [6,25,8,31],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [3,1,3,1],
        2025: [5,2,5,2],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Euskal Herria": {
    "_state_code": "pv",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,13],
        2021: [4,1,4,5],
        2022: [4,14,4,18],
        2023: [4,6,4,10],
        2024: [3,28,4,1],
        2025: [4,17,4,21],
        2026: [4,2,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,7],
        2021: [6,19,9,7],
        2022: [6,22,9,7],
        2023: [6,22,9,6],
        2024: [6,22,9,29],
        2025: [5,16,9,4],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Extremadura": {
    "_state_code": "ex",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Extremadura&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,22,1,5],
        2024: [12,23,1,7],
        2025: [12,23,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [12,7,12,7],
        2021: [11,22,11,22],
        2022: [12,9,12,9],
        2023: [12,7,12,7],
        2024: [11,25,11,25],
        2025: [11,28,11,28],
      },
      {
        name: "Carnavales",
        2020: [2,24,2,25],
        2021: [2,15,2,16],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,6,4,13],
        2021: [3,29,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,18,9,9],
        2021: [6,19,9,9],
        2022: [6,22,9,11],
        2023: [6,23,9,10],
        2024: [6,21,9,10],
        2025: [6,24,9,10],
      },
      {
        name: "Día de la Comunitat Valenciana",
        2020: [10,9,10,9],
        2023: [10,9,10,9],
      },
      {
        name: "Fin de lecciones",
        2026: [7,23,7,23],
      },
    ]
  },
  "Galicia": {
    "_state_code": "ga",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Galicia&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,7],
        2021: [12,22,1,7],
        2022: [12,23,1,6],
        2023: [12,22,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,4,4,13],
        2021: [3,27,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,9],
        2021: [6,23,9,8],
        2022: [6,23,9,7],
        2023: [6,22,9,10],
        2024: [6,22,9,10],
        2025: [6,21,9,7],
      },
      {
        name: "Día de la Educación",
        2020: [12,7,12,7],
        2021: [10,11,10,11],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
      },
      {
        name: "Carnavales",
        2021: [2,24,2,26],
        2022: [2,28,3,2],
        2023: [2,20,2,22],
        2024: [2,12,2,14],
        2025: [3,3,4,5],
        2026: [2,16,2,18],
      },
      {
        name: "Día no lectivo",
        2025: [11,3,11,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Granada": {
    "_state_code": "an-gr",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [2,27,2,27],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,28,4,4],
        2022: [4,10,4,17],
        2023: [4,2,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Día no lectivo",
        2020: [5,4,5,4],
        2021: [12,7,12,7],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2024: [3,1,3,1],
        2025: [11,3,11,3],
        2026: [6,5,6,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,24,9,1],
        2025: [6,25,8,31],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Huelva": {
    "_state_code": "an-hl",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [11,2,11,2],
        2025: [3,3,3,3],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,1],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,11],
        2023: [6,24,9,10],
        2024: [6,26,9,9],
        2025: [6,25,9,9],
      },
      {
        name: "Día no lectivo",
        2025: [1,7,1,7],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Huesca": {
    "_state_code": "ar-hu",
    SH: [
      {
        name: "Día no lectivo",
        2020: [2,14,2,14],
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2023: [2,17,2,17],
        2024: [2,16,2,16],
        2025: [2,14,2,14],
        2026: [2,20,2,20],
      },
    ]
  },
  "Illes Balears": {
    "_state_code": "ib",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Illes+Balears&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,22,1,5],
        2024: [12,21,1,7],
        2025: [12,22,1,6],
      },
      {
        name: "Fiesta Escolar Unificada",
        2020: [2,28,2,28],
        2021: [2,26,2,26],
        2022: [2,28,2,28],
        2023: [2,28,2,28],
        2024: [2,29,2,29],
        2025: [2,28,2,28],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,8,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,22],
        2023: [4,6,4,14],
        2024: [3,28,4,5],
        2025: [4,17,4,27],
        2026: [4,2,4,12],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,11],
        2023: [6,24,9,10],
        2024: [6,22,9,10],
        2025: [6,28,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Islas Canarias": {
    "_state_code": "cn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Islas+Canarias&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast"
  },
  "Jaén": {
    "_state_code": "an-ja",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,10],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,25,1,7],
        2024: [12,23,1,7],
        2025: [12,23,1,7],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [5,3,5,3],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [3,3,3,3],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,12],
        2021: [3,27,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,24,9,9],
        2022: [6,24,9,11],
        2023: [6,23,9,10],
        2024: [6,24,9,1],
        2025: [6,25,9,1],
      },
      {
        name: "Día no lectivo",
        2023: [12,7,12,7],
        2025: [5,2,5,2],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "La Rioja": {
    "_state_code": "ri",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=La+Rioja&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,7],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [2,24,2,24],
        2021: [2,15,2,15],
        2022: [3,11,3,11],
        2023: [3,10,3,10],
        2024: [2,17,2,17],
        2025: [2,28,2,28],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,17],
        2021: [4,1,4,9],
        2022: [4,11,4,15],
        2023: [4,1,4,10],
        2024: [3,28,4,7],
        2025: [4,17,4,25],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,6],
        2021: [6,23,9,5],
        2022: [6,25,9,7],
        2023: [6,24,9,6],
        2024: [6,22,9,5],
        2025: [6,20,9,8],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [6,8,6,8],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Málaga": {
    "_state_code": "an-ma",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,25,1,5],
        2024: [12,23,1,5],
        2025: [12,22,1,5],
      },
      {
        name: "Semana Blanca",
        2020: [2,24,2,28],
        2021: [2,22,2,26],
        2022: [2,28,3,4],
        2023: [2,27,3,3],
        2024: [2,26,3,1],
        2025: [2,24,2,26],
        2026: [2,23,2,26],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,20],
        2026: [3,30,4,1],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,25,9,9],
        2021: [6,25,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,25,9,9],
        2025: [6,25,9,4],
      },
      {
        name: "Día de la Comunidad Educativa",
        2022: [1,7,1,7],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Melilla": {
    "_state_code": "ml",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Melilla&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,5],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,23,1,6],
        2024: [12,23,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Días de libre disposición",
        2020: [4,1,4,3],
        2021: [3,22,3,26],
        2022: [4,4,4,8],
        2023: [3,27,3,31],
        2024: [3,18,3,22],
        2025: [4,7,4,11],
        2026: [3,23,3,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,1],
      },
      {
        name: "Día de libre disposición",
        2020: [12,7,12,7],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [5,2,5,2],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,7],
        2021: [6,19,9,6],
        2022: [6,23,9,5],
        2023: [6,22,9,6],
        2024: [6,22,9,8],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Nafarroako Foru Komunitatea": {
    "_state_code": "nc",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,24],
        2023: [4,6,4,16],
        2024: [3,28,4,7],
        2025: [4,17,4,27],
        2026: [4,2,4,12],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,8],
        2021: [6,23,9,7],
        2022: [6,23,9,6],
        2023: [6,21,9,6],
        2024: [6,19,9,4],
        2025: [6,21,9,3],
      },
      {
        name: "Festividad patronal del nivel educativo",
        2020: [11,27,11,27],
        2022: [11,28,11,28],
        2023: [11,27,11,27],
        2024: [11,27,11,27],
        2025: [11,27,11,27],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "País Vasco": {
    "_state_code": "pv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Pa%C3%ADs+Vasco&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast"
  },
  "Región de Murcia": {
    "_state_code": "mc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Espa%C3%B1a&state=Regi%C3%B3n+de+Murcia&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,24,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,24,1,6],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,6],
        2021: [6,24,9,6],
        2022: [6,24,9,7],
        2023: [6,24,9,6],
        2024: [6,20,9,8],
        2025: [6,25,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Sevilla": {
    "_state_code": "an-se",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,25,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [2,27,2,27],
        2024: [2,27,2,27],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,25,9,9],
        2021: [6,22,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,25,9,1],
        2025: [6,25,9,2],
      },
      {
        name: "Día no lectivo",
        2025: [1,7,1,7],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Teruel": {
    "_state_code": "ar-te",
    SH: [
      {
        name: "Día no lectivo",
        2020: [2,21,2,21],
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2023: [2,17,2,17],
        2024: [2,16,2,16],
        2025: [2,14,2,14],
        2026: [2,20,2,20],
      },
    ]
  },
  "Zaragoza": {
    "_state_code": "ar-zg",
    SH: [
      {
        name: "Día no lectivo",
        2020: [10,14,10,14],
        2021: [10,13,10,13],
        2022: [10,10,10,10],
        2023: [3,2,3,2],
        2024: [10,11,10,11],
        2025: [10,10,10,10],
        2026: [4,24,4,24],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const fi = {
  PH: [{"name":"uudenvuodenpäivä - nyårsdagen","fixed_date":[1,1]},{"name":"loppiainen - trettondedagen","fixed_date":[1,6]},{"name":"pitkäperjantai - långfredagen","variable_date":"easter","offset":-2},{"name":"pääsiäispäivä - påskdagen","variable_date":"easter"},{"name":"toinen pääsiäispäivä - annandag påsk","variable_date":"easter","offset":1},{"name":"vappu - första maj","fixed_date":[5,1]},{"name":"helatorstai - Kristi himmelsfärdsdag","variable_date":"easter","offset":39},{"name":"helluntai - pingst","variable_date":"easter","offset":49},{"name":"juhannuspäivä - midsommardagen","variable_date":"nextSaturday20Jun"},{"name":"pyhäinpäivä - alla helgons dag","variable_date":"nextSaturday31Oct"},{"name":"itsenäisyyspäivä - självständighetsdagen","fixed_date":[12,6]},{"name":"joulupäivä - juldagen","fixed_date":[12,25]},{"name":"toinen joulupäivä - annandag jul","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.4965&lon=26.8429&zoom=18&addressdetails=1&accept-language=fi,sv,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const fr = {
  PH: [{"name":"Nouvel An","fixed_date":[1,1]},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Fête du travail","fixed_date":[5,1]},{"name":"Fête de la Victoire 1945","fixed_date":[5,8]},{"name":"Ascension","variable_date":"easter","offset":39},{"name":"Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Fête Nationale de la France","fixed_date":[7,14]},{"name":"Assomption","fixed_date":[8,15]},{"name":"Toussaint","fixed_date":[11,1]},{"name":"Armistice 1918","fixed_date":[11,11]},{"name":"Noël","fixed_date":[12,25]},{"name":"Arrivée de l’Évangile","fixed_date":[3,5],"only_states":["Polynésie française"]},{"name":"Vendredi saint","variable_date":"easter","offset":-2,"only_states":["Bas-Rhin","Guadeloupe","Haut-Rhin","Martinique","Moselle","Polynésie française","Saint-Barthélemy"]},{"name":"Abolition de l’esclavage","fixed_date":[4,27],"only_states":["Mayotte"]},{"name":"Fête de Saint Pierre-Chanel","fixed_date":[4,28],"only_states":["Wallis-et-Futuna"]},{"name":"Abolition de l’esclavage","fixed_date":[5,22],"only_states":["Martinique"]},{"name":"Abolition de l’esclavage","fixed_date":[5,27],"only_states":["Guadeloupe","Saint-Martin"]},{"name":"Abolition de l’esclavage","fixed_date":[6,10],"only_states":["Guyane"]},{"name":"Saint Pierre et Paul","fixed_date":[6,29],"only_states":["Wallis-et-Futuna"]},{"name":"Jour de Victor Schoelcher","fixed_date":[7,21],"only_states":["Guadeloupe","Martinique"]},{"name":"Fête du Territoire","fixed_date":[7,29],"only_states":["Wallis-et-Futuna"]},{"name":"Fête de la Citoyenneté","fixed_date":[9,24],"only_states":["Nouvelle-Calédonie"]},{"name":"Abolition de l’esclavage","fixed_date":[10,9],"only_states":["Saint-Barthélemy"]},{"name":"Matari’i","fixed_date":[11,20],"only_states":["Polynésie française"]},{"name":"Abolition de l’esclavage","fixed_date":[12,20],"only_states":["La Réunion"]},{"name":"Lendemain de Noël","fixed_date":[12,26],"only_states":["Bas-Rhin","Haut-Rhin","Moselle"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.60333&lon=1.88920&zoom=18&addressdetails=1&accept-language=fr,en",
  "Auvergne-Rhône-Alpes": {
    "_state_code": "ar",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Bas-Rhin": {
    "_state_code": "67",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Bas-Rhin&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Bourgogne-Franche-Comté": {
    "_state_code": "bf",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Bretagne": {
    "_state_code": "bt",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Centre-Val de Loire": {
    "_state_code": "cv",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Corse": {
    "_state_code": "co",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,16,3,1],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,25,3,10],
        2025: [2,16,3,2],
        2026: [2,15,3,1],
      },
      {
        name: "Vacances de printemps",
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,16,5,1],
        2024: [4,28,5,12],
        2025: [4,13,4,27],
        2026: [4,12,4,26],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,9,2],
        2021: [7,9,9,2],
        2022: [7,9,8,1],
        2023: [7,8,9,4],
        2024: [7,7,9,2],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Grand Est": {
    "_state_code": "ge",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Guadeloupe": {
    "_state_code": "gp",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Guadeloupe&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2021: [5,29,5,29],
        2022: [5,23,5,25],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Guyane": {
    "_state_code": "gf",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Guyane&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2024: [2,11,2,25],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,10,4,27],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2024: [4,21,5,2],
        2025: [4,18,5,4],
        2026: [4,2,4,15],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,23,5,24],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,14,5,21],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,4,9,1],
        2023: [7,9,9,3],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,25,11,8],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Vacances d'hiver",
        2023: [2,19,3,5],
      },
      {
        name: "Semaine en Mai",
        2026: [5,15,5,16],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Haut-Rhin": {
    "_state_code": "68",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Haut-Rhin&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Hauts-de-France": {
    "_state_code": "hf",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Île-de-France": {
    "_state_code": "if",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,18,3,4],
        2019: [2,24,3,10],
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
        2027: [2,7,2,21],
      },
      {
        name: "Vacances de printemps",
        2018: [4,15,4,29],
        2019: [4,21,5,5],
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "La Réunion": {
    "_state_code": "re",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=La+R%C3%A9union&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances d'été austral",
        2019: [12,20,1,26],
        2020: [12,20,1,24],
        2021: [12,19,1,23],
        2022: [12,18,1,22],
        2023: [12,20,1,21],
        2024: [12,20,1,20],
        2025: [12,20,1,20],
        2026: [12,20,1,31],
      },
      {
        name: "Vacances après troisième période",
        2020: [3,9,3,22],
        2021: [3,7,3,21],
        2022: [3,13,3,27],
        2023: [3,12,3,26],
        2024: [3,3,3,17],
        2025: [3,2,3,16],
        2026: [3,1,3,15],
        2027: [3,17,3,29],
      },
      {
        name: "Vacances après quatrième période",
        2020: [5,1,5,13],
        2021: [5,5,5,16],
        2022: [5,15,5,29],
        2023: [5,14,5,29],
        2024: [5,5,5,20],
        2025: [5,4,5,18],
        2026: [5,3,5,17],
        2027: [5,6,5,18],
      },
      {
        name: "Vacances d'hiver austral",
        2020: [7,5,8,16],
        2021: [7,8,8,15],
        2022: [7,10,8,15],
        2023: [7,9,8,16],
        2024: [7,7,8,18],
        2025: [7,6,8,18],
        2026: [7,5,8,17],
        2027: [7,11,8,15],
      },
      {
        name: "Vacances après première période",
        2020: [10,11,10,25],
        2021: [10,10,10,24],
        2022: [10,9,10,23],
        2023: [10,15,10,29],
        2024: [10,13,10,27],
        2025: [10,12,10,26],
        2026: [10,11,10,24],
      },
    ]
  },
  "Martinique": {
    "_state_code": "mq",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Martinique&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,23,3,8],
        2021: [2,7,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2024: [2,11,2,25],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,5,4,19],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,16],
        2024: [3,24,4,7],
        2025: [4,13,4,27],
        2026: [3,28,4,12],
      },
      {
        name: "Pas de cours",
        2020: [5,22,5,23],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,19,5,20],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,25,11,8],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Mayotte": {
    "_state_code": "yt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Mayotte&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,15,1,12],
        2020: [12,13,1,10],
        2021: [12,12,1,9],
        2022: [12,11,1,8],
        2023: [12,17,1,14],
        2024: [12,15,1,12],
        2025: [12,14,1,11],
      },
      {
        name: "Vacances de février",
        2020: [3,1,3,15],
        2021: [2,28,3,14],
        2022: [2,27,3,13],
        2023: [2,19,3,5],
        2024: [2,25,3,10],
        2025: [3,2,3,16],
        2026: [3,2,3,8],
      },
      {
        name: "Vacances de Pâques",
        2020: [5,3,5,10],
        2021: [5,2,5,16],
        2022: [5,1,5,15],
        2023: [4,23,5,7],
        2024: [4,28,5,12],
        2025: [4,27,5,11],
        2026: [4,26,5,11],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,23],
        2021: [7,7,8,23],
        2022: [7,6,8,23],
        2023: [7,8,8,22],
        2024: [7,7,8,25],
        2025: [7,5,8,22],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,11,10,25],
        2021: [10,10,10,24],
        2022: [10,9,10,23],
        2023: [10,15,10,29],
        2024: [10,13,10,27],
        2025: [10,12,10,26],
      },
      {
        name: "Fin des cours",
        2026: [7,4,8,21],
      },
    ]
  },
  "Moselle": {
    "_state_code": "57",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Moselle&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Normandie": {
    "_state_code": "no",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Nouvelle-Aquitaine": {
    "_state_code": "na",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Nouvelle-Calédonie": {
    "_state_code": "nc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Nouvelle-Cal%C3%A9donie&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Occitanie": {
    "_state_code": "oc",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,18,3,4],
        2019: [2,24,3,10],
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
      },
      {
        name: "Vacances de printemps",
        2018: [4,15,4,29],
        2019: [4,21,5,5],
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Pays de la Loire": {
    "_state_code": "pl",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Polynésie française": {
    "_state_code": "pf",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Polyn%C3%A9sie+fran%C3%A7aise&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Provence-Alpes-Côte d'Azur": {
    "_state_code": "pc",
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Saint-Barthélemy": {
    "_state_code": "bl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Saint-Barth%C3%A9lemy&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Saint-Martin": {
    "_state_code": "mf",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Saint-Martin&zoom=18&addressdetails=1&limit=1&accept-language=fr,en",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2021: [5,29,5,29],
        2022: [5,23,5,25],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Saint-Pierre-et-Miquelon": {
    "_state_code": "sp",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2025: [5,28,6,1],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Vacances de printemps",
        2021: [4,11,4,25],
        2025: [4,19,5,4],
      },
      {
        name: "Vacances d'hiver",
        2025: [2,23,3,9],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Wallis-et-Futuna": {
    "_state_code": "wf",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=France&state=Wallis-et-Futuna&zoom=18&addressdetails=1&limit=1&accept-language=fr,en"
  },
  "Zone A": {
    "_state_code": "za",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances de printemps",
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances d'hiver",
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Zone B": {
    "_state_code": "zb",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Zone C": {
    "_state_code": "zc",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
        2027: [2,7,2,21],
      },
      {
        name: "Vacances de printemps",
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const gb = {
  "England": {
    "_state_code": "eng",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.5073219&lon=-0.1276474&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday","substitute_name":"New Year’s Day (substitute day)"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Christmas Day (substitute day)"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Boxing Day (substitute day)"}]
  },
  "Northern Ireland": {
    "_state_code": "nir",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=54.5950675&lon=-5.9298401&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday","substitute_name":"New Year’s Day (substitute day)"},{"name":"St Patrick’s Day","variable_date":"nextMo-Fr17March"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Battle of the Boyne","variable_date":"nextMo-Fr12July"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Christmas Day (substitute day)"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Boxing Day (substitute day)"}]
  },
  "Scotland": {
    "_state_code": "sct",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.9557307&lon=-3.1976026&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday","substitute_name":"New Year’s Day (substitute day)"},{"name":"2nd January","fixed_date":[1,2],"substitute_rule":"if saturday then next monday if sunday then next tuesday if monday then next tuesday","substitute_name":"2nd January (substitute day)"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"firstAugustMonday"},{"name":"St. Andrew’s Day","variable_date":"nextMo-Fr30November"},{"name":"Christmas","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Christmas Day (substitute day)"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Boxing Day (substitute day)"}]
  },
  "Wales": {
    "_state_code": "wls",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.2928116&lon=-3.73893&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday","substitute_name":"New Year’s Day (substitute day)"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Christmas Day (substitute day)"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday","substitute_name":"Boxing Day (substitute day)"}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ge = {
  PH: [{"name":"ახალი წელი","fixed_date":[1,1]},{"name":"ბედობა","fixed_date":[1,2]},{"name":"შობა","fixed_date":[1,7]},{"name":"ნათლისღება","fixed_date":[1,19]},{"name":"დედის დღე","fixed_date":[3,3]},{"name":"ქალთა საერთაშორისო დღე","fixed_date":[3,8]},{"name":"ეროვნული ერთიანობის დღე","fixed_date":[4,9]},{"name":"წითელი პარასკევი","variable_date":"orthodox easter","offset":-2},{"name":"დიდი შაბათი","variable_date":"orthodox easter","offset":-1},{"name":"აღდგომა","variable_date":"orthodox easter"},{"name":"აღდგომის ორშაბათი","variable_date":"orthodox easter","offset":1},{"name":"ფაშიზმზე გამარჯვების დღე","fixed_date":[5,9]},{"name":"წმინდა ანდრია პირველწოდებულის ხსენების დღე","fixed_date":[5,12]},{"name":"დამოუკიდებლობის დღე","fixed_date":[5,26]},{"name":"მარიამობა","fixed_date":[8,28]},{"name":"სვეტიცხოვლობა","fixed_date":[10,14]},{"name":"გიორგობა","fixed_date":[11,23]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.7151&lon=44.8271&zoom=18&addressdetails=1&accept-language=ka,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const gg = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Liberation Day","fixed_date":[5,9]},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const gi = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Commonwealth Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Workers Memorial Day","fixed_date":[4,28]},{"name":"May Day","fixed_date":[5,1],"shift_rule":"if sunday, saturday then next monday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Late Summer Bank Holiday","variable_date":"lastAugustMonday"},{"name":"Gibraltar National Day","fixed_date":[9,10],"substitute_rule":"if sunday, saturday then previous monday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Queen's Birthday","variable_date":"mondayBefore20Jun"}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const gr = {
  PH: [{"name":"Πρωτοχρονιά","fixed_date":[1,1]},{"name":"Θεοφάνια","fixed_date":[1,6]},{"name":"25η Μαρτίου","fixed_date":[3,25]},{"name":"Καθαρά Δευτέρα","variable_date":"orthodox easter","offset":-48},{"name":"Μεγάλη Παρασκευή","variable_date":"orthodox easter","offset":-2},{"name":"Πάσχα","variable_date":"orthodox easter"},{"name":"Δευτέρα του Πάσχα","variable_date":"orthodox easter","offset":1},{"name":"Αγίου Πνεύματος","variable_date":"orthodox easter","offset":50},{"name":"Εργατική Πρωτομαγιά","fixed_date":[5,1]},{"name":"Κοίμηση της Θεοτόκου","fixed_date":[8,15]},{"name":"Επέτειος του Όχι","fixed_date":[10,28]},{"name":"Χριστούγεννα","fixed_date":[12,25]},{"name":"Δεύτερη μέρα των Χριστουγέννων","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Greece&zoom=18&addressdetails=1&limit=1&accept-language=el,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const hr = {
  PH: [{"name":"Nova godina","fixed_date":[1,1]},{"name":"Bogojavljenje ili Sveta tri kralja","fixed_date":[1,6]},{"name":"Uskrs","variable_date":"easter"},{"name":"Uskršnji ponedjeljak","variable_date":"easter","offset":1},{"name":"Praznik rada","fixed_date":[5,1]},{"name":"Dan državnosti","fixed_date":[5,30]},{"name":"Tijelovo","variable_date":"easter","offset":60},{"name":"Dan antifašističke borbe","fixed_date":[6,22]},{"name":"Dan pobjede i domovinske zahvalnosti i Dan hrvatskih branitelja","fixed_date":[8,5]},{"name":"Velika Gospa","fixed_date":[8,15]},{"name":"Svi sveti","fixed_date":[11,1]},{"name":"Dan sjećanja na žrtve Domovinskog rata i Dan sjećanja na žrtvu Vukovara i Škabrnje","fixed_date":[11,18]},{"name":"Božić","fixed_date":[12,25]},{"name":"Sveti Stjepan","fixed_date":[12,26]}],
  SH: [
    {
      name: "Zimski odmor",
      2019: [12,23,1,3],
      2025: [12,24,1,9],
    },
    {
      name: "Zimski odmor (prvi dio)",
      2019: [12,23,1,3],
      2020: [12,24,1,8],
      2021: [12,24,1,7],
      2022: [12,27,1,5],
      2023: [12,27,1,5],
      2024: [12,23,1,6],
    },
    {
      name: "Zimski odmor (drugi dio)",
      2020: [2,24,2,28],
      2021: [2,23,2,26],
      2022: [2,21,2,25],
      2023: [2,20,2,24],
      2024: [2,19,2,23],
      2025: [2,24,2,28],
    },
    {
      name: "Proljetni odmor",
      2020: [4,10,4,17],
      2021: [4,2,4,9],
      2022: [4,14,4,22],
      2023: [4,6,4,14],
      2024: [3,28,4,5],
      2025: [4,17,4,25],
      2026: [3,30,4,6],
    },
    {
      name: "Ljetni odmor",
      2020: [6,18,9,6],
      2021: [6,21,9,5],
      2022: [6,23,9,4],
      2023: [6,23,9,3],
      2024: [6,24,9,1],
      2025: [6,19,8,31],
      2026: [6,15,8,31],
    },
    {
      name: "Jesenski odmor",
      2020: [11,2,11,3],
      2021: [11,2,11,3],
      2022: [10,31,11,1],
      2023: [10,30,11,1],
      2024: [10,31,11,1],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lon=15.977&lat=45.813&zoom=18&addressdetails=1&accept-language=hr,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const hu = {
  PH: [{"name":"újév","fixed_date":[1,1]},{"name":"az 1848-as forradalom ünnepe","fixed_date":[3,15]},{"name":"nagypéntek","variable_date":"easter","offset":-2},{"name":"húsvétvasárnap","variable_date":"easter"},{"name":"húsvéthétfő","variable_date":"easter","offset":1},{"name":"pünkösdvasárnap","variable_date":"easter","offset":49},{"name":"pünkösdhétfő","variable_date":"easter","offset":50},{"name":"a munka ünnepe","fixed_date":[5,1]},{"name":"az államalapítás ünnepe","fixed_date":[8,20]},{"name":"az 1956-os forradalom ünnepe","fixed_date":[10,23]},{"name":"mindenszentek","fixed_date":[11,1]},{"name":"karácsony","fixed_date":[12,25]},{"name":"karácsony másnap","fixed_date":[12,26]}],
  SH: [
    {
      name: "Őszi szünet",
      2014: [10,23,11,2],
      2015: [10,23,11,1],
      2016: [10,29,11,6],
      2017: [10,28,11,5],
      2018: [10,27,11,4],
      2019: [10,26,11,3],
      2020: [10,22,11,1],
      2021: [10,23,11,1],
      2022: [10,29,11,6],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [10,23,11,2],
    },
    {
      name: "Téli szünet",
      2014: [12,20,1,4],
      2015: [12,19,1,3],
      2016: [12,22,1,2],
      2017: [12,23,1,2],
      2018: [12,22,1,2],
      2019: [12,23,1,5],
      2020: [12,18,1,3],
      2021: [12,22,1,2],
      2022: [12,22,1,8],
      2023: [12,21,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
    },
    {
      name: "Tavaszi szünet",
      2015: [4,2,4,7],
      2016: [3,24,3,29],
      2017: [4,13,4,18],
      2018: [3,29,4,3],
      2019: [4,18,4,23],
      2020: [4,9,4,14],
      2021: [3,31,4,6],
      2022: [4,14,4,19],
      2023: [4,6,4,11],
      2024: [3,29,4,7],
      2025: [4,17,4,27],
      2026: [4,2,4,12],
    },
    {
      name: "Nyári szünet",
      2015: [6,16,8,31],
      2016: [6,16,8,31],
      2017: [6,16,8,31],
      2018: [6,16,9,2],
      2019: [6,15,9,1],
      2020: [6,16,8,31],
      2021: [6,16,8,31],
      2022: [6,16,8,31],
      2023: [6,16,8,31],
      2024: [6,16,8,31],
      2025: [6,21,8,31],
      2026: [6,20,8,31],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=47.4821&lon=19.0640&zoom=18&addressdetails=1&accept-language=hu,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ie = {
  PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"St. Brigid’s Day","fixed_date":[2,1],"shift_rule":"if tuesday,wednesday,thursday,saturday,sunday then next monday"},{"name":"St. Patrick’s Day","fixed_date":[3,17]},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"First Monday in May","variable_date":"firstMayMonday"},{"name":"First Monday in June","variable_date":"firstJuneMonday"},{"name":"First Monday in August","variable_date":"firstAugustMonday"},{"name":"Last Monday in October","variable_date":"lastOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"St. Stephen’s Day","fixed_date":[12,26]}],
  SH: [
    {
      name: "Christmas",
      2019: [12,20,1,5],
      2020: [12,22,1,5],
      2021: [12,22,1,5],
      2022: [12,21,1,4],
      2023: [12,22,1,7],
      2024: [12,20,1,5],
      2025: [12,19,1,4],
    },
    {
      name: "February mid-term break",
      2020: [2,20,2,21],
      2021: [2,18,2,19],
      2022: [2,24,2,25],
      2023: [2,16,2,17],
      2024: [2,15,2,16],
      2025: [2,20,2,21],
      2026: [2,19,2,20],
    },
    {
      name: "Easter",
      2020: [4,3,4,19],
      2021: [3,26,4,11],
      2022: [4,8,4,24],
      2023: [3,31,4,16],
      2024: [3,22,4,7],
      2025: [4,11,4,27],
      2026: [3,27,4,12],
    },
    {
      name: "October mid-term break",
      2020: [10,26,10,30],
      2021: [10,25,10,29],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=53.1424&lon=-7.6921&zoom=18&addressdetails=1&accept-language=ga,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const im = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Tourist Trophy, Senior Race Day","variable_date":"firstJuneFriday","offset":7},{"name":"Tynwald Day","fixed_date":[7,5]},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const it = {
  PH: [{"name":"Capodanno","fixed_date":[1,1]},{"name":"Epifania","fixed_date":[1,6]},{"name":"Pasqua","variable_date":"easter"},{"name":"Lunedì di Pasqua","variable_date":"easter","offset":1},{"name":"Liberazione dal nazifascismo (1945)","fixed_date":[4,25]},{"name":"Festa del lavoro","fixed_date":[5,1]},{"name":"Festa della Repubblica","fixed_date":[6,2]},{"name":"Assunzione di Maria","fixed_date":[8,15]},{"name":"Festa nazionale di San Francesco d'Assisi","fixed_date":[10,4]},{"name":"Ognissanti","fixed_date":[11,1]},{"name":"Immacolata Concezione","fixed_date":[12,8]},{"name":"Natale di Gesù","fixed_date":[12,25]},{"name":"Santo Stefano","fixed_date":[12,26]}],
  SH: [
    {
      name: "festività pasquali",
      2020: [4,9,4,14],
      2021: [4,1,4,6],
      2022: [4,14,4,19],
    },
    {
      name: "vacanza galleggiante",
      2020: [4,24,4,24],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.9808038&lon=12.7662312&zoom=18&addressdetails=1&accept-language=it,en",
  "Abruzzo": {
    "_state_code": "ab",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,9,9,24],
        2021: [6,11,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Basilicata": {
    "_state_code": "ba",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,12,9,24],
        2021: [6,12,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [4,26,4,27],
        2025: [3,3,3,4],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Bolzano": {
    "_state_code": "tr-bz",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,21,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,5],
        2023: [12,27,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [5,29,5,29],
        2024: [5,20,5,20],
        2025: [6,9,6,9],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,17,9,7],
        2021: [6,17,9,5],
        2022: [6,17,9,4],
        2023: [6,17,9,4],
        2024: [6,14,9,4],
        2025: [6,14,9,7],
      },
      {
        name: "vacanze galleggianti",
        2020: [11,3,11,7],
        2021: [11,3,11,6],
        2022: [12,9,12,10],
        2023: [11,1,11,3],
        2024: [10,26,11,3],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,8],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,16,6,16],
      },
    ]
  },
  "Calabria": {
    "_state_code": "cl",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,24,1,6],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [5,2,5,2],
      },
      {
        name: "vacanze estive",
        2020: [6,10,9,24],
        2021: [6,13,9,19],
        2022: [6,10,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,8,9,15],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Campania": {
    "_state_code": "cm",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,21,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,8],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,24],
        2021: [6,13,9,14],
        2022: [6,9,9,12],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,12,2,13],
        2025: [5,2,5,3],
        2026: [2,16,2,17],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Emilia-Romagna": {
    "_state_code": "er",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,5],
        2023: [12,24,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,12],
        2022: [6,5,9,14],
        2023: [6,8,9,14],
        2024: [6,6,9,15],
        2025: [6,7,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,2,11,2],
        2024: [11,2,11,2],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Friuli Venezia Giulia": {
    "_state_code": "fv",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,27,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [10,31,10,31],
        2023: [4,24,4,24],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,16],
        2021: [6,11,9,15],
        2022: [6,12,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,10],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,12,2,14],
        2025: [3,3,3,5],
        2026: [2,16,2,18],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Lazio": {
    "_state_code": "la",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,8,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,14],
        2023: [6,9,9,14],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
      },
      {
        name: "vacanze galleggianti",
        2021: [5,31,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Liguria": {
    "_state_code": "li",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,23,1,7],
        2023: [12,27,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2023: [4,24,4,24],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,10,9,14],
        2022: [6,11,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "vacanze galleggianti",
        2022: [6,3,6,4],
        2024: [4,29,4,30],
        2025: [5,2,5,3],
        2026: [2,16,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,11,6,11],
      },
    ]
  },
  "Lombardia": {
    "_state_code": "lo",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [2,29,2,29],
        2021: [11,2,11,2],
        2022: [3,1,3,1],
      },
      {
        name: "vacanze estive",
        2020: [6,8,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,11],
        2023: [6,9,9,11],
        2024: [6,8,9,15],
        2025: [6,8,9,11],
      },
      {
        name: "vacanze galleggianti",
        2021: [2,19,2,20],
        2022: [3,4,3,5],
        2023: [2,24,2,25],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Marche": {
    "_state_code": "ma",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,24,1,6],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,14],
        2022: [6,5,9,13],
        2023: [6,11,9,12],
        2024: [6,6,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2023: [11,1,11,3],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Molise": {
    "_state_code": "mo",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,8],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [12,7,12,7],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,14],
        2022: [6,9,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,29,4,30],
        2025: [5,2,5,3],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Piemonte": {
    "_state_code": "pi",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [3,1,3,1],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [3,1,3,1],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,12,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,10],
        2024: [6,8,9,15],
        2025: [6,8,9,9],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,14,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Puglia": {
    "_state_code": "pu",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,9],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,2,12,2],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,24],
        2021: [6,12,9,19],
        2022: [6,10,9,13],
        2023: [6,11,9,13],
        2024: [6,7,9,15],
        2025: [6,8,9,15],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [2,12,2,13],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Sardegna": {
    "_state_code": "sa",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,2,11,2],
        2024: [11,2,11,2],
        2025: [4,28,4,28],
        2026: [5,2,5,2],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,22],
        2021: [6,13,9,13],
        2022: [6,9,9,13],
        2023: [6,11,9,13],
        2024: [6,7,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,13,2,13],
        2025: [3,3,3,4],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Sicilia": {
    "_state_code": "si",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,6],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,9,9,15],
        2022: [6,11,9,18],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanza galleggiante",
        2023: [11,2,11,2],
        2024: [11,2,11,2],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Toscana": {
    "_state_code": "to",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,5],
        2023: [12,24,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,11,9,14],
        2022: [6,11,9,14],
        2023: [6,11,9,14],
        2024: [6,10,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Trento": {
    "_state_code": "tr-tn",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,11,9,12],
        2022: [6,11,9,11],
        2023: [6,10,9,10],
        2024: [6,11,9,8],
        2025: [6,13,9,9],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,18,4,26],
        2026: [4,2,4,8],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,8,2,13],
        2025: [5,1,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Umbria": {
    "_state_code": "um",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,7],
        2023: [12,22,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,10,9,14],
        2021: [6,10,9,12],
        2022: [6,10,9,13],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanze galleggianti",
        2021: [5,31,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Valle d'Aosta": {
    "_state_code": "va",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,23,1,8],
        2022: [12,24,1,7],
        2023: [12,24,1,7],
        2024: [12,23,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [3,1,3,1],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,13,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,18],
        2023: [6,16,9,10],
        2024: [6,6,9,15],
        2025: [6,11,9,9],
      },
      {
        name: "vacanze galleggianti",
        2023: [1,30,1,31],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,1],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Veneto": {
    "_state_code": "ve",
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,9],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,8],
        2024: [3,28,4,2],
        2025: [4,17,4,19],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const je = {
  PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Liberation Day","fixed_date":[5,9]},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=49.2&lon=-2.1&zoom=11&addressdetails=1&accept-language=en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const jp = {
  PH: [{"name":"元日","fixed_date":[1,1],"substitute_rule":"if sunday then next monday"},{"name":"成人の日","variable_date":"firstJanuaryMonday","offset":7},{"name":"建国記念の日","fixed_date":[2,11],"substitute_rule":"if sunday then next monday"},{"name":"天皇誕生日","fixed_date":[2,23],"substitute_rule":"if sunday then next monday"},{"name":"昭和の日","fixed_date":[4,29],"substitute_rule":"if sunday then next monday"},{"name":"憲法記念日","fixed_date":[5,3],"substitute_rule":"if sunday then next wednesday"},{"name":"みどりの日","fixed_date":[5,4],"substitute_rule":"if sunday then next tuesday"},{"name":"こどもの日","fixed_date":[5,5],"substitute_rule":"if sunday then next monday"},{"name":"海の日","variable_date":"firstJulyMonday","offset":14},{"name":"山の日","fixed_date":[8,11],"substitute_rule":"if sunday then next monday"},{"name":"敬老の日","variable_date":"firstSeptemberMonday","offset":14},{"name":"スポーツの日","variable_date":"firstOctoberMonday","offset":7},{"name":"文化の日","fixed_date":[11,3],"substitute_rule":"if sunday then next monday"},{"name":"勤労感謝の日","fixed_date":[11,23],"substitute_rule":"if sunday then next monday"},{"name":"春分の日","variable_date":"springEquinox","substitute_rule":"if sunday then next monday"},{"name":"秋分の日","variable_date":"autumnalEquinox","substitute_rule":"if sunday then next monday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.39291572&lon=139.44288869&zoom=18&addressdetails=1&accept-language=ja,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const li = {
  SH: [
    {
      name: "Winterferien",
      2019: [12,21,1,6],
      2020: [12,24,1,6],
      2021: [12,24,1,9],
      2022: [12,24,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,6],
      2025: [12,24,1,6],
      2026: [12,24,1,6],
    },
    {
      name: "Sommerferien",
      2020: [7,4,8,16],
      2021: [7,3,8,15],
      2022: [7,2,8,16],
      2023: [7,8,8,20],
      2024: [7,6,8,18],
      2025: [7,5,8,17],
      2026: [7,4,8,16],
    },
    {
      name: "Herbstferien",
      2020: [10,3,10,18],
      2021: [10,2,10,17],
      2022: [10,1,10,16],
      2023: [10,7,10,22],
      2024: [10,5,10,20],
      2025: [10,4,10,19],
      2026: [10,3,10,18],
    },
    {
      name: "Sportferien",
      2020: [2,22,3,1],
      2021: [2,13,2,21],
      2022: [2,26,3,6],
      2023: [2,18,2,26],
      2024: [2,10,2,18],
      2025: [3,1,3,9],
      2026: [2,14,2,22],
    },
    {
      name: "Schulfrei",
      2020: [6,12,6,12],
      2021: [6,4,6,4],
      2022: [6,17,6,17],
      2023: [6,9,6,9],
      2024: [5,31,5,31],
      2025: [6,20,6,20],
      2026: [6,5,6,5],
    },
    {
      name: "Frühlingsferien",
      2020: [4,10,4,26],
      2021: [4,2,4,18],
      2022: [4,13,5,1],
      2023: [4,7,4,23],
      2024: [3,29,4,14],
      2025: [4,18,5,4],
      2026: [4,3,4,19],
    },
  ]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const lt = {
  PH: [{"name":"Naujieji metai","fixed_date":[1,1]},{"name":"Lietuvos valstybės atkūrimo diena","fixed_date":[2,16]},{"name":"Lietuvos nepriklausomybės atkūrimo diena","fixed_date":[3,11]},{"name":"Velykos","variable_date":"easter"},{"name":"Velykų pirmadienis","variable_date":"easter","offset":1},{"name":"Tarptautinė darbo diena","fixed_date":[5,1]},{"name":"Joninės, Rasos","fixed_date":[6,24]},{"name":"Valstybės diena","fixed_date":[7,6]},{"name":"Žolinė","fixed_date":[8,15]},{"name":"Visų šventųjų diena","fixed_date":[11,1]},{"name":"Vėlinės","fixed_date":[11,2]},{"name":"Šv. Kūčios","fixed_date":[12,24]},{"name":"Šv. Kalėdos","fixed_date":[12,25]},{"name":"2. Kalėdų diena","fixed_date":[12,26]}],
  SH: [
    {
      name: "Žiemos atostogos",
      2019: [12,23,1,3],
      2020: [12,23,1,5],
      2021: [12,27,1,7],
      2022: [12,27,1,6],
      2023: [12,27,1,5],
      2024: [12,27,1,3],
      2025: [12,24,1,4],
      2026: [12,23,1,3],
      2027: [2,15,2,21],
    },
    {
      name: "Pavasario atostogos",
      2020: [4,14,4,17],
      2021: [4,6,4,9],
      2022: [4,19,4,22],
      2023: [4,11,4,14],
      2024: [4,2,4,5],
      2025: [4,22,4,25],
      2026: [4,6,4,12],
      2027: [3,29,4,4],
    },
    {
      name: "Atgal į mokyklą",
      2020: [9,1,9,1],
      2021: [9,1,9,1],
      2022: [9,1,9,1],
      2023: [9,1,9,1],
      2024: [9,1,9,1],
      2025: [9,1,9,1],
      2026: [9,1,9,1],
      2027: [9,1,9,1],
    },
    {
      name: "Rudens atostogos",
      2020: [10,26,10,30],
      2021: [11,3,11,5],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,10,31],
      2025: [11,3,11,9],
      2026: [11,2,11,8],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=54.6872&lon=25.2797&zoom=18&addressdetails=1&accept-language=lt,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const lu = {
  PH: [{"name":"Neijoerschdag - Neujahr - Nouvel An","fixed_date":[1,1]},{"name":"Ouschterméindeg - Ostermontag - Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Dag vun der Aarbecht - Tag der Arbeit - Premier Mai","fixed_date":[5,1]},{"name":"Europadag - Europatag - Journée de l'Europe","fixed_date":[5,1]},{"name":"Christi Himmelfaart - Christi Himmelfahrt - Ascension","variable_date":"easter","offset":39},{"name":"Péngschtméindeg - Pfingstmontag - Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Nationalfeierdag - Nationalfeiertag - Fête nationale","fixed_date":[6,23]},{"name":"Mariä Himmelfaart - Maria Himmelfahrt - Assomption","fixed_date":[8,15]},{"name":"Allerhellgen - Weihnachten - Allerheiligen - Toussaint","fixed_date":[11,1]},{"name":"Chrëschtdag - Noël","fixed_date":[12,25]},{"name":"Stiefesdag - Zweiter Weihnachtsfeiertag - St. Etienne","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vacances de Noël",
      2019: [12,21,1,5],
      2020: [12,19,1,3],
      2021: [12,18,1,2],
      2022: [12,24,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
      2026: [12,19,1,3],
    },
    {
      name: "Congé de Carnaval",
      2020: [2,15,2,23],
      2021: [2,13,2,21],
      2022: [2,12,2,20],
      2023: [2,11,2,19],
      2024: [2,10,2,18],
      2025: [2,15,2,23],
      2026: [2,14,2,22],
      2027: [2,6,2,14],
    },
    {
      name: "Vacances de Pâques",
      2020: [4,4,4,19],
      2021: [4,3,4,22],
      2022: [4,2,4,18],
      2023: [4,1,4,16],
      2024: [3,30,4,14],
      2025: [4,5,4,20],
      2026: [3,28,4,12],
      2027: [3,27,4,11],
    },
    {
      name: "Congé de la Pentecôte",
      2020: [5,30,6,7],
      2021: [5,22,5,30],
      2022: [5,21,5,29],
      2023: [5,27,6,4],
      2024: [5,25,6,2],
      2025: [5,24,6,1],
      2026: [5,23,5,31],
      2027: [5,29,6,6],
    },
    {
      name: "Vacances d’été",
      2020: [7,16,9,14],
      2021: [7,16,9,14],
      2022: [7,16,9,14],
      2023: [7,15,9,14],
      2024: [7,16,9,15],
      2025: [7,16,9,14],
      2026: [7,16,9,14],
      2027: [7,16,9,14],
    },
    {
      name: "Congé de la Toussaint",
      2020: [10,31,11,8],
      2021: [10,30,11,7],
      2022: [10,29,11,6],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [11,1,11,9],
      2026: [10,31,11,8],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Luxembourg&zoom=18&addressdetails=1&limit=1&accept-language=lb,fr,de,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const lv = {
  PH: [{"name":"Jaunais Gads","fixed_date":[1,1]},{"name":"Lielā Piektdiena","variable_date":"easter","offset":-2},{"name":"Lieldienas","variable_date":"easter"},{"name":"Otrās Lieldienas","variable_date":"easter","offset":1},{"name":"Darba svētki","fixed_date":[5,1]},{"name":"Latvijas Republikas Neatkarības atjaunošanas diena","fixed_date":[5,4],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Līgo Diena","fixed_date":[6,23]},{"name":"Jāņi","fixed_date":[6,24]},{"name":"Latvijas Republikas proklamēšanas diena","fixed_date":[11,18],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Ziemassvētku vakars","fixed_date":[12,24]},{"name":"Ziemassvētki","fixed_date":[12,25]},{"name":"Otrie Ziemassvētki","fixed_date":[12,26]},{"name":"Vecgada vakars","fixed_date":[12,31]}],
  SH: [
    {
      name: "Ziemas brīvdienas",
      2019: [12,23,1,3],
      2020: [12,21,1,1],
      2021: [12,22,1,4],
      2022: [12,26,1,6],
      2023: [12,25,1,5],
      2024: [12,23,1,5],
    },
    {
      name: "Pavasara brīvdienas",
      2020: [3,16,3,20],
      2021: [3,15,3,19],
      2022: [3,14,3,18],
      2023: [3,13,3,17],
      2024: [3,11,3,15],
      2025: [3,10,3,16],
    },
    {
      name: "Vasaras brīvdienas",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [5,31,8,31],
    },
    {
      name: "Rudens brīvdienas",
      2020: [10,19,10,23],
      2021: [10,18,10,22],
      2022: [10,24,10,28],
      2023: [10,23,10,27],
      2024: [10,21,10,27],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=56.9460&lon=24.1059&zoom=18&addressdetails=1&accept-language=lv,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const mc = {
  PH: [{"name":"Nouvel An","fixed_date":[1,1]},{"name":"Sainte Dévote","fixed_date":[1,27],"substitute_rule":"if sunday then next monday"},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"1er mai","fixed_date":[5,1],"substitute_rule":"if sunday then next monday"},{"name":"Ascension","variable_date":"easter","offset":39},{"name":"Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"la Fête-Dieu","variable_date":"easter","offset":60},{"name":"Assomption","fixed_date":[8,15]},{"name":"Toussaint","fixed_date":[11,1]},{"name":"La Fête du Prince","fixed_date":[11,19],"substitute_rule":"if sunday then next monday"},{"name":"Immaculée Conception","fixed_date":[12,8]},{"name":"Noël","fixed_date":[12,25],"substitute_rule":"if sunday then next monday"}],
  SH: [
    {
      name: "Vacances de Noël",
      2019: [12,21,1,5],
      2020: [12,19,1,3],
      2021: [12,18,1,2],
      2022: [12,17,1,2],
      2023: [12,23,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
    },
    {
      name: "Vacances d’hiver",
      2020: [2,15,3,1],
      2021: [2,20,3,7],
      2022: [2,5,2,20],
      2023: [2,11,2,26],
      2024: [2,24,3,10],
      2025: [2,8,2,23],
      2026: [2,14,3,1],
    },
    {
      name: "Vacances de printemps",
      2020: [4,11,4,26],
      2021: [4,10,4,25],
      2022: [4,9,4,24],
      2023: [4,15,5,1],
      2024: [4,20,5,5],
      2025: [4,5,4,21],
      2026: [4,11,4,26],
    },
    {
      name: "Grand Prix historique",
      2020: [5,8,5,8],
      2022: [5,13,5,15],
    },
    {
      name: "Grand Prix de Formule 1 et Pentecôte",
      2020: [5,21,5,24],
      2021: [5,15,5,24],
      2022: [5,26,5,29],
      2023: [5,25,5,29],
      2024: [5,23,5,26],
      2025: [5,22,5,25],
      2026: [5,21,5,25],
    },
    {
      name: "Vacances d’été",
      2020: [6,27,9,6],
      2021: [7,1,9,5],
      2022: [7,2,9,4],
      2023: [7,1,9,10],
      2024: [6,29,9,8],
      2025: [6,28,9,7],
      2026: [6,27,9,6],
    },
    {
      name: "Vacances de la Toussaint",
      2020: [10,22,11,2],
      2021: [10,28,11,7],
      2022: [10,22,11,2],
      2023: [10,21,11,1],
      2024: [10,24,11,3],
      2025: [10,23,11,2],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.7384&lon=7.4246&zoom=18&addressdetails=1&accept-language=fr,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const md = {
  PH: [{"name":"Anul nou","fixed_date":[1,1]},{"name":"Ziua Internationala a Femeii","fixed_date":[3,8]},{"name":"Paștele","variable_date":"orthodox easter"},{"name":"A doua zi de Pasti","variable_date":"orthodox easter","offset":1},{"name":"Paştele Blăjinilor","variable_date":"orthodox easter","offset":8},{"name":"Ziua muncii","fixed_date":[5,1]},{"name":"Ziua Victoriei","fixed_date":[5,9]},{"name":"Ziua Independentei","fixed_date":[8,27]},{"name":"Limba noastră","fixed_date":[8,31]},{"name":"Craciun pe stil Nou","fixed_date":[12,25]}],
  SH: [
    {
      name: "Vacanţa de iarnă",
      2019: [12,25,1,8],
      2020: [12,25,1,10],
      2021: [12,25,1,9],
      2022: [12,24,1,8],
      2023: [12,23,1,8],
      2024: [12,25,1,8],
      2025: [12,25,1,8],
    },
    {
      name: "Vacanţa de primăvară",
      2020: [3,5,3,8],
      2021: [3,5,3,8],
      2022: [3,5,3,8],
      2023: [3,8,3,12],
      2024: [3,8,3,12],
      2025: [3,3,3,9],
      2026: [3,5,3,8],
    },
    {
      name: "Vacanţa de Paşti",
      2020: [4,18,4,27],
      2021: [5,1,5,10],
      2022: [4,23,5,2],
      2023: [4,15,4,24],
      2024: [5,4,5,13],
      2025: [4,19,4,28],
      2026: [4,11,4,20],
    },
    {
      name: "Vacanţa de vară",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [6,1,8,31],
      2026: [5,30,8,31],
    },
    {
      name: "Vacanţa de toamnă",
      2020: [10,24,11,1],
      2021: [10,27,10,31],
      2022: [10,26,10,30],
      2023: [11,1,11,5],
      2024: [10,28,11,3],
      2025: [10,27,11,2],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=47.0105&lon=28.8638&zoom=18&addressdetails=1&accept-language=ro,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const mt = {
  PH: [{"name":"L-Ewwel tas-Sena","fixed_date":[1,1]},{"name":"Nawfraġju ta' San Pawl","fixed_date":[2,10]},{"name":"San Ġużepp","fixed_date":[3,19]},{"name":"Jum il-Ħelsien","fixed_date":[3,31]},{"name":"Il-Ġimgħa l-Kbira","variable_date":"easter","offset":-2},{"name":"Jum il-Ħaddiem","fixed_date":[5,1]},{"name":"Sette Giugno","fixed_date":[6,7]},{"name":"L-Imnarja","fixed_date":[6,29]},{"name":"Santa Marija","fixed_date":[8,15]},{"name":"Jum il-Vitorja","fixed_date":[9,8]},{"name":"Jum l-Indipendenza","fixed_date":[9,21]},{"name":"Il-Kunċizzjoni","fixed_date":[12,8]},{"name":"Jum ir-Repubblika","fixed_date":[12,13]},{"name":"Il-Milied","fixed_date":[12,25]}],
  SH: [
    {
      name: "Vaganzi tal-Milied",
      2019: [12,23,1,6],
      2020: [12,23,1,6],
      2021: [12,23,1,6],
      2022: [12,23,1,6],
      2023: [12,23,1,6],
      2024: [12,23,1,6],
      2025: [12,23,1,6],
    },
    {
      name: "Festi tal-Karnival",
      2020: [2,24,2,25],
      2021: [2,15,2,17],
      2022: [2,28,3,2],
      2023: [2,20,2,21],
      2024: [2,12,2,14],
      2025: [3,1,3,4],
      2026: [2,16,2,17],
    },
    {
      name: "Vaganzi tal-Għid",
      2020: [4,8,4,15],
      2021: [3,31,4,7],
      2022: [4,13,4,20],
      2023: [4,5,4,12],
      2024: [3,27,4,3],
      2025: [4,16,4,23],
      2026: [4,1,4,8],
    },
    {
      name: "Kumpens għall-vaganzi fi tmiem il-ġimgħa",
      2020: [4,16,4,17],
      2021: [4,8,4,9],
      2022: [5,2,5,2],
      2023: [4,13,4,14],
      2024: [12,12,12,12],
      2025: [5,30,5,30],
      2026: [4,9,4,10],
    },
    {
      name: "Vaganzi tas-sajf",
      2020: [6,29,9,29],
      2021: [6,29,9,28],
      2022: [6,30,9,27],
      2023: [6,28,9,26],
      2024: [6,28,9,24],
      2025: [6,27,9,23],
      2026: [7,1,9,29],
    },
    {
      name: "Btajjel ta' nofs it-terminu",
      2020: [11,2,11,4],
      2021: [11,1,11,3],
      2022: [10,31,11,2],
      2023: [11,1,11,3],
      2024: [11,1,11,5],
      2025: [11,3,11,5],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.8997&lon=14.5147&zoom=18&addressdetails=1&accept-language=mt,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const mx = {
  PH: [{"name":"Año Nuevo","fixed_date":[1,1]},{"name":"Día de la Constitución","variable_date":"firstFebruaryMonday"},{"name":"Natalicio de Benito Juárez","variable_date":"firstMarchMonday","offset":14},{"name":"Día del Trabajador","fixed_date":[5,1]},{"name":"Día de la Independencia","fixed_date":[9,16]},{"name":"Día de la Revolución","variable_date":"firstNovemberMonday","offset":14},{"name":"Navidad","fixed_date":[12,25]}],
  SH: [
    {
      name: "Receso de invierno",
      2019: [12,23,1,7],
      2020: [12,21,1,5],
      2021: [12,20,12,31],
      2022: [12,19,12,30],
      2023: [12,18,1,2],
      2024: [12,19,1,3],
      2025: [12,22,1,6],
    },
    {
      name: "Receso de primavera",
      2020: [4,6,4,17],
      2021: [3,29,4,9],
      2022: [4,11,4,22],
      2023: [4,3,4,14],
      2024: [3,25,4,5],
      2025: [4,14,4,25],
      2026: [3,30,4,10],
    },
    {
      name: "Receso de clases",
      2020: [7,7,8,23],
      2021: [7,10,8,29],
      2022: [7,29,8,28],
      2023: [7,27,8,27],
      2024: [7,17,8,25],
      2025: [7,16,8,31],
    },
    {
      name: "Fin de lecciones",
      2026: [7,15,7,15],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=19.4326&lon=-99.1332&zoom=18&addressdetails=1&accept-language=es,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const na = {
  PH: [{"name":"New Year’s Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Independence Day","fixed_date":[3,21],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Workers’ Day","fixed_date":[5,1],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Cassinga Day","fixed_date":[5,4],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Ascension Day","variable_date":"easter","offset":39},{"name":"Africa Day","fixed_date":[5,25],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Heroes’ Day","fixed_date":[8,26],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Human Rights Day","fixed_date":[12,10],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Family Day","fixed_date":[12,26],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Namibia&zoom=18&addressdetails=1&limit=1"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const nf = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Australia Day","fixed_date":[1,26],"shift_rule":"if saturday,sunday then next monday"},{"name":"Foundation Day","fixed_date":[3,6],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"Anniversary (Bounty) Day","fixed_date":[6,8],"shift_rule":"if saturday,sunday then next monday"},{"name":"Norfolk Island Agricultural Show","variable_date":"firstOctoberMonday","offset":7},{"name":"Thanksgiving Day","variable_date":"lastNovemberWednesday"},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const nl = {
  PH: [{"name":"Nieuwjaarsdag","fixed_date":[1,1]},{"name":"Goede vrijdag","variable_date":"easter","offset":-2},{"name":"Tweede Paasdag","variable_date":"easter","offset":1},{"name":"Koningsdag","fixed_date":[4,27],"shift_rule":"if sunday then previous saturday"},{"name":"Bevrijdingsdag","fixed_date":[5,5]},{"name":"Hemelvaartsdag","variable_date":"easter","offset":39},{"name":"Tweede Pinksterdag","variable_date":"easter","offset":50},{"name":"Eerste Kerstdag","fixed_date":[12,25]},{"name":"Tweede Kerstdag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.3702&lon=4.8952&zoom=18&addressdetails=1&accept-language=nl,en",
  "MI": {
    "_state_code": "mi",
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,22,3,1],
        2021: [2,20,2,28],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,17,2,25],
        2025: [2,22,3,2],
        2026: [2,14,2,22],
        2027: [2,20,2,28],
        2028: [2,26,3,5],
        2029: [2,17,2,25],
        2030: [2,23,3,3],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,18,8,30],
        2021: [7,17,8,29],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,13,8,25],
        2025: [7,19,8,31],
        2026: [7,18,8,30],
        2027: [7,17,8,29],
        2028: [7,8,8,20],
        2029: [7,7,8,19],
        2030: [7,13,8,25],
      },
      {
        name: "Herfstvakantie",
        2020: [10,17,10,25],
        2021: [10,16,10,24],
        2022: [10,22,10,30],
        2023: [10,14,10,22],
        2024: [10,26,11,3],
        2025: [10,18,10,26],
        2026: [10,17,10,25],
        2027: [10,16,10,24],
        2028: [10,21,10,29],
        2029: [10,20,10,28],
      },
    ]
  },
  "NO": {
    "_state_code": "no",
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,15,2,23],
        2021: [2,20,2,28],
        2022: [2,19,2,27],
        2023: [2,25,3,5],
        2024: [2,17,2,25],
        2025: [2,15,2,23],
        2026: [2,21,3,1],
        2027: [2,20,2,28],
        2028: [2,19,2,27],
        2029: [2,17,2,25],
        2030: [2,16,2,24],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,16,8,28],
        2023: [7,22,9,3],
        2024: [7,20,9,1],
        2025: [7,12,8,24],
        2026: [7,4,8,16],
        2027: [7,10,8,22],
        2028: [7,15,8,27],
        2029: [7,21,9,2],
        2030: [7,20,9,1],
      },
      {
        name: "Herfstvakantie",
        2020: [10,10,10,18],
        2021: [10,16,10,24],
        2022: [10,15,10,23],
        2023: [10,21,10,29],
        2024: [10,26,11,3],
        2025: [10,18,10,26],
        2026: [10,10,10,18],
        2027: [10,16,10,24],
        2028: [10,14,10,22],
        2029: [10,20,10,28],
      },
    ]
  },
  "ZU": {
    "_state_code": "zu",
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [2,22,3,2],
        2026: [2,14,2,22],
        2027: [2,13,3,21],
        2028: [2,26,3,5],
        2029: [2,10,3,18],
        2030: [2,23,3,3],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,11,8,23],
        2021: [7,24,9,5],
        2022: [7,23,9,4],
        2023: [7,15,8,27],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,11,8,23],
        2027: [7,24,9,5],
        2028: [7,22,9,3],
        2029: [7,14,8,26],
        2030: [7,6,8,18],
      },
      {
        name: "Herfstvakantie",
        2020: [10,17,10,25],
        2021: [10,23,10,31],
        2022: [10,22,10,30],
        2023: [10,14,10,22],
        2024: [10,19,10,27],
        2025: [10,11,10,19],
        2026: [10,17,10,25],
        2027: [10,23,10,31],
        2028: [10,21,10,29],
        2029: [10,13,10,21],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const no = {
  PH: [{"name":"Første nyttårsdag","fixed_date":[1,1]},{"name":"Skjærtorsdag","variable_date":"easter","offset":-3},{"name":"Langfredag","variable_date":"easter","offset":-2},{"name":"Første påskedag","variable_date":"easter"},{"name":"Andre påskedag","variable_date":"easter","offset":1},{"name":"Arbeidernes dag","fixed_date":[5,1]},{"name":"Kristi himmelfartsdag","variable_date":"easter","offset":39},{"name":"Grunnlovsdagen","fixed_date":[5,17]},{"name":"Første pinsedag","variable_date":"easter","offset":49},{"name":"Andre pinsedag","variable_date":"easter","offset":50},{"name":"Første juledag","fixed_date":[12,25]},{"name":"Andre juledag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=61.0&lon=8.0&zoom=8&addressdetails=1&accept-language=no,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const nz = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Day after New Year's Day","fixed_date":[1,2],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Waitangi Day","fixed_date":[2,6],"substitute_rule":"if saturday,sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25],"substitute_rule":"if saturday,sunday then next monday"},{"name":"King's Birthday","variable_date":"firstJuneMonday"},{"name":"Matariki","fixed_date":[6,25],"year":2027},{"name":"Matariki","fixed_date":[7,6],"year":2029},{"name":"Matariki","fixed_date":[7,10],"year":2026},{"name":"Matariki","fixed_date":[7,14],"year":2028},{"name":"Labour Day","variable_date":"firstOctoberMonday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if saturday then next monday if sunday then next tuesday"},{"name":"Boxing Day","fixed_date":[12,26],"substitute_rule":"if saturday then next monday if sunday then next tuesday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-41.2922255&lon=174.7763033&zoom=16&addressdetails=1&accept-language=en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const pl = {
  PH: [{"name":"Nowy Rok","fixed_date":[1,1]},{"name":"Święto Trzech Króli","fixed_date":[1,6]},{"name":"pierwszy dzień Wielkiej Nocy","variable_date":"easter"},{"name":"drugi dzień Wielkiej Nocy","variable_date":"easter","offset":1},{"name":"Święto Państwowe","fixed_date":[5,1]},{"name":"Święto Narodowe Trzeciego Maja","fixed_date":[5,3]},{"name":"pierwszy dzień Zielonych Świątek","variable_date":"easter","offset":49},{"name":"dzień Bożego Ciała","variable_date":"easter","offset":60},{"name":"Wniebowzięcie Najświętszej Marii Panny","fixed_date":[8,15]},{"name":"Wszystkich Świętych","fixed_date":[11,1]},{"name":"Narodowe Święto Niepodległości","fixed_date":[11,11]},{"name":"Wigilia Bożego Narodzenia","fixed_date":[12,24]},{"name":"pierwszy dzień Bożego Narodzenia","fixed_date":[12,25]},{"name":"drugi dzień Bożego Narodzenia","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=53.4825&lon=18.75823&zoom=18&addressdetails=1&accept-language=pl,en",
  "Dolnośląskie": {
    "_state_code": "ds",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Kujawsko-pomorskie": {
    "_state_code": "kp",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Łódzkie": {
    "_state_code": "ld",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Lubelskie": {
    "_state_code": "lb",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Lubuskie": {
    "_state_code": "lu",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,16,3,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Małopolskie": {
    "_state_code": "ma",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Mazowieckie": {
    "_state_code": "mz",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Opolskie": {
    "_state_code": "op",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Podkarpackie": {
    "_state_code": "pd",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Podlaskie": {
    "_state_code": "pk",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,20,2,2],
        2021: [1,4,1,17],
        2022: [1,24,2,6],
        2023: [1,23,2,5],
        2024: [1,22,2,4],
        2025: [1,27,2,9],
        2026: [1,19,2,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Pomorskie": {
    "_state_code": "pm",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Śląskie": {
    "_state_code": "sk",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Świętokrzyskie": {
    "_state_code": "sl",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Warmińsko-mazurskie": {
    "_state_code": "wn",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,20,2,2],
        2021: [1,4,1,17],
        2022: [1,24,2,6],
        2023: [1,23,2,5],
        2024: [1,22,2,4],
        2025: [1,27,2,9],
        2026: [1,19,2,1],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Wielkopolskie": {
    "_state_code": "wp",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,16,3,1],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Zachodniopomorskie": {
    "_state_code": "zp",
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const pm = {
  PH: [{"name":"Nouvel An","fixed_date":[1,1]},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Fête du travail","fixed_date":[5,1]},{"name":"Fête de la Victoire 1945","fixed_date":[5,8]},{"name":"Ascension","variable_date":"easter","offset":39},{"name":"Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Fête Nationale de la France","fixed_date":[7,14]},{"name":"Assomption","fixed_date":[8,15]},{"name":"Toussaint","fixed_date":[11,1]},{"name":"Armistice 1918","fixed_date":[11,11]},{"name":"Noël","fixed_date":[12,25]}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const pt = {
  PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Sexta-Feira Santa","variable_date":"easter","offset":-2},{"name":"Páscoa","variable_date":"easter"},{"name":"Dia da Liberdade","fixed_date":[4,25]},{"name":"Dia do trabalhador","fixed_date":[5,1]},{"name":"Corpo de Deus","variable_date":"easter","offset":60},{"name":"Dia de Portugal","fixed_date":[6,10]},{"name":"Assunção de Maria","fixed_date":[8,15]},{"name":"Implantação da República","fixed_date":[10,5]},{"name":"Todos os santos","fixed_date":[11,1]},{"name":"Restauração da Independência","fixed_date":[12,1]},{"name":"Imaculada Conceição","fixed_date":[12,8]},{"name":"Natal","fixed_date":[12,25]}],
  SH: [
    {
      name: "Férias de Natal",
      2019: [12,18,1,3],
      2020: [12,21,12,31],
      2021: [12,20,1,7],
      2022: [12,19,1,2],
      2023: [12,18,1,2],
      2024: [12,18,1,3],
      2025: [12,16,1,5],
      2026: [12,16,12,31],
      2027: [12,20,12,31],
    },
    {
      name: "Férias de Carnaval",
      2020: [2,24,2,26],
      2022: [3,1,3,1],
      2023: [2,20,2,22],
      2024: [2,12,2,14],
      2025: [3,3,3,5],
      2026: [2,16,2,18],
      2027: [2,8,2,10],
      2028: [2,28,3,1],
    },
    {
      name: "Férias de Páscoa",
      2020: [3,30,4,13],
      2021: [3,29,4,1],
      2022: [4,11,4,18],
      2023: [4,3,4,14],
      2024: [3,25,4,5],
      2025: [4,7,4,21],
      2026: [3,30,4,10],
      2027: [3,22,4,2],
      2028: [4,3,4,17],
    },
    {
      name: "Férias de verão",
      2020: [6,20,9,13],
      2021: [7,9,9,13],
      2022: [7,1,9,12],
      2023: [7,1,9,11],
      2024: [6,29,9,11],
      2025: [6,28,9,10],
      2026: [7,1,9,10],
      2027: [7,1,9,12],
    },
    {
      name: "Fim das aulas",
      2028: [6,30,6,30],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.7223&lon=-9.1393&zoom=18&addressdetails=1&accept-language=pt,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ro = {
  PH: [{"name":"Anul nou","fixed_date":[1,1]},{"name":"Anul nou","fixed_date":[1,2]},{"name":"Bobotează","fixed_date":[1,6]},{"name":"Sfântul Ioan Botezătorul","fixed_date":[1,7]},{"name":"Ziua Unirii Principatelor Române","fixed_date":[1,24]},{"name":"Vinerea Mare","variable_date":"orthodox easter","offset":-2},{"name":"Paștele","variable_date":"orthodox easter"},{"name":"A doua zi de Paști","variable_date":"orthodox easter","offset":1},{"name":"Rusaliile","variable_date":"orthodox easter","offset":49},{"name":"A doua zi de Rusalii","variable_date":"orthodox easter","offset":50},{"name":"Ziua muncii","fixed_date":[5,1]},{"name":"Ziua Copilului","fixed_date":[6,1]},{"name":"Adormirea Maicii Domnului","fixed_date":[8,15]},{"name":"Sfântul Andrei","fixed_date":[11,30]},{"name":"Ziua națională, Ziua Marii Uniri","fixed_date":[12,1]},{"name":"Crăciunul","fixed_date":[12,25]},{"name":"A doua zi de Crăciun","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vacanța de iarnă",
      2014: [12,20,1,4],
      2015: [12,19,1,3],
    },
    {
      name: "Vacanţa intersemestrială",
      2015: [1,31,2,8],
      2016: [1,30,2,7],
      2021: [1,30,2,7],
    },
    {
      name: "Vacanța de primăvară",
      2015: [4,11,4,19],
      2016: [4,23,5,3],
    },
    {
      name: "Vacanța de vară",
      2015: [6,20,9,13],
      2016: [6,18,9,4],
    },
    {
      name: "Vacanţa de iarnă",
      2019: [12,21,1,12],
      2020: [12,23,1,10],
      2021: [12,24,1,9],
      2022: [12,23,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,7],
      2025: [12,20,1,7],
    },
    {
      name: "Vacanţa de primăvară",
      2020: [4,4,4,21],
      2022: [4,15,5,1],
      2023: [4,7,4,18],
      2024: [4,27,5,7],
      2025: [4,18,4,27],
      2026: [4,4,4,14],
    },
    {
      name: "Vacanţa de vară",
      2020: [6,13,9,13],
      2021: [6,19,9,12],
      2022: [6,11,9,4],
      2023: [6,17,9,3],
      2024: [6,22,9,8],
      2025: [6,21,9,7],
      2026: [6,20,9,6],
    },
    {
      name: "Vacanţa de toamnă",
      2020: [10,24,11,1],
      2021: [10,23,11,7],
      2022: [10,22,10,30],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [10,25,11,1],
    },
    {
      name: "Vacanţa de primăvară 1",
      2021: [4,2,4,11],
    },
    {
      name: "Vacanţa de primăvară 2",
      2021: [4,30,5,9],
    },
    {
      name: "Vacanţa de schi",
      2024: [2,12,2,18],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=45.9852129&lon=24.6859225&zoom=18&addressdetails=1&accept-language=ro,en",
  "Alba": {
    "_state_code": "ab",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Arad": {
    "_state_code": "ar",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Argeș": {
    "_state_code": "ag",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Bacău": {
    "_state_code": "bc",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Bihor": {
    "_state_code": "bh",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Bistrița-Năsăud": {
    "_state_code": "bn",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,12,2,18],
        2025: [2,10,2,14],
        2026: [2,9,2,13],
      },
    ]
  },
  "Botoșani": {
    "_state_code": "bt",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Brăila": {
    "_state_code": "br",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Brașov": {
    "_state_code": "bv",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "București": {
    "_state_code": "bu",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Buzău": {
    "_state_code": "bz",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Călărași": {
    "_state_code": "cl",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Caraș-Severin": {
    "_state_code": "cs",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Cluj": {
    "_state_code": "cj",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,9,2,13],
      },
    ]
  },
  "Constanța": {
    "_state_code": "ct",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Covasna": {
    "_state_code": "cv",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Dâmbovița": {
    "_state_code": "db",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Dolj": {
    "_state_code": "dj",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Galați": {
    "_state_code": "gl",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Giurgiu": {
    "_state_code": "gr",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Gorj": {
    "_state_code": "gj",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Harghita": {
    "_state_code": "hr",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Hunedoara": {
    "_state_code": "hd",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Ialomița": {
    "_state_code": "il",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Iași": {
    "_state_code": "is",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Ilfov": {
    "_state_code": "if",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,6,2,12],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Maramureș": {
    "_state_code": "mm",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Mehedinți": {
    "_state_code": "mh",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Mureș": {
    "_state_code": "ms",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Neamț": {
    "_state_code": "nt",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Olt": {
    "_state_code": "ot",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Prahova": {
    "_state_code": "ph",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Sălaj": {
    "_state_code": "sj",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Satu Mare": {
    "_state_code": "sm",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,12,2,18],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Sibiu": {
    "_state_code": "sb",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Suceava": {
    "_state_code": "sv",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,6,2,12],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Teleorman": {
    "_state_code": "tr",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Timiș": {
    "_state_code": "tm",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,9,2,13],
      },
    ]
  },
  "Tulcea": {
    "_state_code": "tl",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Vâlcea": {
    "_state_code": "vl",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Vaslui": {
    "_state_code": "vs",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Vrancea": {
    "_state_code": "vn",
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const rs = {
  PH: [{"name":"Нова година","fixed_date":[1,1],"shift_rule":"if sunday then next tuesday"},{"name":"Нова година","fixed_date":[1,2],"shift_rule":"if sunday then next monday"},{"name":"Дан државности Србије","fixed_date":[2,15],"shift_rule":"if sunday then next tuesday"},{"name":"Дан државности Србије","fixed_date":[2,16],"shift_rule":"if sunday then next monday"},{"name":"Велики петак","variable_date":"orthodox easter","offset":-2},{"name":"Васкрс","variable_date":"orthodox easter"},{"name":"Васкрсни понедељак","variable_date":"orthodox easter","offset":1},{"name":"Празник рада","fixed_date":[5,1],"shift_rule":"if sunday then next tuesday"},{"name":"Празник рада","fixed_date":[5,2],"shift_rule":"if sunday then next monday"},{"name":"Дан примирја","fixed_date":[11,11],"shift_rule":"if sunday then next monday"}],
  SH: [
    {
      name: "Зимски распуст",
      2019: [12,30,1,7],
      2020: [12,31,1,8],
      2021: [12,31,1,21],
      2022: [1,4,1,21],
      2023: [1,3,1,20],
      2024: [12,30,1,17],
      2025: [12,31,1,16],
    },
    {
      name: "Пролећни распуст",
      2020: [4,15,4,20],
      2021: [4,30,5,7],
      2022: [4,22,5,3],
      2023: [4,11,4,18],
      2024: [4,29,5,6],
      2025: [4,16,4,21],
      2026: [4,10,4,14],
    },
    {
      name: "Летњи распуст",
      2020: [6,22,8,31],
      2021: [6,23,8,31],
      2022: [6,22,8,31],
      2023: [6,21,8,31],
      2024: [6,24,8,30],
      2025: [6,23,8,29],
      2026: [6,22,8,31],
    },
    {
      name: "Јесењи распуст",
      2020: [11,11,11,13],
      2021: [11,12,11,12],
      2023: [11,8,11,10],
      2024: [11,11,11,12],
      2025: [11,10,11,11],
    },
    {
      name: "Сретењски распуст",
      2026: [2,16,2,20],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=44.8176&lon=20.4569&zoom=18&addressdetails=1&accept-language=sr,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ru = {
  PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8],"substitute_rule":"if sunday then next monday"},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.7780&lon=49.1303&zoom=18&addressdetails=1&accept-language=ru,en",
  "Адыгея": {
    "_state_code": "adygea",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=44.60627&lon=40.10432&zoom=18&addressdetails=1&accept-language=ru,us",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День образования Республики Адыгея","fixed_date":[10,5]}]
  },
  "Башкортостан": {
    "_state_code": "bashkortostan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=54.1264&lon=56.5797&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День Республики Башкирии","fixed_date":[10,11]},{"name":"День Конституции Башкортостана","fixed_date":[12,24]}]
  },
  "Брянская область": {
    "_state_code": "bryansk",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.952&lon=33.283&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Радоница","fixed_date":[4,29]},{"name":"День освобождения города Брянска","fixed_date":[9,17]}]
  },
  "Дагестан": {
    "_state_code": "dagestan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.118&lon=46.959&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Конституции Республики Дагестан","fixed_date":[7,26]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День единства народов Дагестана","fixed_date":[9,15]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Ингушетия": {
    "_state_code": "ingushetia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.1171&lon=44.8626&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День образования Республики Ингушетия","fixed_date":[6,4]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Кабардино-Балкария": {
    "_state_code": "kabardino_balkaria",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.497&lon=43.423&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День возрождения балкарского народа","fixed_date":[3,28]},{"name":"Черкесский день траура","fixed_date":[5,21]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День государственности Кабардино-Балкарской Республики","fixed_date":[9,1]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Калмыкия": {
    "_state_code": "kalmykia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.524&lon=44.731&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Цаган Сар","fixed_date":[1,14]},{"name":"День принятия Степного Уложения (Конституции) Республики Калмыкия","fixed_date":[4,5]},{"name":"День рождения Будды Шакьямун","fixed_date":[6,6]},{"name":"Зул","fixed_date":[12,15]},{"name":"День памяти жертв депортации калмыцкого народа","fixed_date":[12,28]}]
  },
  "Карачаево-Черкесия": {
    "_state_code": "karachay_cherkess",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.7916&lon=41.7268&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День возрождения карачаевского народа","fixed_date":[5,3]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Приволжский федеральный округ": {
    "_state_code": "udmurtia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=56.8642&lon=53.2054&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Государственности Удмуртской Республики","fixed_date":[5,31]}]
  },
  "Республика Алтай": {
    "_state_code": "altai",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=50.900&lon=86.899&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Чага-Байрам","fixed_date":[1,14]}]
  },
  "Республика Бурятия": {
    "_state_code": "buryatia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.014&lon=109.366&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Сагаалган","fixed_date":[1,14]}]
  },
  "Республика Карелия": {
    "_state_code": "karelia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.832&lon=33.626&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Карелия","fixed_date":[6,8]},{"name":"День освобождения Карелии от фашистских захватчиков","fixed_date":[9,30]}]
  },
  "Республика Коми": {
    "_state_code": "komi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=64.191&lon=55.826&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Коми","fixed_date":[8,22]}]
  },
  "Республика Саха (Якутия)": {
    "_state_code": "sakha",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=62.1010&lon=129.7176&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Саха","fixed_date":[4,27]},{"name":"Ысыах","fixed_date":[6,23]},{"name":"День государственности Республики Саха","fixed_date":[9,27]}]
  },
  "Республика Тыва": {
    "_state_code": "tuva",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.781&lon=94.033&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Народный праздник Шагаа","fixed_date":[1,14]},{"name":"День Республики Тыва","fixed_date":[8,15]}]
  },
  "Саратовская область": {
    "_state_code": "saratov",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.335&lon=46.668&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Радоница","fixed_date":[4,29]}]
  },
  "Татарстан": {
    "_state_code": "tatarstan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.7780&lon=49.1303&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День Республики Татарстан","fixed_date":[8,30]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День Конституции Республики Татарстан","fixed_date":[11,6]}]
  },
  "Чечня": {
    "_state_code": "chechnya",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.451&lon=45.700&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День мира в Чеченской Республике","fixed_date":[4,16]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Чувашия": {
    "_state_code": "chuvashia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.4871&lon=47.1659&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Чувашской республики","fixed_date":[6,24]}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const se = {
  PH: [{"name":"nyårsdagen","fixed_date":[1,1]},{"name":"trettondedag jul","fixed_date":[1,6]},{"name":"långfredagen","variable_date":"easter","offset":-2},{"name":"påskdagen","variable_date":"easter"},{"name":"annandag påsk","variable_date":"easter","offset":1},{"name":"första maj","fixed_date":[5,1]},{"name":"Kristi himmelsfärdsdag","variable_date":"easter","offset":39},{"name":"pingstdagen","variable_date":"easter","offset":49},{"name":"nationaldagen","fixed_date":[6,6]},{"name":"midsommardagen","variable_date":"nextSaturday20Jun"},{"name":"alla helgons dag","variable_date":"nextSaturday31Oct"},{"name":"juldagen","fixed_date":[12,25]},{"name":"annandag jul","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.1151&lon=16.5767&zoom=18&addressdetails=1&accept-language=sv,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const si = {
  PH: [{"name":"novo leto","fixed_date":[1,1]},{"name":"novo leto","fixed_date":[1,2]},{"name":"Prešernov dan, slovenski kulturni praznik","fixed_date":[2,8]},{"name":"velikonočna nedelja","variable_date":"easter"},{"name":"velikonočni ponedeljek","variable_date":"easter","offset":1},{"name":"dan upora proti okupatorju","fixed_date":[4,27]},{"name":"praznik dela 1","fixed_date":[5,1]},{"name":"praznik dela 2","fixed_date":[5,2]},{"name":"binkoštna nedelja - binkošti","variable_date":"easter","offset":49},{"name":"dan državnosti","fixed_date":[6,25]},{"name":"Marijino vnebovzetje","fixed_date":[8,15]},{"name":"dan reformacije","fixed_date":[10,31]},{"name":"dan spomina na mrtve","fixed_date":[11,1]},{"name":"božič","fixed_date":[12,25]},{"name":"dan samostojnosti in enotnosti","fixed_date":[12,26]}],
  SH: [
    {
      name: "Novoletne počitnice",
      2019: [12,25,1,2],
      2020: [12,28,12,31],
      2021: [12,27,12,31],
      2022: [12,27,12,30],
      2023: [12,27,1,2],
      2024: [12,27,1,2],
      2025: [12,29,12,31],
    },
    {
      name: "Prvomajske počitnice",
      2020: [4,27,5,1],
      2021: [4,28,4,30],
      2022: [4,28,4,29],
      2023: [4,28,4,28],
      2024: [4,28,5,2],
      2025: [4,28,5,2],
      2026: [4,28,4,30],
    },
    {
      name: "Poletne počitnice",
      2020: [6,26,8,31],
      2021: [6,26,8,31],
      2022: [6,26,8,31],
      2023: [6,26,8,31],
      2024: [6,26,8,31],
      2025: [6,26,8,31],
      2026: [6,26,8,31],
    },
    {
      name: "Jesenske počitnice",
      2020: [10,26,10,30],
      2021: [10,25,11,1],
      2022: [10,31,11,4],
      2023: [10,30,11,1],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
    },
    {
      name: "Pouka prost dan",
      2024: [5,3,5,3],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.0569&lon=14.5058&zoom=18&addressdetails=1&accept-language=sl,en",
  "vzhodne regije": {
    "_state_code": "vr",
    SH: [
      {
        name: "Zimske počitnice",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [1,30,2,3],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "zahodne regije": {
    "_state_code": "zr",
    SH: [
      {
        name: "Zimske počitnice",
        2020: [2,17,2,21],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [2,6,2,10],
        2024: [2,19,2,23],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const sj = {
  PH: [{"name":"Første nyttårsdag","fixed_date":[1,1]},{"name":"Skjærtorsdag","variable_date":"easter","offset":-3},{"name":"Langfredag","variable_date":"easter","offset":-2},{"name":"Første påskedag","variable_date":"easter"},{"name":"Andre påskedag","variable_date":"easter","offset":1},{"name":"Arbeidernes dag","fixed_date":[5,1]},{"name":"Grunnlovsdagen","fixed_date":[5,17]},{"name":"Kristi himmelfartsdag","variable_date":"easter","offset":39},{"name":"Første pinsedag","variable_date":"easter","offset":49},{"name":"Andre pinsedag","variable_date":"easter","offset":50},{"name":"Første juledag","fixed_date":[12,25]},{"name":"Andre juledag","fixed_date":[12,26]}]
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const sk = {
  PH: [{"name":"Deň vzniku Slovenskej republiky","fixed_date":[1,1]},{"name":"Zjavenie Pána","fixed_date":[1,6]},{"name":"Veľký piatok","variable_date":"easter","offset":-2},{"name":"Veľkonočný pondelok","variable_date":"easter","offset":1},{"name":"Sviatok práce","fixed_date":[5,1]},{"name":"Sviatok svätého Cyrila a Metoda","fixed_date":[7,5]},{"name":"Výročie Slovenského národného povstania","fixed_date":[8,29]},{"name":"Sviatok všetkých svätých","fixed_date":[11,1]},{"name":"Štedrý deň","fixed_date":[12,24]},{"name":"Prvý sviatok vianočný","fixed_date":[12,25]},{"name":"Druhý sviatok vianočný","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=48.7411522&lon=19.4528646&zoom=18&addressdetails=1&accept-language=sk,en",
  "Banskobystrický kraj": {
    "_state_code": "bc",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Bratislavský kraj": {
    "_state_code": "bl",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Košický kraj": {
    "_state_code": "ki",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [3,2,3,6],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [3,6,3,10],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [3,2,3,6],
        2027: [2,22,2,26],
        2028: [2,21,2,25],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Nitriansky kraj": {
    "_state_code": "ni",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Prešovský kraj": {
    "_state_code": "pv",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [3,2,3,6],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [3,6,3,10],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [3,2,3,6],
        2027: [2,22,2,26],
        2028: [2,21,2,25],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Trenčiansky kraj": {
    "_state_code": "tc",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Trnavský kraj": {
    "_state_code": "ta",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Žilinský kraj": {
    "_state_code": "zi",
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const sm = {
  PH: [{"name":"Capodanno","fixed_date":[1,1]},{"name":"Epifania","fixed_date":[1,6]},{"name":"Festa di Sant’Agata","fixed_date":[2,5]},{"name":"Anniversario dell'Arengo","fixed_date":[3,25]},{"name":"Domenica di Pasqua","variable_date":"easter"},{"name":"Lunedì dell’Angelo","variable_date":"easter","offset":1},{"name":"Cerimonia di investitura dei Capitani Reggenti","fixed_date":[4,1]},{"name":"Festa del lavoro","fixed_date":[5,1]},{"name":"Corpus Domini","variable_date":"easter","offset":60},{"name":"Anniversario della caduta del Fascismo e Festa della Libertà","fixed_date":[7,28]},{"name":"Assunzione di Maria","fixed_date":[8,15]},{"name":"Festa di San Marino e di Fondazione della Repubblica","fixed_date":[9,3]},{"name":"Cerimonia di investitura dei Capitani Reggenti","fixed_date":[10,1]},{"name":"Tutti i Santi","fixed_date":[11,1]},{"name":"Commemorazione dei defunti","fixed_date":[11,2]},{"name":"Immacolata Concezione","fixed_date":[12,8]},{"name":"Natale di Gesù","fixed_date":[12,25]},{"name":"Santo Stefano","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vacanze Natalizie",
      2019: [12,24,1,4],
      2020: [12,24,1,5],
      2021: [12,24,1,5],
      2022: [12,24,1,7],
      2023: [12,24,1,5],
      2024: [12,23,1,5],
      2025: [12,24,1,5],
    },
    {
      name: "Vacanze Pasquali",
      2020: [4,9,4,14],
      2021: [4,2,4,6],
      2022: [4,14,4,19],
      2023: [4,3,4,10],
      2024: [3,26,4,1],
      2025: [4,17,4,22],
      2026: [4,2,4,7],
    },
    {
      name: "Vacanze Estive",
      2020: [6,11,9,6],
      2021: [6,12,9,12],
      2022: [6,12,9,14],
      2023: [6,8,9,17],
      2024: [6,8,9,17],
      2025: [6,11,9,14],
    },
    {
      name: "Termine lezioni",
      2026: [6,17,6,17],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.9424&lon=12.4578&zoom=18&addressdetails=1&accept-language=it,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const ua = {
  PH: [{"name":"Новий Рік","fixed_date":[1,1],"substitute_rule":"if saturday, sunday then next tuesday"},{"name":"Новий Рік","fixed_date":[1,2],"substitute_rule":"if saturday, sunday then next monday"},{"name":"Міжнародний жіночий день","fixed_date":[3,8],"substitute_rule":"if saturday, sunday then next monday"},{"name":"Великдень","variable_date":"orthodox easter"},{"name":"Трійця","variable_date":"orthodox easter","offset":49},{"name":"День міжнародної солідарності трудящих","fixed_date":[5,1],"substitute_rule":"if saturday, sunday then next tuesday"},{"name":"День перемоги над нацизмом у Другій світовій війні","fixed_date":[5,9],"substitute_rule":"if saturday, sunday then next monday"},{"name":"День Конституції","fixed_date":[6,28],"substitute_rule":"if saturday, sunday then next monday"},{"name":"День Української Державності","fixed_date":[7,15],"substitute_rule":"if saturday, sunday then next monday"},{"name":"День Незалежності","fixed_date":[8,24],"substitute_rule":"if saturday, sunday then next monday"},{"name":"День захисників і захисниць України","fixed_date":[10,1],"substitute_rule":"if saturday, sunday then next monday"},{"name":"Різдво Христове","fixed_date":[12,25],"substitute_rule":"if saturday, sunday then next monday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=50.4501&lon=30.5234&zoom=18&addressdetails=1&accept-language=uk,en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const us = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&zoom=18&addressdetails=1&limit=1&accept-language=en",
  "Alabama": {
    "_state_code": "al",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Alabama&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Confederate Memorial Day","variable_date":"firstAprilMonday","offset":21},{"name":"Jefferson Davis' birthday","variable_date":"firstJuneMonday"}]
  },
  "Alaska": {
    "_state_code": "ak",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Alaska&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Seward's Day","variable_date":"lastMarchMonday"},{"name":"Alaska Day","fixed_date":[10,18]}]
  },
  "American Samoa": {
    "_state_code": "as",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=American+Samoa&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"American Samoa Flag Day","fixed_date":[4,17],"substitute_rule":"if sunday then next monday"}]
  },
  "Arizona": {
    "_state_code": "az",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Arizona&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Arkansas": {
    "_state_code": "ar",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Arkansas&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Christmas Eve","fixed_date":[12,24]}]
  },
  "California": {
    "_state_code": "ca",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=California&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"César Chávez Day","fixed_date":[3,31],"substitute_rule":"if sunday then next monday"}]
  },
  "Colorado": {
    "_state_code": "co",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Colorado&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Frances Xavier Cabrini Day","variable_date":"firstOctoberMonday"}]
  },
  "Connecticut": {
    "_state_code": "ct",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Connecticut&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Delaware": {
    "_state_code": "de",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Delaware&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "District of Columbia": {
    "_state_code": "dc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=District+of+Columbia&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Emancipation Day","fixed_date":[4,16]}]
  },
  "Florida": {
    "_state_code": "fl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Florida&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Susan B. Anthony Day","fixed_date":[2,15]},{"name":"Commemoration of America's 250th Birthday","fixed_date":[2,16],"year":2026}]
  },
  "Georgia": {
    "_state_code": "ga",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Georgia&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"State Holiday","variable_date":"lastAprilMonday"},{"name":"Washington's Birthday","fixed_date":[12,24],"substitute_rule":"if wednesday then next friday"}]
  },
  "Guam": {
    "_state_code": "gu",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Guam&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Guam History and Chamorro Heritage Day","variable_date":"firstMarchMonday"},{"name":"Liberation Day","fixed_date":[7,21],"shift_rule":"if sunday then next monday"},{"name":"All Souls' Day","fixed_date":[11,2]},{"name":"Our Lady of Camarin Day","fixed_date":[12,8],"shift_rule":"if sunday then next monday"}]
  },
  "Hawaii": {
    "_state_code": "hi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Hawaii&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Prince Jonah Kuhio Kalanianaole Day","fixed_date":[3,26],"substitute_rule":"if saturday then previous friday if sunday then next monday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Kamehameha Day","fixed_date":[6,11],"substitute_rule":"if saturday then previous friday if sunday then next monday"},{"name":"Statehood Day","variable_date":"firstAugustFriday","offset":14}]
  },
  "Idaho": {
    "_state_code": "id",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Idaho&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Illinois": {
    "_state_code": "il",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Illinois&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Casimir Pulaski Day","variable_date":"firstMarchMonday"},{"name":"Malcolm X Day","fixed_date":[5,19]}]
  },
  "Indiana": {
    "_state_code": "in",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Indiana&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Iowa": {
    "_state_code": "ia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Iowa&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]}]
  },
  "Kansas": {
    "_state_code": "ks",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Kansas&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Kentucky": {
    "_state_code": "ky",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Kentucky&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Louisiana": {
    "_state_code": "la",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Louisiana&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Mardi Gras","variable_date":"easter","offset":-47},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Maine": {
    "_state_code": "me",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Maine&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Patriots' Day","variable_date":"firstAprilMonday","offset":14}]
  },
  "Maryland": {
    "_state_code": "md",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Maryland&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Massachusetts": {
    "_state_code": "ma",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Massachusetts&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Evacuation Day","fixed_date":[3,17]},{"name":"Patriots' Day","variable_date":"firstAprilMonday","offset":14},{"name":"Bunker Hill Day","fixed_date":[6,17]}]
  },
  "Michigan": {
    "_state_code": "mi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Michigan&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Minnesota": {
    "_state_code": "mn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Minnesota&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Mississippi": {
    "_state_code": "ms",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Mississippi&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Confederate Memorial Day","variable_date":"lastAprilMonday"}]
  },
  "Missouri": {
    "_state_code": "mo",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Missouri&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Truman Day","fixed_date":[5,8]}]
  },
  "Montana": {
    "_state_code": "mt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Montana&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Nebraska": {
    "_state_code": "ne",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Nebraska&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Arbor Day","variable_date":"lastAprilFriday"}]
  },
  "Nevada": {
    "_state_code": "nv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Nevada&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Nevada Day","variable_date":"lastOctoberFriday"}]
  },
  "New Hampshire": {
    "_state_code": "nh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=New+Hampshire&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "New Jersey": {
    "_state_code": "nj",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=New+Jersey&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "New Mexico": {
    "_state_code": "nm",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=New+Mexico&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "New York": {
    "_state_code": "ny",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=New+York&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Susan B. Anthony Day","fixed_date":[2,15]}]
  },
  "North Carolina": {
    "_state_code": "nc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=North+Carolina&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Christmas Eve","fixed_date":[12,24],"substitute_rule":"if friday then previous thursday if saturday,sunday then previous friday"}]
  },
  "North Dakota": {
    "_state_code": "nd",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=North+Dakota&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Ohio": {
    "_state_code": "oh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Ohio&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Oklahoma": {
    "_state_code": "ok",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Oklahoma&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Oregon": {
    "_state_code": "or",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Oregon&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Pennsylvania": {
    "_state_code": "pa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Pennsylvania&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Flag Day","fixed_date":[6,14]}]
  },
  "Puerto Rico": {
    "_state_code": "pr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Puerto+Rico&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Día de los Reyes Magos","fixed_date":[1,6]},{"name":"Natalicio de Eugenio María de Hostos","variable_date":"firstJanuaryMonday","offset":7},{"name":"Natalicio de Luis Muñoz Marín","fixed_date":[2,18]},{"name":"Día de la Ciudadanía Americana","fixed_date":[3,2]},{"name":"Día de la Abolición de Esclavitud","fixed_date":[3,22]},{"name":"Natalicio de José de Diego","fixed_date":[4,16]},{"name":"Natalicio de Don Luis Muñoz Rivera","variable_date":"firstJulyMonday","offset":14},{"name":"Constitución de Puerto Rico","fixed_date":[7,25]},{"name":"Natalicio de Dr. José Celso Barbosa","fixed_date":[7,27]},{"name":"Día del Descubrimiento de Puerto Rico","fixed_date":[11,19]}]
  },
  "Rhode Island": {
    "_state_code": "ri",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Rhode+Island&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Victory Day","variable_date":"firstAugustMonday","offset":7}]
  },
  "South Carolina": {
    "_state_code": "sc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=South+Carolina&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Confederate Memorial Day","fixed_date":[5,10]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "South Dakota": {
    "_state_code": "sd",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=South+Dakota&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Tennessee": {
    "_state_code": "tn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Tennessee&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Christmas Eve","fixed_date":[12,24]}]
  },
  "Texas": {
    "_state_code": "tx",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Texas&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Day after Christmas","fixed_date":[12,26]}]
  },
  "United States Virgin Islands": {
    "_state_code": "vi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=United+States+Virgin+Islands&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Three Kings Day","fixed_date":[1,6]},{"name":"Transfer Day","fixed_date":[3,31]},{"name":"Maundy Thursday","variable_date":"easter","offset":-3},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Emancipation Day","fixed_date":[7,3]},{"name":"Hurricane Supplication Day","variable_date":"firstJulyMonday","offset":21}]
  },
  "Utah": {
    "_state_code": "ut",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Utah&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Pioneer Day","fixed_date":[7,24]}]
  },
  "Vermont": {
    "_state_code": "vt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Vermont&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Town Meeting Day","variable_date":"firstMarchTuesday"},{"name":"Bennington Battle Day","variable_date":"firstAugustMonday","offset":14}]
  },
  "Virginia": {
    "_state_code": "va",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Virginia&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "Washington": {
    "_state_code": "wa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Washington&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  },
  "West Virginia": {
    "_state_code": "wv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=West+Virginia&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Susan B. Anthony Day","fixed_date":[2,15]},{"name":"West Virginia Day","fixed_date":[6,20]}]
  },
  "Wisconsin": {
    "_state_code": "wi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Wisconsin&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Susan B. Anthony Day","fixed_date":[2,15]},{"name":"Primary Election Day","variable_date":"firstSeptemberTuesday","offset":7}]
  },
  "Wyoming": {
    "_state_code": "wy",
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=United+States+of+America&state=Wyoming&zoom=18&addressdetails=1&limit=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Martin Luther King Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Juneteenth","fixed_date":[6,19],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Independence Day","fixed_date":[7,4],"substitute_rule":"if sunday then next monday if saturday then previous friday"},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving Day","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25],"substitute_rule":"if sunday then next monday if saturday then previous friday"}]
  }
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const vn = {
  PH: [{"name":"Tết Dương Lịch","fixed_date":[1,1]},{"name":"Ngày Quốc tế Phụ nữ","fixed_date":[3,8]},{"name":"Ngày thành lập Đoàn Thanh niên Cộng sản Hồ Chí Minh","fixed_date":[3,26]},{"name":"Ngày Quốc tế Thiếu nhi","fixed_date":[6,1]},{"name":"Ngày Nhà giáo Việt Nam","fixed_date":[11,20]},{"name":"Ngày Giải phóng miền Nam, Thống nhất Đất nước","fixed_date":[4,30]},{"name":"Ngày Quốc tế lao động","fixed_date":[5,1]},{"name":"Quốc Khánh","fixed_date":[9,2]},{"name":"Lễ Giáng Sinh","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=10.77374&lon=106.70094&zoom=16&addressdetails=1&accept-language=en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const xa = {
  PH: [{"name":"New Year","fixed_date":[1,1]}],
  SH: [
    {
      name: "Summer",
      2020: [6,21,9,23],
      2021: [6,21,9,23],
      2022: [6,21,9,23],
      2023: [6,21,9,23],
      2024: [6,21,9,23],
      2025: [6,21,9,23],
      2026: [6,21,9,23],
      2027: [6,21,9,23],
      2028: [6,21,9,23],
      2029: [6,21,9,23],
      2030: [6,21,9,23],
      2031: [6,21,9,23],
      2032: [6,21,9,23],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=0.0&lon=0.0&zoom=18&addressdetails=1&accept-language=en"
};

/** @type {import('./holiday-definitions.d.ts').CountryHolidayDefinitions} */
export const za = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Human Rights Day","fixed_date":[3,21],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Family Day","variable_date":"easter","offset":1},{"name":"Freedom Day","fixed_date":[4,27],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Workers' Day","fixed_date":[5,1],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Youth Day","fixed_date":[6,16],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"National Women's Day","fixed_date":[8,9],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Heritage Day","fixed_date":[9,24],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Day of Reconciliation","fixed_date":[12,16],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Day of Goodwill","fixed_date":[12,26],"substitute_rule":"if sunday then next monday","substitute_name":"Public Holiday"}],
  SH: [
    {
      name: "Summer Break",
      2019: [12,7,1,12],
      2020: [12,17,1,10],
      2021: [12,11,1,9],
      2022: [12,17,1,8],
      2023: [12,16,1,14],
      2024: [12,14,1,12],
      2025: [12,13,1,11],
      2026: [12,12,1,10],
      2027: [12,11,1,9],
    },
    {
      name: "Autumn Break",
      2020: [3,19,5,31],
      2021: [3,27,4,12],
      2022: [3,18,4,4],
      2023: [3,25,4,11],
      2024: [3,22,4,2],
      2025: [3,29,4,7],
      2026: [3,28,4,7],
      2027: [3,20,4,5],
    },
    {
      name: "Winter Break",
      2020: [8,11,8,11],
      2021: [6,26,7,19],
      2022: [6,25,7,18],
      2023: [6,24,7,17],
      2024: [6,15,7,8],
      2025: [6,28,7,21],
      2026: [6,27,7,20],
      2027: [6,26,7,19],
    },
    {
      name: "Spring Break",
      2020: [9,25,10,4],
      2021: [10,2,10,11],
      2022: [10,1,10,10],
      2023: [9,30,10,9],
      2024: [9,21,9,30],
      2025: [10,4,10,12],
      2026: [10,3,10,12],
      2027: [10,2,10,10],
    },
    {
      name: "Special School Holiday",
      2021: [4,26,4,26],
      2022: [8,8,8,8],
      2023: [4,28,4,28],
      2024: [4,26,4,26],
      2025: [6,2,6,2],
      2026: [9,25,9,25],
      2027: [4,26,4,26],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-25.7462&lon=28.1881&zoom=18&addressdetails=1&accept-language=en,af"
};
